import React, { Component } from "react";
import { connect } from "react-redux";
import _, { debounce, isEqual } from "lodash";
import qs from "query-string";
import "rc-time-picker/assets/index.css";
import DatePicker from "react-datepicker";
import { withRouter } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import "react-datepicker/dist/react-datepicker.css";
import recommendationsActions from "../actions";
import projectActions from "../../project/actions";
import surveyAssetActions from "../../assetSurveyProject/actions";
import NumberFormat from "react-number-format";
import Loader from "../../common/components/Loader";
import Portal from "../../common/components/Portal";
import buildingActions from "../../building/actions";
import userActions from "../../users/actions";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import ServiceLifeChangeConfirmationModal from "../../common/components/ServiceLifeChangeConfirmationModal";
import {
    popBreadCrumpData,
    addToBreadCrumpData,
    findInfoPathFromBreadCrump,
    getUsefullLifeRemaining,
    convertToXML,
    removeAllTags,
    toArrayOfObjects,
    getCurrentAge,
    showAlert,
    normalizeToNested,
    denormalizeToFlat,
    showAlert as showAlertUtil
} from "../../../config/utils";
import ReactTooltip from "react-tooltip";
import ImageUploadModal from "../../common/components/ImagesModal";
import RepotNoteTemplateModal from "./RepotNoteTemplateModal";
import AssignAssetModal from "./AssignAssetModal";
import ChoiceModal from "../../common/components/ChoiceModal";
import RecommendationTemplateModal from "./RecommendationTemplateModal";
import history from "../../../config/history";
import assetActions from "../../assets/actions";
import dashboardActions from "../../dashboard/actions";
import { getCleanParams } from "../../../utils/filtersUtils";
import Autosuggest from "react-autosuggest";
import { defaultTheme as autosuggestDefaultTheme } from "react-autosuggest/dist/theme";
import {
    validateFirstWord,
    isFirstWordValid,
    matchVerbs,
    applyVerbToText,
    matchTemplatesByPrefix,
    getVerbToken,
    getLiveVerbError,
    isVerbValidationEnabled
} from "../../../utils/recommendationVerbs";
import AssetForm, { ASSET_FIELD_VISIBILITY_SLOT_ID } from "./AssetForm";
import { checkPermission } from "../../../config/utils";
import recomIcon from "../../../assets/img/recom-denoter.svg";
import recomIcon1 from "../../../assets/img/recom-icon.svg";
import RecommendationNoteEdit from "../../common/components/RecommendationNoteEdit";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { EnergyBand } from "./Bands/EnergyBand";
import { WaterBand } from "./Bands/WaterBand";
import { energy_fields } from "./Bands/EnergyBand";
import { water_fields } from "./Bands/WaterBand";
import { DynamicBand, DynamicBandField } from "./Bands/DynamicBand";
import { applySubsystemLinkedDynamicFields } from "../../../utils/staticDynamicFieldLinks";
import {
    DYNAMIC_FIELD_TYPES,
    LOCK_STATUS,
    RECOMMENDATION_CREATION_METHODS,
    RECOMMENDATION_SOURCE_TYPES,
    RECOMMENDATION_TYPES
} from "../../common/constants";
import { RecommendationBand } from "./Bands/RecommendationBand";
import { FormField } from "./Bands/FormField";
import { AddRemoveButton } from "./AddRemoveButton";
import SelectBox from "../../images/components/SelectBox";
import moment from "moment";
import { CkeditorConfiguration } from "../../smartCharts/CkEditorConfig";
import { MyUploadAdapterPlugin } from "../../smartCharts/CustomImageUploadPlugin";
import { CAPITAL_REQUEST_STATUS, mrAssetMapKap, mrStaticFields } from "../constants";
import MobileAction from "../../mobileRecommendation/actions";
import VoiceNotesTable from "../../assetSurveyProject/components/VoiceNotesTable";
import VideoTable from "../../mobileRecommendation/components/VideoTable";
import Draggable from "react-draggable";
import VoiceVideoPortal from "../../assetSurveyProject/components/VoiceVideoPortal";
import statusAction from "../../Status/action";
import { SiteBuildingInfoModal } from "./SiteBuildingInfoModal";
import InfoImages from "../../assetSurveyProject/components/InfoImage";
import commonActions from "../../common/actions";
import { EllipsisTooltipText } from "../../common/components/EllipsisTextWithTooltip";
import { ASSET_SOURCES } from "../../assets/constants";
import { ImageViewV2 } from "../../common/components/ImageComponents/ImageViewModalV2";
import { RecommendationChecklist } from "./Bands/Checklist";
import { sanitizeHtml } from "../../common/components/SafeHtml";
import { checkQaQcDraft } from "../../qaQc/qaQcService";
import { buildDraftPayload, isWorthChecking } from "../../qaQc/buildDraftPayload";
import ValidationModal from "../../qaQc/components/ValidationModal";
import {
    QA_VALIDATION_STATUS,
    QA_CLEAN_HOLD_MS,
    QA_NOTHING_CHECKED_HOLD_MS,
    isOttoValidationEnabled
} from "../../qaQc/validationConstants";
import { decideQaOutcome, localSkipReasons, nothingWasChecked, QA_OUTCOME } from "../../qaQc/validationOutcome";
import { permissions } from "../../../config/permissions";
import {
    formatCapitalRequestSourceValue,
    getCapitalRequestLabel,
    getCapitalRequestNarrativeLabel,
    getCapitalRequestStatusLabel,
    getCapitalRequestStatusNotesLabel
} from "../../../utils/capitalRequestLabel";
import FormContextBanner from "./FormContextBanner";
import {
    getConvertSourceCode,
    getFormContextBanner,
    resolveFormContextClientName
} from "../../../utils/recommendationFormContext";

const editorConfiguration = {
    toolbar: [
        // "fontFamily",
        // "fontSize",
        // "|",
        "bold",
        "italic",
        "underLine",
        "|",
        "alignment:left",
        "alignment:right",
        "alignment:center",
        "alignment:justify",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        // "outdent",
        // "indent",
        "highlight",
        "|",
        "undo",
        "redo"
        // "heading"
    ],
    removePlugins: ["Title", "ListStyle"],
    alignment: {
        options: ["left", "right", "center", "justify"]
    },
    highlight: {
        options: [
            { model: "yellowMarker", class: "marker-yellow", title: "Yellow marker", color: "var(--ck-highlight-marker-yellow)", type: "marker" },
            { model: "greenMarker", class: "marker-green", title: "Green marker", color: "#32CD32", type: "marker" },
            { model: "pinkMarker", class: "marker-pink", title: "Pink marker", color: "#FF00FF", type: "marker" },
            { model: "blueMarker", class: "marker-blue", title: "Blue marker", color: "#0000FF", type: "marker" }
        ]
    },
    placeholder: "Type Here..."
};

const FIELD_CONFIG_ALIASES = {
    recommendation_space_type_id: "space_type",
    recommendation_capital_type_id: "capital_type"
};

const serviceLifeIntegerIsAllowed = ({ value }) => {
    if (value === "" || value === null || value === undefined) return true;
    const str = String(value);
    if (!/^\d+$/.test(str)) return false;
    const n = parseInt(str, 10);
    return !isNaN(n) && n <= 100;
};
const priorityElementFieldName = (item, index) => `Priority Element ${item?.index || index + 1}`;

const FIELD_TO_BAND = {
    description: "band1",
    trade: "band1",
    system: "band1",
    sub_system: "band1",
    type: "band1",
    region: "band2",
    site: "band2",
    building: "band2",
    addition: "band2",
    floor: "band2",
    room: "band2",
    space_type: "band2",
    project_total: "band3",
    unit: "band3",
    cost_per_unit: "band3",
    quantity: "band3",
    options_cost: "band3",
    occurrence: "band3",
    total_opinions_of_cost: "band3",
    criticality: "band4",
    criticality_type: "band4",
    condition: "band6",
    category: "band6",
    capital_type: "band6",
    funding: "band6",
    responsibility: "band6",
    crv: "band6",
    department: "band6",
    initiative: "band6",
    requestor: "band6",
    requested_date: "band6",
    cr_status: "band6",
    cr_status_notes: "band6",
    inspection_date: "band6",
    recommendation_status_id: "band6",
    status_notes: "band6",
    surveyor: "band6",
    installed_year: "band6",
    service_life: "band6"
};
class RecommendationForm extends Component {
    constructor(props) {
        super(props);
        const {
            location: { search }
        } = this.props;
        this.templateRef = React.createRef();
        this.suggestionInputRef = React.createRef();
        const query = qs.parse(search);
        this.initialRecomState = {
            code: "",
            client_id: "",
            region_id: "",
            room: "",
            site_id: "",
            notes: "",
            note_html: "",
            asset_condition_id: "",
            project_id: query.p_id || "",
            comments: "",
            image: "",
            building_id: "",
            floor_id: "",
            addition_id: "",
            trade_id: "",
            system_id: "",
            sub_system_id: "",
            img_desc: "",
            category_id: "",
            asset_name: "",
            asset_tag: "",
            recommendationIdentifier: "",
            description: "",
            department_id: "",
            project: "",
            total_opinions_of_cost: "",
            occurrence: 1,
            service_life: "",
            usefull_life_remaining: "",
            model_number: "",
            serial_number: "",
            area_served: "",
            installed_year: "",
            image_name: "",
            priority_elements: [
                { index: "1", element: "" },
                { index: "2", element: "" },
                { index: "3", element: "" },
                { index: "4", element: "" },
                { index: "5", element: "" },
                { index: "6", element: "" },
                { index: "7", element: "" },
                { index: "8", element: "" }
            ],
            capacity: "",
            capital_type: "",
            recommendation_capital_type_id: "",
            funding_source_id: "",
            recommendation_space_type_id: "",
            responsibility_id: "",
            status: "pending",
            status_notes: "",
            cr_status: CAPITAL_REQUEST_STATUS[0]?.id,
            cr_status_notes: "",
            surveyor_id:
                query?.is_cr !== "true" && localStorage.getItem("userId") && localStorage.getItem("userId") !== "null"
                    ? localStorage.getItem("userId")
                    : "",
            surveyor:
                query?.is_cr !== "true" && localStorage.getItem("printed_name") && localStorage.getItem("printed_name") !== "null"
                    ? localStorage.getItem("printed_name")
                    : "",
            priority: 0,
            asset_notes: "",
            crv: "",
            inspection_date: "",
            maintenance_years: [],
            manufacturer_id: "",
            recommendation_status_id: "",
            quantity: "",
            unit: "",
            cost_per_unit: "",
            options_cost: "",

            asset: {},
            recommendation_type: RECOMMENDATION_TYPES.SYSTEM,
            fmp_id: "",
            fmp_project: "",
            fmp_track: "",
            infrastructure_request: localStorage.getItem("infrastructure_request_user") === "yes" || query?.is_cr === "true" ? "yes" : "no",
            fmp: localStorage.getItem("fmp_user") === "yes" ? "yes" : "no",
            red_line: "no",
            continuous_fca: "no",
            budget_priority: "no",
            criticality_id: "",
            criticality_type: "",
            source:
                query.type === RECOMMENDATION_SOURCE_TYPES.GEO_HIERARCHY ? "Same Geo Hierarchy" : query?.is_mr ? "Mobile" : (query.type ?? "Regular"),
            requestor_id:
                query?.is_cr === "true" && localStorage.getItem("userId") && localStorage.getItem("userId") !== "null"
                    ? localStorage.getItem("userId")
                    : "",
            requested_date: query?.is_cr === "true" ? new Date() : "",
            energy_band: {
                ecm_description: "",
                annual_savings: "",
                implementation_cost: "",
                simple_payback: "",
                annual_nat_gas_savings: "",
                annual_elec_savings: "",
                total_annual_savings: ""
            },
            water_band: {
                recommendation_for_improvement: "",
                annual_savings: "",
                safety_concerns: "",
                return_on_investment: ""
            },
            energy_band_show: "no",
            water_band_show: "no",
            dynamic_fields: {},
            check_list: []
        };
        this.state = {
            isAddOrEdit: false,
            showConfirmSave: false,
            // Kept separate from `loading` so Save can read "Validating…" without touching the form's
            // own loading behaviour.
            qaState: null,
            qaFindings: [],
            qaFailed: [],
            qaValidationStatus: null,
            toggleInput: false,
            activeDetail: query?.active_tab === "asset" ? "Asset Details" : "Main Details",
            loading: false,
            systemLoading: false,
            subSystemLoading: false,
            regionLoading: false,
            siteLoading: false,
            buildingLoading: false,
            floorLoading: false,
            additionLoading: false,
            autoFilledCapitalTypeId: "",
            clients: "",
            activeBuilding: "",
            showConfirmModal: false,
            building_type: "",
            priorityTotal: 0,
            systemArray: [],
            subSystemArray: [],
            initialPriorityTotal: "",
            costTotal: 0,
            initialCostYear: 0,
            imageUploadModal: false,
            project: {
                code: "",
                client_id: "",
                region_id: "",
                room: "",
                site_id: "",
                notes: "",
                note_html: "",
                asset_condition_id: "",
                project_id: query.p_id || "",
                comments: "",
                image: "",
                building_id: "",
                floor_id: "",
                addition_id: "",
                trade_id: "",
                system_id: "",
                sub_system_id: "",
                img_desc: "",
                category_id: "",
                asset_name: "",
                asset_tag: "",
                recommendationIdentifier: "",
                description: "",
                department_id: "",
                project: "",
                total_opinions_of_cost: "",
                occurrence: 1,
                service_life: "",
                usefull_life_remaining: "",
                model_number: "",
                serial_number: "",
                area_served: "",
                installed_year: "",
                image_name: "",
                priority_elements: [
                    { index: "1", element: "" },
                    { index: "2", element: "" },
                    { index: "3", element: "" },
                    { index: "4", element: "" },
                    { index: "5", element: "" },
                    { index: "6", element: "" },
                    { index: "7", element: "" },
                    { index: "8", element: "" }
                ],
                capacity: "",
                capital_type: "",
                recommendation_capital_type_id: "",
                funding_source_id: "",
                recommendation_space_type_id: "",
                responsibility_id: "",
                status: "pending",
                status_notes: "",
                cr_status: CAPITAL_REQUEST_STATUS[0]?.id,
                cr_status_notes: "",
                surveyor_id:
                    query?.is_cr !== "true" && localStorage.getItem("userId") && localStorage.getItem("userId") !== "null"
                        ? localStorage.getItem("userId")
                        : "",
                surveyor:
                    query?.is_cr !== "true" && localStorage.getItem("printed_name") && localStorage.getItem("printed_name") !== "null"
                        ? localStorage.getItem("printed_name")
                        : "",
                priority: 0,
                asset_notes: "",
                crv: "",
                inspection_date: "",
                maintenance_years: [],
                manufacturer_id: "",
                recommendation_status_id: "",
                quantity: "",
                unit: "",
                cost_per_unit: "",
                options_cost: "",

                asset: {},
                recommendation_type: RECOMMENDATION_TYPES.SYSTEM,
                fmp_id: "",
                fmp_project: "",
                fmp_track: "",
                infrastructure_request: localStorage.getItem("infrastructure_request_user") === "yes" || query?.is_cr === "true" ? "yes" : "no",
                fmp: localStorage.getItem("fmp_user") === "yes" ? "yes" : "no",
                red_line: "no",
                continuous_fca: "no",
                budget_priority: "no",
                criticality_id: "",
                criticality_type: "",
                source:
                    query.type === RECOMMENDATION_SOURCE_TYPES.GEO_HIERARCHY
                        ? "Same Geo Hierarchy"
                        : query?.is_mr
                          ? "Mobile"
                          : (query.type ?? "Regular"),
                requestor_id:
                    query?.is_cr === "true" && localStorage.getItem("userId") && localStorage.getItem("userId") !== "null"
                        ? localStorage.getItem("userId")
                        : "",
                requested_date: query?.is_cr === "true" ? new Date() : "",
                energy_band: {
                    ecm_description: "",
                    annual_savings: "",
                    implementation_cost: "",
                    simple_payback: "",
                    annual_nat_gas_savings: "",
                    annual_elec_savings: "",
                    total_annual_savings: ""
                },
                water_band: {
                    recommendation_for_improvement: "",
                    annual_savings: "",
                    safety_concerns: "",
                    return_on_investment: ""
                },
                energy_band_show: "no",
                water_band_show: "no",
                dynamic_fields: {},
                check_list: []
            },
            isLoading: true,
            errorMessage: "",
            showErrorBorder: false,
            isNewProject: true,
            selectedClient: {},
            regionList: [],
            initialValues: {},
            projectList: [],
            selectedImage: "",
            selectedConsultancyUsers: [],
            selectedProject: props.match.params.id,
            uploadError: "",
            attachmentChanged: false,
            locked: "",
            showAssetModal: false,
            assetFormData: assetFormInitialState,
            initialAssetFormData: {},
            showAssetRenameModal: false,
            showAssetTagReuseModal: false,
            assetTagReuseFields: [],
            assetTagReuseEdits: {},
            isEditingAssetTagReuse: false,
            assetRenameConfirmChoice: null,
            pendingAssetRename: null,
            showRecommendationTemplateModal: false,
            recommendationTemplateList: [],
            recommendationSuggestions: [],
            liveVerbError: null,
            forceShowVerbList: false,
            shakeVerbField: false,
            captionLength: 1000,
            showBand: {
                band1: true,
                band2: !query?.is_cr,
                band3: false,
                band4: false,
                band5: false,
                band6: false,
                energyBand: false,
                waterBand: false
            },
            priorityElementsData: [],
            criticalityData: [],
            criticalityTypeData: [
                { id: "Immediate", name: "Immediate" },
                { id: "Reserve", name: "Reserve" }
            ],
            capitalTypeData: [],
            showNoteModal: false,
            note_html: "",
            note_xml: "",
            editorHeight: "310",
            showYearRemoveConfirmation: false,
            selectedRemoveYear: "",
            siteCspYears: { start: "", end: "" },
            pendingSiteCspYearChange: null,
            birth_year: "",
            cr_narrative: "",
            isLoadingDrop: false,
            showVoiceNoteModal: false,
            showVideoNotesModal: false,
            showImageModal: false,
            showInfoModal: false,
            staticLinking: {
                energy: false,
                water: false
            },
            imagePopup: false,
            checkListData: [],
            parentRecommendationId: "",
            initialCheckListData: [],
            showSubsystemServiceLifeConfirm: false,
            pendingSubsystemChange: null,
            showCapitalTypeUpdateConfirm: false,
            pendingCapitalTypeChange: null
        };
    }
    mapFieldValues = (fields, projectData, capitalTypeData = []) => {
        return Object.keys(fields || {})?.reduce((acc, key) => {
            const field = fields[key];
            const isDynamic = !mrStaticFields?.includes(key);
            if (key === "main_building_type_id") key = "building_type";
            if (key === "floor") key = "floor_id";
            if (key === "notes") key = "note_html";
            if (isDynamic) {
                acc = {
                    ...acc,
                    dynamic_fields: {
                        ...(acc?.dynamic_fields ?? {}),
                        [key]: field?.value || ""
                    }
                };
                if ("priority_element_option" in field) {
                    acc.priority_elements = [
                        ...(acc.priority_elements || []),
                        {
                            index: field?.recom_priority_index,
                            element: field?.priority_element_option,
                            option_id: field?.uuid || null,
                            recommendation_priority_id: field?.field_name || null,
                            recommendation_required: false,
                            notes: null
                        }
                    ];
                }
            } else {
                const numericFields = ["installed_year", "service_life", "usefull_life_remaining", "current_age"];
                acc[key] =
                    field.field_type === "custom_select" && key !== "building_type"
                        ? field.uuid || ""
                        : numericFields.includes(key)
                          ? field.value || projectData[key]
                              ? parseInt(field.value || projectData[key])
                              : ""
                          : field.value || projectData[key] || "";
            }
            return acc;
        }, {});
    };
    mapAssetFieldsForAssetRecommendation = (fields, projectData = {}, capitalTypeData = [], isMR = false) => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);

        const recommendationType = fields?.recommendation_type?.value?.toLowerCase();

        if (recommendationType !== "asset") return {};
        this.props.getDropdownList("manufacturers", {
            current_manufacturer: fields?.["assets.manufacturer_id"]?.uuid,
            client_id: query?.c_id || this?.state?.project?.client_id
        });
        const result = Object.keys(fields || {})
            ?.filter(key => mrAssetMapKap[key])
            ?.reduce((acc, key) => {
                const field = fields[key];

                const transformedKey = mrAssetMapKap[key] || key;

                const numericFields = [
                    "assets.installed_year",
                    "assets.service_life",
                    "assets.usefull_life_remaining",
                    "assets.current_age",
                    "assets.end_of_service_life"
                ];

                if (numericFields?.includes(key)) {
                    acc[transformedKey] = field?.value ? parseInt(field.value) : "";
                } else if (field.field_type === "custom_select" && transformedKey !== "building_type") {
                    acc[transformedKey] =
                        transformedKey === "capital_type" ? (capitalTypeData?.find(e => e?.id === field?.uuid)?.name ?? "") : field?.uuid || "";
                } else {
                    acc[transformedKey] = field?.value || projectData?.[transformedKey] || "";
                }
                return acc;
            }, {});
        return result;
    };

    componentWillUnmount = () => {
        this.flushDeferredCapitalResolution.cancel();
        clearTimeout(this.shakeTimer);
    };

    componentDidMount = async () => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);

        this.setState({
            activeDetail: sessionStorage.getItem("activeDetail")
                ? sessionStorage.getItem("activeDetail")
                : query.active_tab === "additional"
                  ? "Additional Details"
                  : query.active_tab === "asset"
                    ? "Asset Details"
                    : "Main Details"
        });
        await this.props.getPriorityElementDropDownData(query.p_id);
        this.props.getRecommendationFieldConfigs({ project_id: query.p_id });
        await this.props.getDynamicFields({ project_id: query.p_id, client_id: query.c_id });
        const { recommendation_custom_fields: bands = [] } = this.props.recommendationsReducer.dynamicFields || {};
        let tempStaticLinking = { ...this.state.staticLinking };

        Object.entries(bands).forEach(([band, fields]) => {
            if (fields.some(e => e?.link_static_entity === "energy")) {
                tempStaticLinking = { ...tempStaticLinking, energy: true };
            }
            if (fields.some(e => e?.link_static_entity === "water")) {
                tempStaticLinking = { ...tempStaticLinking, water: true };
            }
        });
        await this.setState({ staticLinking: tempStaticLinking });
        let updatedPriorityElements = this.props.recommendationsReducer.priorityElementsDropDownResponse?.priority_elements || [];
        await this.props.getCriticalityData({ project_id: query.p_id });
        let criticalityData = this.props.projectReducer.criticalityData?.criticalities || [];
        await this.props.getCapitalTypeDropDownData(query.p_id);
        let capitalTypeData = this.props.recommendationsReducer.capitalTypeDropDownResponse?.capital_types || [];
        this.props.getDepartmentByProject(query.p_id);
        this.props.getConditionBasedOnProject(query.p_id);
        this.props.getTradeBasedOnProject(query.p_id);
        this.props.getCategoryBasedOnProject(query.p_id);
        this.props.getCapitalTypeBasedOnProject(query.p_id);
        this.props.getFundingSourceByProject(query.p_id);
        this.props.getSpaceType({ project_id: query.p_id });
        this.props.getResponsibilityByProject(query.p_id);
        if (isVerbValidationEnabled()) this.props.getRecommendationAcceptableVerbsByProject(query.p_id);
        this.props.getUsersByProject(query.p_id, { is_surveyor_list: true });
        this.getRecommendationTemplates(undefined, query.p_id);
        await this.props.getProjectById(query.p_id);
        const { getProjectByIdResponse } = this.props.projectReducer;
        await this.setState({
            captionLength: getProjectByIdResponse?.miscellaneous?.reco_length
        });
        this.props.getInitiativeDropdown({ project_id: query.p_id, client_id: query.c_id });
        await this.props.getAllClientsRecomentation();
        this.props.getDropdownList("uniformat_level_1s", { client_id: query?.c_id });
        await this.props.statusDropdown(query.p_id);
        if (query.c_id) {
            // get asset dropdowns
            this.props.getAssetDynamicFields({ client_id: query?.c_id });
            this.props.getDropdownList("asset_conditions", { client_id: query.c_id });
            this.props.getDropdownList("asset_statuses", { client_id: query.c_id });
            this.props.getDropdownList("asset_types", { client_id: query.c_id });
            this.props.getDropdownList("main_categories", { client_id: query.c_id });
            this.props.getDropdownList("client_standards", { client_id: query.c_id });
            let regionList = await this.props.getRegionListBasedOnClient(query.c_id);
            this.setState({
                regionList,
                project: {
                    ...this.state.project,
                    client_id: query.c_id
                },
                assetFormData: {
                    ...this.state.assetFormData,
                    client_id: query.c_id
                }
            });
        }
        if (query.s_id && this.props?.match?.params?.section === "add") {
            await this.props?.getMobileRecommendationById(query?.s_id);
        }
        if (query?.s_id) {
            await this.props.getAssetVoiceNotes(query.s_id, { page_type: "recommendations", sort: "desc" });
            const mrComments = this.props?.mobileRecommendationsReducer?.getMobileRecommendationByIdResponse?.recommendation?.comments ?? "";
            const voiceNotes = this.props.assetSurveyProjectReducer.getAssetVoiceNotesResponse?.data?.audio;
            const voiceText = [
                ...(mrComments && [{ voice_text: removeAllTags((mrComments ?? "")?.replace(/["']/g, "")) }]),
                ...(voiceNotes ?? [])
            ]?.reduce((acc, item) => {
                acc = acc ? `${acc} <br/><br/> ${item?.voice_text ?? ""}` : (item?.voice_text ?? "");
                return acc;
            }, "");
            await this.setState({ cr_narrative: voiceText });
            await this.props?.getSurveyRecommendationImagesById(query?.s_id);
        }

        const {
            projectReducer: {
                getAllClientsResponse: { clients }
            }
        } = this.props;
        if (
            this.props?.mobileRecommendationsReducer?.getMobileRecommendationByIdResponse &&
            this.props?.match?.params?.section === "add" &&
            query.s_id
        ) {
            const inspectionDate = this.props?.mobileRecommendationsReducer?.getMobileRecommendationByIdResponse?.recommendation?.surveyed_time ?? "";
            const surveyor = this.props?.mobileRecommendationsReducer?.getMobileRecommendationByIdResponse?.recommendation?.surveyor?.id ?? "";
            const surveyor_name = this.props?.mobileRecommendationsReducer?.getMobileRecommendationByIdResponse?.recommendation?.surveyor?.name ?? "";
            const pending =
                this.props?.recommendationStatusReducer?.getStatusDropdwnResponse?.recommendation_status_data?.find(item => item?.key === "pending")
                    ?.id || null;
            const mobileRecomData = this.props?.mobileRecommendationsReducer?.getMobileRecommendationByIdResponse?.recommendation?.dynamic_fields;
            const checkListData = normalizeToNested(
                this.props?.mobileRecommendationsReducer?.getMobileRecommendationByIdResponse?.recommendation?.check_list || []
            );
            await this.setState(prevState => {
                const updatedProjectData = this?.mapFieldValues(mobileRecomData, prevState.project, capitalTypeData);
                const updatedAssetData = this?.mapAssetFieldsForAssetRecommendation(mobileRecomData, prevState.project, capitalTypeData);
                return {
                    ...prevState,
                    project: {
                        ...prevState.project,
                        ...updatedProjectData,
                        ...(inspectionDate && { inspection_date: new Date(inspectionDate) }),
                        ...(surveyor && { surveyor_id: surveyor }),
                        ...(surveyor_name && { surveyor: surveyor_name })
                        // recommendation_status_id: pending
                    },
                    assetFormData: { ...prevState?.assetFormData, ...updatedAssetData },
                    priorityTotal: mobileRecomData?.priority?.value,
                    checkListData,
                    initialCheckListData: checkListData,
                    parentRecommendationId:
                        this.props?.mobileRecommendationsReducer?.getMobileRecommendationByIdResponse?.recommendation?.recommendation_id || ""
                };
            });
            const isMR = query.is_mr === "true";
            if (this.state?.project?.recommendation_type === RECOMMENDATION_TYPES.ASSET && !isMR) {
                const { installed_year, service_life, usefull_life_remaining } = this.state?.project ?? {};
                await this.setState({
                    assetFormData: {
                        ...(this.state?.assetFormData ?? {}),
                        installed_year: installed_year ? parseInt(installed_year) : "",
                        service_life: isNaN(parseInt(service_life)) ? "" : parseInt(service_life),
                        current_age: installed_year ? getCurrentAge(installed_year) : "",
                        usefull_life_remaining: usefull_life_remaining ? parseInt(usefull_life_remaining) : "",
                        client_asset_condition_id: this.state?.project?.asset_condition_id ?? ""
                    }
                });
            }
            this.props.getDropdownList("project_sites", { project_id: query.p_id, region_id: this.state?.project?.region_id });
            this.props.getFloorBasedOnBuilding(this.state?.project?.building_id);
            this.props.getAdditionBasedOnBuilding(this.state?.project?.building_id);
            this.props.getDropdownList("project_buildings", { project_id: query.p_id, site_id: this.state.project.site_id });
            await this.getCostYear(this.state.project.site_id);
            if (this.state?.project?.trade_id) {
                await this.handleTrade(this.state?.project?.trade_id, this.state?.project?.system_id, this.state?.project?.sub_system_id);
            }
        }

        const { selectedProject } = this.state;
        let projectList = [];
        if (query.inp || selectedProject) {
            projectList = this.props.projectReducer.getAllProjectsResponse.projects;
        }
        if (selectedProject) {
            await this.props.getDataById(selectedProject);
            this.props.getAllRecommendationImages(selectedProject);
            const {
                recommendationsReducer: {
                    getRecommendationByIdResponse: {
                        code,
                        comments,
                        name,
                        success,
                        description,
                        trade,
                        system,
                        sub_system,
                        floor,
                        addition,
                        department,
                        category,
                        room,
                        asset_name,
                        asset_tag,
                        installed_year,
                        condition,
                        priority,
                        inspection_date,
                        future_capital,
                        project_total,
                        surveyor_id,
                        surveyor,
                        status,
                        status_notes,
                        cr_status,
                        cr_status_notes,
                        initiative,
                        capital_type,
                        recommendation_capital_type_id,
                        service_life,
                        usefull_life_remaining,
                        crv,
                        model_number,
                        serial_number,
                        capacity,
                        asset_notes,
                        area_served,
                        notes,
                        note_html,
                        funding_source,
                        recommendation_space_type,
                        responsibility,
                        lock_status,
                        client,
                        region,
                        site,
                        building,
                        image,
                        maintenance_years,
                        priority_elements,
                        created_at,
                        updated_at,
                        manufacturer,
                        project,
                        quantity,
                        unit,
                        cost_per_unit,
                        options_cost,
                        total_opinions_of_cost,
                        occurrence,
                        asset,
                        recommendation_type,
                        fmp,
                        fmp_id,
                        fmp_project,
                        fmp_track,
                        criticality,
                        criticality_type,
                        source,
                        energy_band,
                        water_band,
                        energy_band_show,
                        water_band_show,
                        red_line,
                        continuous_fca,
                        budget_priority,
                        infrastructure_request,
                        dynamic_fields,
                        birth_year,
                        requestor,
                        requested_date,
                        check_list
                    }
                }
            } = this.props;
            if (success) {
                this.props.getDropdownList("manufacturers", {
                    current_manufacturer: manufacturer?.id,
                    client_id: query?.c_id || this.state?.project?.client_id
                });
                updatedPriorityElements = this.getUpdatedPriorityElementsData(
                    priority_elements,
                    this.props.recommendationsReducer.priorityElementsDropDownResponse.priority_elements
                );
                let latestPriorityElements = this.getLatestPriorityElements(
                    priority_elements,
                    this.props.recommendationsReducer.priorityElementsDropDownResponse.priority_elements
                );
                let selectedCriticality = null;
                if (priority_elements?.length && !criticality?.id) {
                    let priorityTotal = 0;
                    let pelement = priority_elements;
                    pelement.map(item => (priorityTotal += Number(item.element)));
                    if (priorityTotal && criticalityData.length) {
                        selectedCriticality = criticalityData.find(
                            c => priorityTotal >= parseFloat(c.start_range) && priorityTotal <= parseFloat(c.end_range)
                        );
                    }
                }
                await this.props.getSystemBasedOnProject(query.p_id, trade.id);
                const systemData = this.props.recommendationsReducer?.getSystemByProject?.systems || [];
                await this.props.getSubSystemBasedOnProject(query.p_id, system.id);
                const subSystemData = this.props.recommendationsReducer?.getSubSystemByProject?.sub_systems || [];
                let regionList = await this.props.getRegionListBasedOnClient(client.id);
                this.props.getDropdownList("project_sites", {
                    project_id: query.p_id,
                    region_id: region.id,
                    ...(site?.id ? { current_site_id: site.id } : {})
                });
                this.props.getFloorBasedOnBuilding(building.id);
                this.props.getAdditionBasedOnBuilding(building.id);
                const dynamicFieldValue = {};
                if (dynamic_fields && Object.keys(dynamic_fields)?.length) {
                    Object.keys(dynamic_fields).forEach(field => {
                        dynamicFieldValue[field] = dynamic_fields[field]?.value;
                    });
                }
                const checklistValue = normalizeToNested(check_list);
                await this.setState({
                    systemArray: systemData,
                    subSystemArray: subSystemData,
                    project: {
                        name,
                        code,
                        comments,
                        description,
                        trade_id: trade.id,
                        system_id: system.id || "",
                        sub_system_id: sub_system.id,
                        floor_id: floor.id,
                        addition_id: addition?.id,
                        department_id: department.id,
                        category_id: category.id,
                        room,
                        asset_name,
                        asset_tag,
                        installed_year,
                        asset_condition_id: condition?.id,
                        priority,
                        inspection_date,
                        future_capital,
                        project_total,
                        surveyor_id: surveyor_id
                            ? surveyor_id
                            : surveyor
                              ? this.props.projectReducer.getUserByProjectData?.users?.find(({ printed_name }) => printed_name === surveyor)?.id
                              : "",
                        surveyor,
                        status: status?.key,
                        status_notes,
                        cr_status,
                        cr_status_notes,
                        initiative_id: initiative ? initiative.id : "",
                        capital_type: capital_type || "",
                        recommendation_capital_type_id: recommendation_capital_type_id || "",
                        service_life,
                        usefull_life_remaining,
                        crv,
                        model_number,
                        serial_number,
                        capacity,
                        asset_notes,
                        client_id: client.id || "",
                        region_id: region.id || "",
                        site_id: site.id || "",
                        building_id: building.id || "",
                        building_type: building.building_type,
                        image: image.id ? image : [],
                        maintenance_years,
                        priority_elements: latestPriorityElements,
                        img_desc: image.description || "",
                        area_served,
                        notes: notes || "",
                        note_html: note_html || notes?.replace(/\n/g, "<br />"),
                        image_id: image ? image.id : "",
                        funding_source_id: funding_source.id,
                        recommendation_space_type_id: recommendation_space_type?.id ?? "",
                        responsibility_id: responsibility?.id,
                        manufacturer_id: manufacturer?.id,
                        recommendation_status_id: status?.id,
                        project,
                        quantity,
                        unit,
                        cost_per_unit,
                        options_cost,
                        total_opinions_of_cost,
                        occurrence,
                        asset,
                        asset_id: asset?.id || "",
                        recommendation_type: recommendation_type || RECOMMENDATION_TYPES.SYSTEM,
                        fmp,
                        fmp_id,
                        fmp_project,
                        fmp_track,
                        criticality_id: criticality.id || selectedCriticality?.id || "",
                        criticality_type: criticality_type || "",
                        source: source || "-",
                        energy_band: { ...this.state.project.energy_band, ...energy_band },
                        water_band: { ...this.state.project.water_band, ...water_band },
                        energy_band_show,
                        water_band_show,
                        infrastructure_request,
                        red_line,
                        continuous_fca,
                        budget_priority,
                        dynamic_fields: dynamicFieldValue,
                        requestor_id: requestor?.id,
                        requested_date,
                        check_list
                    },
                    birth_year,
                    regionList,
                    selectedImage: image,
                    createdAt: created_at,
                    updatedAt: updated_at,
                    locked: lock_status === LOCK_STATUS.LOCKED,
                    editorHeight: recommendation_type === RECOMMENDATION_TYPES.ASSET ? "400" : "310",
                    initialCheckListData: checklistValue,
                    checkListData: checklistValue
                });
                if (recommendation_type === RECOMMENDATION_TYPES.ASSET) {
                    await this.handleAssignAsset(asset);
                }
                this.getCostYear(site?.id);
                this.getRecommendationTemplates(this.state.project.sub_system_id);
                this.props.getDropdownList("project_buildings", {
                    project_id: query.p_id,
                    site_id: this.state.project.site_id,
                    ...(this.state.project.building_id ? { current_building_id: this.state.project.building_id } : {})
                });
                let costTotal = 0;
                maintenance_years && maintenance_years.length && maintenance_years.map(item => (costTotal += item.amount));
                this.setState({
                    costTotal: costTotal,
                    initialCostYear: costTotal,
                    initialPriorityTotal: priority,
                    priorityTotal: priority
                });
                this.setState({ initialValues: _.cloneDeep(this.state.project) });
            }
        } else if (
            query.type === RECOMMENDATION_SOURCE_TYPES.SIMILAR ||
            query.type === RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE ||
            query.type === RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP ||
            query.type === RECOMMENDATION_SOURCE_TYPES.GEO_HIERARCHY ||
            query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST
        ) {
            // set the initial recommendation form values based on the create type
            await this.populateValuesBasedOnType();
        } else if (!query?.s_id || (!this.state?.project?.trade_id && query?.s_id)) {
            await this.props.getUserDefaultTrade(query.p_id);
            const { getUserDefaultTradeResponse } = this.props.recommendationsReducer;
            const defaultTradeId = getUserDefaultTradeResponse?.id || "";
            if (defaultTradeId) {
                await this.setState({
                    project: { ...this.state.project, trade_id: defaultTradeId },
                    assetFormData: { ...this.state.assetFormData, trade_id: defaultTradeId }
                });
            }
            await this.handleTrade(defaultTradeId);

            const pending =
                this.props?.recommendationStatusReducer?.getStatusDropdwnResponse?.recommendation_status_data?.find(item => item?.key === "pending")
                    ?.id || null;

            await this.setState({
                project: {
                    ...this.state.project,
                    recommendation_status_id: pending
                }
            });
        }
        if (!selectedProject) {
            const isMR = query.is_mr === "true";
            if (
                query.type !== RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE &&
                query.type !== RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP &&
                query.type !== RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST &&
                !isMR
            ) {
                let initialPriorityElementData = this.setPriorirtyElementData(updatedPriorityElements);
                await this.setState({
                    project: {
                        ...this.state.project,
                        priority_elements: initialPriorityElementData
                    }
                });
            }
        }

        await this.setState({
            clients,
            projectList,
            isNewProject: query.inp,
            isLoading: false,
            priorityElementsData: updatedPriorityElements,
            criticalityData: criticalityData,
            capitalTypeData: capitalTypeData,
            initialValues: _.cloneDeep(this.state.project)
        });
        ReactTooltip.rebuild();
        // to set the previous recommendation data
        await this.setPrevRecomData();
        this.setState({ initialAssetFormData: _.cloneDeep(this.state.assetFormData) });
    };

    getUpdatedPriorityElementsData = (currentData = [], dropDownData = []) => {
        let updatedData = [];
        if (currentData.length > dropDownData.length) {
            updatedData = currentData.map((pData, i) => {
                if (dropDownData[i]) {
                    return {
                        ...dropDownData[i]
                    };
                }
                return {
                    ...pData
                };
            });
        } else {
            updatedData = [...dropDownData];
        }
        return updatedData;
    };
    getLatestPriorityElements(currentData = [], dropDownData = []) {
        const existingIds = currentData.map(d => d.recommendation_priority_id).filter(Boolean);
        const missing = dropDownData.filter(p => !existingIds.includes(p.id));
        const result = [...currentData];
        const placeholderCount = result.filter(d => !d.recommendation_priority_id).length;
        missing.forEach((p, i) => {
            if (i < placeholderCount) {
                const slotIdx = result.findIndex(d => !d.recommendation_priority_id);
                result[slotIdx] = {
                    ...result[slotIdx],
                    element: "",
                    option_id: "",
                    recommendation_priority_id: p.id
                };
            } else {
                result.push({
                    element: "",
                    option_id: "",
                    recommendation_priority_id: p.id
                });
            }
        });
        return result.map((row, idx) => ({
            ...row,
            index: idx + 1
        }));
    }

    setPriorirtyElementData = priority_elements => {
        let priorityElementData = [];
        priority_elements.forEach((element, i) => {
            priorityElementData.push({ index: i + 1, element: "", option_id: "", recommendation_priority_id: "" });
        });
        return priorityElementData;
    };

    setPrevRecomData = async () => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        if (JSON.parse(sessionStorage.getItem("currentFormData"))) {
            const project = JSON.parse(sessionStorage.getItem("currentFormData"));
            let systemData = [];
            let subSystemData = [];
            let regionList = [];
            if (!this.state.selectedProject) {
                if (project?.trade_id) {
                    await this.props.getSystemBasedOnProject(query.p_id, project?.trade_id);
                    systemData = this.props.recommendationsReducer?.getSystemByProject?.systems || [];
                }
                if (project?.system_id) {
                    await this.props.getSubSystemBasedOnProject(query.p_id, project?.system_id);
                    subSystemData = this.props.recommendationsReducer?.getSubSystemByProject?.sub_systems || [];
                }
                if (project?.sub_system_id) {
                    this.getRecommendationTemplates(project?.sub_system_id);
                }
                if (project?.client_id) {
                    regionList = await this.props.getRegionListBasedOnClient(project?.client_id);
                }
                if (project?.region_id) {
                    this.props.getDropdownList("project_sites", { project_id: query.p_id, region_id: project?.region_id });
                }
                if (project?.site_id) {
                    this.props.getDropdownList("project_buildings", { project_id: query.p_id, site_id: project?.site_id });
                }
                if (project?.building_id) {
                    this.props.getFloorBasedOnBuilding(project?.building_id);
                    this.props.getAdditionBasedOnBuilding(project?.building_id);
                }
            }
            await this.setState({
                project,
                systemArray: systemData,
                subSystemArray: subSystemData,
                regionList
            });
            this.assignLastCreatedAsset();
            sessionStorage.removeItem("currentFormData");
            sessionStorage.removeItem("activeDetail");
        }
    };

    assignLastCreatedAsset = async () => {
        let lastCreatedAssetId = sessionStorage.getItem("lastCreatedAssetId");
        if (lastCreatedAssetId) {
            await this.props.getAssetDataById(lastCreatedAssetId);
            const resData = this.props.assetReducer.getDataByIdResponse;
            this.handleAssignAsset(resData);
            sessionStorage.removeItem("lastCreatedAssetId");
        }
    };

    populateValuesBasedOnType = async () => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const isDuplicateNoCsp = query.type === RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP;
        let recomData = JSON.parse(sessionStorage.getItem("currentRecommendationData"));
        if (recomData) {
            let systemData = [];
            let subSystemData = [];
            let regionList = [];
            if (query.type !== "Building") {
                if (recomData?.trade?.id) {
                    await this.props.getSystemBasedOnProject(query.p_id, recomData?.trade?.id);
                    systemData = this.props.recommendationsReducer?.getSystemByProject?.systems || [];
                }
                if (recomData?.system?.id) {
                    await this.props.getSubSystemBasedOnProject(query.p_id, recomData?.system?.id);
                    subSystemData = this.props.recommendationsReducer?.getSubSystemByProject?.sub_systems || [];
                }
                if (recomData?.sub_system?.id) {
                    this.getRecommendationTemplates(recomData?.sub_system?.id);
                }
            }
            if (recomData?.client?.id) {
                regionList = await this.props.getRegionListBasedOnClient(recomData?.client?.id);
            }
            if (recomData?.region?.id) {
                this.props.getDropdownList("project_sites", {
                    project_id: query.p_id,
                    region_id: recomData?.region?.id,
                    ...(recomData?.site?.id ? { current_site_id: recomData.site.id } : {})
                });
            }
            if (recomData?.manufacturer?.id) {
                this.props.getDropdownList("manufacturers", {
                    current_manufacturer: recomData.manufacturer.id,
                    client_id: recomData?.client?.id || query?.c_id
                });
            }
            if (recomData?.site?.id) {
                this.props.getDropdownList("project_buildings", {
                    project_id: query.p_id,
                    site_id: recomData?.site?.id,
                    ...(recomData?.building?.id ? { current_building_id: recomData.building.id } : {})
                });
                await this.getCostYear(recomData?.site?.id, isDuplicateNoCsp);
            }
            if (recomData?.building?.id) {
                this.props.getFloorBasedOnBuilding(recomData?.building?.id);
                this.props.getAdditionBasedOnBuilding(recomData?.building?.id);
            }
            let list = { regionList };
            if (query.type !== "Building") {
                list = { ...list, systemArray: systemData, subSystemArray: subSystemData };
            }
            await this.setState({ ...list });
            const {
                addition,
                area_served,
                asset,
                asset_name,
                asset_notes,
                asset_tag,
                building,
                capacity,
                capital_type,
                recommendation_capital_type_id,
                category,
                client,
                condition,
                cost_per_unit,
                criticality,
                criticality_type,
                crv,
                department,
                description,
                energy_band,
                floor,
                funding_source,
                space_type,
                responsibility,
                initiative,
                inspection_date,
                installed_year,
                maintenance_years,
                manufacturer,
                model_number,
                notes,
                note_html,
                options_cost,
                total_opinions_of_cost,
                occurrence,
                priority,
                priority_elements,
                project,
                project_total,
                quantity,
                recommendation_type,
                region,
                room,
                serial_number,
                service_life,
                site,
                status,
                status_notes,
                cr_status,
                cr_status_notes,
                sub_system,
                surveyor_id,
                surveyor,
                system,
                trade,
                unit,
                fmp,
                fmp_id,
                fmp_project,
                fmp_track,
                budget_priority,
                red_line,
                continuous_fca,
                infrastructure_request,
                usefull_life_remaining,
                water_band,
                energy_band_show,
                water_band_show,
                dynamic_fields,
                requestor,
                requested_date
            } = recomData;
            if (query.type === RECOMMENDATION_SOURCE_TYPES.SIMILAR) {
                await this.setState({
                    project: {
                        ...this.state.project,
                        addition_id: addition?.id,
                        building_id: building?.id,
                        building_type: building?.building_type,
                        floor_id: floor?.id,
                        inspection_date,
                        recommendation_type,
                        region_id: region?.id,
                        room,
                        site_id: site?.id,
                        status: status?.key,
                        recommendation_status_id: status?.id,
                        sub_system_id: sub_system?.id,
                        system_id: system?.id,
                        trade_id: trade?.id,
                        recommendation_space_type_id: space_type?.id
                    }
                });
                this.handleRecommendationTypeSelect();
            } else if (
                query.type === RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE ||
                query.type === RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP ||
                query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST
            ) {
                // Duplicate - No CSP and Capital Request drop the surveyor, the inspection date and
                // any BBI/BSI-linked dynamic field. Duplicate - Full copies everything: see fullDuplicateValues below.
                let latestPriorityElements = this.getLatestPriorityElements(
                    priority_elements,
                    this.props.recommendationsReducer.priorityElementsDropDownResponse.priority_elements
                );

                const isFullDuplicate = query.type === RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE;
                const dynamicFieldValue = {};
                if (dynamic_fields && Object.keys(dynamic_fields)?.length) {
                    Object.keys(dynamic_fields).forEach(field => {
                        dynamicFieldValue[field] =
                            !isFullDuplicate && (dynamic_fields[field]?.link_bbi || dynamic_fields[field]?.link_bsi)
                                ? ""
                                : dynamic_fields[field]?.value;
                    });
                }
                const currentUser = localStorage.getItem("userId");
                const isSameOwner = currentUser === surveyor_id;
                const sourceSurveyorName = typeof surveyor === "string" ? surveyor : surveyor?.printed_name || surveyor?.name || "";
                const sourceSurveyorId =
                    surveyor_id ||
                    surveyor?.id ||
                    (sourceSurveyorName
                        ? this.props.projectReducer.getUserByProjectData?.users?.find(({ printed_name }) => printed_name === sourceSurveyorName)?.id
                        : "");
                const noCspClearedValues = isDuplicateNoCsp
                    ? {
                          installed_year: "",
                          maintenance_years: this.state.project.maintenance_years,
                          options_cost: "",
                          total_opinions_of_cost: "",
                          project_total: 0,
                          quantity: "",
                          usefull_life_remaining: ""
                      }
                    : {};
                const fullDuplicateValues = isFullDuplicate
                    ? {
                          ...(sourceSurveyorId ? { surveyor_id: sourceSurveyorId, surveyor: sourceSurveyorName } : {}),
                          inspection_date,
                          requestor_id: requestor?.id || "",
                          requested_date: requested_date || "",
                          fmp: fmp || this.state.project.fmp,
                          fmp_id: fmp_id || "",
                          fmp_project: fmp_project || "",
                          fmp_track: fmp_track || "",
                          budget_priority: budget_priority || this.state.project.budget_priority,
                          red_line: red_line || this.state.project.red_line,
                          continuous_fca: continuous_fca || this.state.project.continuous_fca,
                          infrastructure_request: infrastructure_request || this.state.project.infrastructure_request
                      }
                    : {};
                await this.setState({
                    project: {
                        ...this.state.project,
                        addition_id: addition?.id,
                        area_served,
                        asset_name,
                        asset_notes,
                        asset_tag,
                        building_id: building.id,
                        building_type: building.building_type,
                        capacity,
                        capital_type: capital_type || "",
                        recommendation_capital_type_id: recommendation_capital_type_id || "",
                        category_id: category?.id,
                        client_id: client?.id,
                        asset_condition_id: condition?.id,
                        cost_per_unit,
                        crv,
                        department_id: department.id,
                        description,
                        floor_id: floor.id,
                        funding_source_id: funding_source.id,
                        recommendation_space_type_id: space_type?.id ?? "",
                        responsibility_id: responsibility.id,
                        initiative_id: initiative?.id,
                        inspection_date:
                            query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST
                                ? requested_date
                                : isDuplicateNoCsp || !isSameOwner
                                  ? ""
                                  : inspection_date,
                        requestor_id: query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST ? requestor?.id : this.state.project.requestor_id,
                        requested_date: query.is_cr === "true" ? new Date() : requested_date,
                        installed_year,
                        maintenance_years,
                        manufacturer_id: manufacturer?.id,
                        recommendation_status_id: status?.id,
                        model_number,
                        notes: query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST ? "" : notes || "",
                        note_html: query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST ? "" : note_html || notes,
                        options_cost,
                        total_opinions_of_cost,
                        occurrence,
                        priority,
                        priority_elements: latestPriorityElements,
                        project,
                        project_total,
                        quantity,
                        recommendation_type: recommendation_type || "asset",
                        region_id: region.id,
                        room,
                        serial_number,
                        service_life,
                        site_id: site.id,
                        status: status?.key,
                        status_notes,
                        cr_status,
                        cr_status_notes,
                        sub_system_id: sub_system.id,
                        system_id: system.id,
                        trade_id: trade.id,
                        unit,
                        usefull_life_remaining,
                        criticality_id: criticality?.id,
                        criticality_type: criticality_type,
                        energy_band: {
                            annual_savings: energy_band?.annual_savings || "",
                            total_captial_spending_plan_kbtu_savings: energy_band?.total_captial_spending_plan_kbtu_savings || "",
                            implementation_cost: energy_band?.implementation_cost || "",
                            simple_payback: energy_band?.simple_payback || "",
                            annual_nat_gas_savings: energy_band?.annual_nat_gas_savings || "",
                            annual_elec_savings: energy_band?.annual_elec_savings || "",
                            total_annual_savings: energy_band?.total_annual_savings || "",
                            annual_energy_savings: energy_band?.annual_energy_savings || "",
                            annual_cost_to_implement_ecm: energy_band?.annual_cost_to_implement_ecm || ""
                        },
                        water_band: {
                            annual_savings_water: water_band?.annual_savings_water || "",
                            safety_concerns: water_band?.safety_concerns || "",
                            simple_payback_water: water_band?.simple_payback_water || ""
                        },
                        energy_band_show,
                        water_band_show,
                        dynamic_fields: dynamicFieldValue,
                        ...noCspClearedValues,
                        ...fullDuplicateValues
                    },
                    costTotal: isDuplicateNoCsp ? 0 : project_total,
                    initialPriorityTotal: priority,
                    priorityTotal: priority,
                    cr_narrative: query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST ? note_html : ""
                });
                if (query.type === RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP) {
                    await this.duplicateAsset(asset, isDuplicateNoCsp);
                } else if (isFullDuplicate && asset?.id) {
                    await this.props.getAssetDataById(asset.id);
                    const assetData = this.props.assetReducer.getDataByIdResponse;
                    if (assetData?.id) {
                        await this.handleAssignAsset(assetData);
                    }
                }
            } else if (query.type === RECOMMENDATION_SOURCE_TYPES.GEO_HIERARCHY) {
                const status =
                    this.props?.recommendationStatusReducer?.getStatusDropdwnResponse?.recommendation_status_data?.find(
                        item => item?.key === "pending"
                    ) || {};
                await this.setState({
                    project: {
                        ...this.state.project,
                        building_id: building?.id,
                        building_type: building?.building_type,
                        region_id: region?.id,
                        site_id: site?.id,
                        floor_id: floor.id,
                        addition_id: addition?.id,
                        room,
                        status: status?.key || "",
                        recommendation_status_id: status?.id || "",
                        recommendation_space_type_id: space_type?.id
                    }
                });
            }
        }
    };

    getSurveyorOptions = () => {
        const users = this.props.projectReducer.getUserByProjectData?.users ?? [];
        const { surveyor_id, surveyor } = this.state.project;
        if (!surveyor_id || users.some(({ id }) => id === surveyor_id)) return users;
        return [...users, { id: surveyor_id, printed_name: surveyor || "", name: surveyor || "" }];
    };

    duplicateAsset = async (asset, isDuplicateNoCsp = false) => {
        await this.setState({
            assetFormData: {
                code: "",
                asset_name: asset.asset_name,
                asset_tag: "",
                asset_note: asset.asset_note,
                client_asset_condition_id: asset.asset_condition?.id,
                installed_year: isDuplicateNoCsp ? "" : asset.installed_year,
                service_life: asset.service_life,
                usefull_life_remaining: isDuplicateNoCsp ? "" : asset.usefull_life_remaining,
                crv: asset.crv,
                manufacturer_id: asset.manufacturer?.id,
                year_manufactured: asset.year_manufactured,
                model_number: asset.model_number,
                serial_number: "",
                capacity: asset.capacity,
                criticality: asset.criticality,
                area_served: asset.area_served,
                client_id: asset.client?.id,
                region_id: asset.region?.id,
                site_id: asset.site?.id,
                building_id: asset.building?.id,
                addition_id: asset.addition?.id,
                floor_id: asset.floor?.id,
                room_number: asset.room_number,
                room_name: asset.room_name,
                location: asset.location,
                architectural_room_number: asset.architectural_room_number,
                additional_room_description: asset.additional_room_description,
                uniformat_level_1_id: asset.uniformat_level_1?.id,
                uniformat_level_2_id: asset.uniformat_level_2?.id,
                uniformat_level_3_id: asset.uniformat_level_3?.id,
                uniformat_level_4_id: asset.uniformat_level_4?.id,
                uniformat_level_5_id: asset.uniformat_level_5?.id,
                uniformat_version: asset?.uniformat_version ?? null,
                asset_type_id: asset.asset_type?.id,
                asset_description: asset.asset_description,
                asset_barcode: "",
                asset_client_id: asset.asset_client_id,
                asset_cmms_id: asset.asset_cmms_id,
                warranty_start: asset.warranty_start,
                warranty_end: asset.warranty_end,
                install_date: isDuplicateNoCsp ? "" : asset.install_date,
                startup_date: asset.startup_date,
                upstream_asset_barcode_number: asset.upstream_asset_barcode_number,
                linked_asset_barcode_number: asset.linked_asset_barcode_number,
                source_panel_barcode_number: asset.source_panel_barcode_number,
                source_panel: asset.source_panel,
                asset_status_id: asset.asset_status?.id,
                notes: asset.notes,
                building_type: asset?.building_type?.name,
                main_category_id: asset?.main_category?.id,
                sub_category_1_id: asset?.sub_category_1?.id,
                sub_category_2_id: asset?.sub_category_2?.id,
                sub_category_3_id: asset?.sub_category_3?.id,
                guid: "",
                source_panel_name: asset?.source_panel_name,
                skysite_hyperlink: asset?.skysite_hyperlink,
                trade_id: asset.trade?.id,
                system_id: asset.system?.id,
                sub_system_id: asset.sub_system?.id,

                quantity: isDuplicateNoCsp ? "" : asset?.quantity,
                rtls_tag: asset?.rtls_tag,
                latitude: asset?.latitude,
                longitude: asset?.longitude,
                current_age: isDuplicateNoCsp ? "" : asset?.current_age,
                age: isDuplicateNoCsp ? "" : asset?.age,
                end_of_service_life: isDuplicateNoCsp ? "" : asset?.end_of_service_life,
                new_asset: asset?.new_asset,
                source: ASSET_SOURCES.RECOMMENDATION,
                latest_source: ASSET_SOURCES.RECOMMENDATION,
                parent_global_id: asset?.parent_global_id,
                survey_global_id: asset?.survey_global_id,
                survey_id: asset?.survey_id,
                survey_property_note: asset?.survey_property_note,
                capacity_status: asset?.capacity_status,
                installed_year_status: asset?.installed_year_status,
                name_plate_status: asset?.name_plate_status,
                qa_notes: asset?.qa_notes,
                additional_qa_notes: asset?.additional_qa_notes,
                surveyor: asset?.surveyor,
                editor: asset?.editor,
                survey_date_created: asset?.survey_date_created,
                survey_date_edited: asset?.survey_date_edited,
                description: asset?.asset_condition?.description,
                uniformat_level_6_id: asset?.uniformat_level_6?.id,
                uniformat_level_6_description: asset?.uniformat_level_6?.uniformat_level_6_description,
                subcategory2_description: asset?.sub_category_2?.subcategory2_description,
                capacity_unit: asset?.capacity_unit,
                refrigerant: asset?.refrigerant
            }
        });
        this.getSelectedAssetDropdowns();
        this.setState({ initialAssetFormData: _.cloneDeep(this.state.assetFormData) });
    };

    onSelectConsultancyUsers = async selectedConsultancyUsers => {
        const { project } = this.state;
        let tempUsers = [];
        if (selectedConsultancyUsers.length) {
            selectedConsultancyUsers.map(item => tempUsers.push(item.id));
        }

        await this.setState({
            project: {
                ...project,
                consultancy_user_ids: tempUsers
            },
            selectedConsultancyUsers
        });
    };

    scrollRight = event => {
        let conent = document.querySelector("#yearList");
        conent.scrollLeft += 203;
        event.preventDefault();
    };

    scrollLeft = event => {
        let conent = document.querySelector("#yearList");
        conent.scrollLeft -= 203;
        event.preventDefault();
    };

    confirmCancel = () => {
        const { costTotal, initialCostYear, priorityTotal, project } = this.state;
        if (
            _.isEqual(this.state.initialValues, this.state.project) &&
            _.isEqual(this.state.assetFormData, this.state.initialAssetFormData) &&
            _.isEqual(this.state.initialCheckListData ?? [], this.state?.checkListData ?? []) &&
            costTotal === initialCostYear &&
            priorityTotal === project.priority
        ) {
            this.cancelForm();
        } else {
            this.setState({
                showConfirmModal: true
            });
        }
    };

    handleClientSelect = async e => {
        this.setState({
            regionLoading: true
        });
        const { project } = this.state;
        let regionList = await this.props.getRegionListBasedOnClient(project.client_id);
        this.setState({
            regionList,
            project: {
                ...project,
                region_id: "",
                site_id: ""
            },
            regionLoading: false
        });
    };

    setMaintenanceYear = (e, name) => {
        const { value } = e;
        let costTotal = 0;
        let myear = this.state.project.maintenance_years;
        const oldData = myear.filter(i => i.year === name);
        if (oldData.length) {
            myear.map(i => (i.amount = i.year === name ? value : i.amount));
        } else {
            const newObject = { year: name, amount: value };
            myear.push(newObject);
        }
        this.setState({
            project: {
                ...this.state.project,
                maintenance_years: myear
            }
        });
        myear.map(item => (costTotal += Number(item.amount)));
        this.setState({
            costTotal: costTotal
        });

        // if criticality score is based on the years
        if (this.props.projectReducer.getProjectByIdResponse?.miscellaneous?.criticality_score === "year") {
            this.handleCriticalityByYear(myear);
        }
    };

    handleCriticalityByYear = years => {
        const {
            project: { criticality_id },
            criticalityData
        } = this.state;
        let selectedCriticality = criticality_id;
        const firstCostYear = years.find(year => parseInt(year.amount) > 0)?.year;
        if (firstCostYear) {
            selectedCriticality =
                criticalityData.find(c => firstCostYear >= parseFloat(c.start_range) && firstCostYear <= parseFloat(c.end_range))?.id || "";
            this.setState({ project: { ...this.state.project, criticality_id: selectedCriticality } });
        }
    };

    renderConfirmationModal = () => {
        const { showConfirmModal, selectedProject } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to ${selectedProject ? "cancel" : "clear"} and lose all changes?`}
                        type="cancel"
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={() => {
                            this.cancelForm();
                        }}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    setPriorityElement = (e, priorityId) => {
        const {
            priorityElementsData,
            criticalityData,
            project: { priority_elements, criticality_id: oldCriticalityId }
        } = this.state;

        const { name: idxStr, value } = e.target;
        const idx = parseInt(idxStr, 10);
        const newPriorityElements = priority_elements.map(item => {
            if (item.index === idx) {
                const selectedPriority = priorityElementsData.find(p => p.id === priorityId);
                const selectedOption = selectedPriority?.options?.find(o => o.id === value);

                return {
                    ...item,
                    recommendation_priority_id: priorityId,
                    option_id: selectedOption ? value : "",
                    element: selectedOption ? Number(selectedOption.value) : value ? Number(value) : ""
                };
            }
            return item;
        });

        const priorityTotal = newPriorityElements.reduce((sum, { element }) => sum + (Number(element) || 0), 0);

        let newCriticalityId = oldCriticalityId;
        const cs = this.props.projectReducer.getProjectByIdResponse?.miscellaneous?.criticality_score;

        if (cs !== "year" && priorityTotal > 0 && criticalityData.length) {
            const match = criticalityData.find(c => priorityTotal >= Number(c.start_range) && priorityTotal <= Number(c.end_range));
            newCriticalityId = match?.id || "";
        }

        this.setState({
            project: {
                ...this.state.project,
                priority_elements: newPriorityElements,
                criticality_id: newCriticalityId
            },
            priorityTotal
        });
    };

    addMaintenanceYear = () => {
        let currentState = this.state.project.maintenance_years;
        const nextYear = this.state.project.maintenance_years.length
            ? parseInt(this.state.project.maintenance_years[this.state.project.maintenance_years.length - 1].year) + 1
            : new Date().getFullYear();

        currentState.push({ year: nextYear, amount: 0.0 });
        this.setState({
            project: {
                ...this.state.project,
                maintenance_years: currentState
            }
        });
        this.handleBandClick("band3", true);
    };

    removeMaintenanceYear = item => {
        const amount = parseInt(item?.amount || 0);
        if (amount > 0) {
            this.setState({ showYearRemoveConfirmation: true, selectedRemoveYear: item });
        } else {
            this.onRemoveMaintenanceYearConfirm(item);
        }
    };

    onRemoveMaintenanceYearConfirm = item => {
        let currentState = this.state.project.maintenance_years.filter(items => items.year !== item.year);
        let currentCostTotal = this.state.costTotal;
        this.setState({
            project: {
                ...this.state.project,
                maintenance_years: currentState
            },
            costTotal: currentCostTotal - parseInt(item.amount || 0)
        });
    };

    handleRegionSelect = async e => {
        const {
            location: { search }
        } = this.props;

        const query = qs.parse(search);
        this.setState({
            siteLoading: true
        });
        const { project } = this.state;
        this.props.getDropdownList("project_sites", { project_id: query.p_id, region_id: project.region_id });
        this.setState({
            project: {
                ...project,
                site_id: "",
                building_id: "",
                building_type: "",
                addition_id: "",
                floor_id: ""
            },
            siteLoading: false
        });
    };

    handleFloorSelect = async value => {
        this.setState({
            floorLoading: true
        });
        let floorList = await this.props.getFloorBasedOnBuilding(value);
        this.setState({
            floorList,
            floorLoading: false
        });
    };
    handleAdditionSelect = async value => {
        this.setState({
            additionLoading: true
        });
        let additionList = await this.props.getAdditionBasedOnBuilding(value);
        this.setState({
            additionList,
            additionLoading: false
        });
    };

    handleSiteSelect = async site_id => {
        const {
            location: { search },
            assetReducer: { dropDownList }
        } = this.props;

        const query = qs.parse(search);
        const { project, assetFormData } = this.state;
        const sitesList = dropDownList?.project_sites || [];
        let siteObj = site_id ? (sitesList && sitesList.length ? sitesList.find(s => s.id === site_id) : null) : null;

        let newRegionId = project.region_id;
        if (siteObj && !newRegionId && siteObj.region_id) {
            newRegionId = siteObj.region_id;
        }
        this.setState({
            project: {
                ...project,
                region_id: newRegionId,
                site_id,
                building_id: "",
                building_type: "",
                addition_id: "",
                floor_id: ""
            },
            assetFormData: {
                ...assetFormData,
                region_id: newRegionId,
                site_id,
                building_id: "",
                building_type: "",
                addition_id: "",
                floor_id: ""
            }
        });
        if (newRegionId && newRegionId !== project.region_id) {
            this.props.getDropdownList("project_sites", { project_id: query.p_id, region_id: newRegionId });
        }
        this.props.getDropdownList("project_buildings", { project_id: query.p_id, site_id });
        this.getCostYear(site_id, false, { rebuildMaintenanceYears: true, confirmOutOfScopeYears: true });
    };

    handleBuildingSelect = async value => {
        const { project, assetFormData } = this.state;
        const {
            assetReducer: { dropDownList }
        } = this.props;
        const buildingsList = dropDownList?.project_buildings || [];
        let buildingObj = value ? (buildingsList && buildingsList.length ? buildingsList.find(b => b.id === value) : null) : null;

        let newRegionId = project.region_id;
        let newSiteId = project.site_id;
        if (buildingObj) {
            if (!newRegionId && buildingObj.region_id) {
                newRegionId = buildingObj.region_id;
            }
            if (!newSiteId && buildingObj.site_id) {
                newSiteId = buildingObj.site_id;
            }
        }
        this.setState({
            project: {
                ...project,
                region_id: newRegionId,
                site_id: newSiteId,
                building_id: value,
                building_type: buildingObj ? buildingObj.description : "",
                addition_id: "",
                floor_id: ""
            },
            assetFormData: {
                ...assetFormData,
                region_id: newRegionId,
                site_id: newSiteId,
                building_id: value,
                building_type: buildingObj ? buildingObj.description : "",
                addition_id: "",
                floor_id: ""
            },
            activeBuilding: value
        });

        if (newRegionId && newRegionId !== project.region_id) {
            const query = qs.parse(this.props.location.search);
            this.props.getDropdownList("project_sites", { project_id: query.p_id, region_id: newRegionId });
        }
        if (newSiteId && newSiteId !== project.site_id) {
            const query = qs.parse(this.props.location.search);
            this.props.getDropdownList("project_buildings", {
                site_id: newSiteId,
                project_id: query.p_id
            });
            this.getCostYear(newSiteId, false, { rebuildMaintenanceYears: true, confirmOutOfScopeYears: true });
        }

        this.handleAdditionSelect(value);
        this.handleFloorSelect(value);
    };

    validate = () => {
        const { project, selectedProject, assetFormData, costTotal, initialValues } = this.state;
        let showErrorBorder = false;
        let errorMessage = "";
        let failedField = null;
        let failedBand = null;
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const isEmptyValue = value => value === "" || value === null || value === undefined || !value?.toString()?.trim()?.length;
        const hasCapitalTypeWithoutId = !isEmptyValue(project.capital_type) && isEmptyValue(project.recommendation_capital_type_id);
        if (query?.is_cr === "true") {
            const { getProjectByIdResponse } = this.props.projectReducer || {};
            const { miscellaneous } = getProjectByIdResponse || {};
            const crLabel = getCapitalRequestLabel(miscellaneous);
            const crNarrativeLabel = getCapitalRequestNarrativeLabel(miscellaneous);
            const crStatusLabel = getCapitalRequestStatusLabel(miscellaneous);
            const crStatusNotesLabel = getCapitalRequestStatusNotesLabel(miscellaneous);
            const isSystem = project.recommendation_type === RECOMMENDATION_TYPES.SYSTEM;
            let validateDynamicFields = this.validateDynamicFields();
            let validateBandFields = this.validateEnergyWaterFields(true);
            let validatePriorityElementResult = this.validatePriorityElements(true);
            const crVerbError = validateFirstWord(project.description, this.getAcceptableVerbs(), crLabel);

            if (this.isFieldRequired("description", true) && !project.description?.trim()?.length) {
                                                errorMessage = `* ${crLabel} is required`;
                showErrorBorder = true;
            } else if (crVerbError) {
                errorMessage = crVerbError;
                failedField = "description";
                failedBand = FIELD_TO_BAND["description"] || null;
                showErrorBorder = true;
            } else if (this.isFieldRequired("note_html", true) && !project.note_html?.trim()?.length) {
                                                errorMessage = `* ${crNarrativeLabel} is required`;
                showErrorBorder = true;
            } else if (this.isFieldRequired("trade", true) && !project.trade_id?.trim()?.length) {
                errorMessage = "* Trade is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("system", true) && !project.system_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* System is required";
            } else if (this.isFieldRequired("sub_system", true) && !project.sub_system_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* SubSystem is required";
            } else if (this.isFieldRequired("region", true) && !project.region_id?.trim()?.length) {
                errorMessage = "* Region is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("site", true) && !project.site_id?.trim()?.length) {
                errorMessage = "* Site is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("building", true) && !project.building_id?.trim()?.length) {
                errorMessage = "* Building is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("addition", true) && !project.addition_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Addition is required";
            } else if (this.isFieldRequired("floor", true) && !project.floor_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Floor is required";
            } else if (this.isFieldRequired("room", true) && !project?.room?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Room is required";
            } else if (this.isFieldRequired("space_type", true) && !project.recommendation_space_type_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Space Type is required";
            } else if (
                !selectedProject &&
                this.isFieldRequired("project_total", true) &&
                !this.props.recommendationsReducer.getCostYearByProject.year_limits
            ) {
                showErrorBorder = true;
                errorMessage = "* No maintenance years defined for the site";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("unit", true) && !project.unit?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Unit is required";
            } else if (
                miscellaneous?.display_unit &&
                this.isFieldRequired("cost_per_unit", true) &&
                (isNaN(project.cost_per_unit) || project.cost_per_unit <= 0)
            ) {
                showErrorBorder = true;
                errorMessage = "* Cost per unit is required";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("quantity", true) && (isNaN(project.quantity) || project.quantity <= 0)) {
                showErrorBorder = true;
                errorMessage = "* Quantity is required";
            } else if (this.isFieldRequired("project_total", true) && costTotal === 0) {
                showErrorBorder = true;
                errorMessage = "* Construction Cost cannot be zero";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("options_cost", true) && isEmptyValue(project.options_cost)) {
                showErrorBorder = true;
                errorMessage = "* Opinions of Cost is required";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("occurrence", true) && isEmptyValue(project.occurrence)) {
                showErrorBorder = true;
                errorMessage = "* Number of Occurrences is required";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("total_opinions_of_cost", true) && isEmptyValue(project.total_opinions_of_cost)) {
                showErrorBorder = true;
                errorMessage = "* Total Opinions of Cost is required";
            } else if (isSystem && this.isFieldRequired("condition", true) && !project.asset_condition_id) {
                showErrorBorder = true;
                errorMessage = "* Condition is required";
            } else if (this.isFieldRequired("category", true) && !project.category_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Category is required";
            } else if (this.isFieldRequired("capital_type", true) && !project.recommendation_capital_type_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Capital Type is required";
            } else if (hasCapitalTypeWithoutId) {
                showErrorBorder = true;
                errorMessage = "* Capital Type selection is invalid";
            } else if (this.isFieldRequired("funding", true) && !project.funding_source_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Funding is required";
            } else if (this.isFieldRequired("responsibility", true) && !project.responsibility_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Responsibility is required";
            } else if (this.isFieldRequired("criticality", true) && !project.criticality_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Criticality is required";
            } else if (this.isFieldRequired("criticality_type", true) && !project.criticality_type?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Criticality Type is required";
            } else if (
                isSystem &&
                this.isFieldRequired("crv", true) &&
                (project.crv === "" || project.crv === null || project.crv === undefined || parseFloat(project.crv) <= 0)
            ) {
                showErrorBorder = true;
                errorMessage = "* CRV is required";
            } else if (this.isFieldRequired("installed_year", true) && isSystem && isEmptyValue(project.installed_year)) {
                showErrorBorder = true;
                errorMessage = "* Installed Year is required";
            } else if (this.isFieldRequired("service_life", true) && isSystem && isEmptyValue(project.service_life)) {
                showErrorBorder = true;
                errorMessage = "* Service Life is required";
            } else if (this.isFieldRequired("department", true) && !project.department_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Department is required";
            } else if (this.isFieldRequired("initiative", true) && !project.initiative_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Initiative is required";
            } else if (this.isFieldRequired("requestor", true) && !project.requestor_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Requester is required";
            } else if (this.isFieldRequired("requested_date", true) && !project.requested_date) {
                showErrorBorder = true;
                errorMessage = "* Requested Date is required";
            } else if (project.fmp === "yes" && this.isFieldRequired("fmp_id", true) && !project.fmp_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* MFP ID is required";
            } else if (project.fmp === "yes" && this.isFieldRequired("fmp_project", true) && !project.fmp_project?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* MFP Project is required";
            } else if (project.fmp === "yes" && this.isFieldRequired("fmp_track", true) && !project.fmp_track?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* MFP Track is required";
            } else if (this.isFieldRequired("cr_status", true) && !project.cr_status?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = `* ${crStatusLabel} is required`;
            } else if (this.isFieldRequired("cr_status_notes", true) && !project.cr_status_notes?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = `* ${crStatusNotesLabel} is required`;
            } else if (!validatePriorityElementResult.isValidate) {
                showErrorBorder = true;
                errorMessage = validatePriorityElementResult.errorMessage;
            } else if (!validateBandFields.isValidate) {
                showErrorBorder = true;
                errorMessage = validateBandFields.errorMessage;
            } else if (!validateDynamicFields.isValidate) {
                showErrorBorder = true;
                errorMessage = validateDynamicFields.errorMessage;
            }
        } else {
            let role = localStorage.getItem("role");
            let validatePriorityElementResult = this.validatePriorityElements();
            let validateDynamicFields = this.validateDynamicFields();
            let validateBandFields = this.validateEnergyWaterFields(false);
            const { getProjectByIdResponse } = this.props.projectReducer || {};
            const { miscellaneous } = getProjectByIdResponse || {};

            const isAsset = project.recommendation_type === RECOMMENDATION_TYPES.ASSET;
            const verbError = validateFirstWord(project.description, this.getAcceptableVerbs());
            if (!project.client_id?.trim()?.length) {
                errorMessage = "* Client is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("trade", false) && !project.trade_id?.trim()?.length) {
                errorMessage = "* Trade is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("system", false) && !project.system_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* System is required";
            } else if (this.isFieldRequired("sub_system", false) && !project.sub_system_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* SubSystem is required";
            } else if (this.isFieldRequired("description", false) && !project.description?.trim()?.length) {
                errorMessage = "* Recommendation is required";
                showErrorBorder = true;
            } else if (verbError) {
                errorMessage = verbError;
                failedField = "description";
                failedBand = FIELD_TO_BAND["description"] || null;
                showErrorBorder = true;
            } else if (this.isFieldRequired("region", false) && !project.region_id?.trim()?.length) {
                errorMessage = "* Region is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("site", false) && !project.site_id?.trim()?.length) {
                errorMessage = "* Site is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("building", false) && !project.building_id?.trim()?.length) {
                errorMessage = "* Building is required";
                showErrorBorder = true;
            } else if (this.isFieldRequired("addition", false) && !project.addition_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Addition  is required";
            } else if (this.isFieldRequired("floor", false) && !project.floor_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Floor  is required";
            } else if (this.isFieldRequired("room", false) && !project?.room?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Room  is required";
            } else if (this.isFieldRequired("space_type", false) && !project.recommendation_space_type_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Space Type is required";
            } else if (
                !selectedProject &&
                this.isFieldRequired("project_total", false) &&
                !this.props.recommendationsReducer.getCostYearByProject.year_limits
            ) {
                showErrorBorder = true;
                errorMessage = "* No maintenance years defined for the site";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("unit", false) && !project.unit?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Unit is required";
            } else if (
                miscellaneous?.display_unit &&
                this.isFieldRequired("cost_per_unit", false) &&
                (isNaN(project.cost_per_unit) || project.cost_per_unit <= 0)
            ) {
                showErrorBorder = true;
                errorMessage = "* Cost per unit is required";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("quantity", false) && (isNaN(project.quantity) || project.quantity <= 0)) {
                showErrorBorder = true;
                errorMessage = "* Quantity is required";
            } else if (this.isFieldRequired("project_total", false) && costTotal === 0) {
                showErrorBorder = true;
                errorMessage = "* Construction Cost cannot be zero";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("options_cost", false) && isEmptyValue(project.options_cost)) {
                showErrorBorder = true;
                errorMessage = "* Opinions of Cost is required";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("occurrence", false) && isEmptyValue(project.occurrence)) {
                showErrorBorder = true;
                errorMessage = "* Number of Occurrences is required";
            } else if (miscellaneous?.display_unit && this.isFieldRequired("total_opinions_of_cost", false) && isEmptyValue(project.total_opinions_of_cost)) {
                showErrorBorder = true;
                errorMessage = "* Total Opinions of Cost is required";
            } else if (this.isFieldRequired("type", false) && !project.recommendation_type?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Type is required";
            } else if (isAsset && this.isFieldRequired("asset_name", false) && !assetFormData.asset_name) {
                showErrorBorder = true;
                errorMessage = "* Asset name is required";
            } else if (isAsset && this.isFieldRequired("asset_condition", false) && !assetFormData.client_asset_condition_id) {
                showErrorBorder = true;
                errorMessage = "* Asset condition is required";
            } else if (isAsset && this.isFieldRequired("asset_tag", false) && !assetFormData.asset_tag) {
                showErrorBorder = true;
                errorMessage = "* Asset Tag is required";
            } else if (isAsset && this.isFieldRequired("serial_number", false) && !assetFormData.serial_number) {
                showErrorBorder = true;
                errorMessage = "* Serial Number is required";
            } else if (isAsset && this.isFieldRequired("model_number", false) && !assetFormData.model_number) {
                showErrorBorder = true;
                errorMessage = "* Model Number is required";
            } else if (isAsset && this.isFieldRequired("manufacturer", false) && !assetFormData.manufacturer_id) {
                showErrorBorder = true;
                errorMessage = "* Manufacturer is required";
            } else if (isAsset && this.isFieldRequired("capacity", false) && !assetFormData.capacity) {
                showErrorBorder = true;
                errorMessage = "* Capacity is required";
            } else if (isAsset && this.isFieldRequired("capacity_unit", false) && !assetFormData.capacity_unit) {
                showErrorBorder = true;
                errorMessage = "* Capacity unit is required";
            } else if (isAsset && this.isFieldRequired("refrigerant", false) && !assetFormData.refrigerant) {
                showErrorBorder = true;
                errorMessage = "* Refrigerant is required";
            } else if (project.recommendation_type === RECOMMENDATION_TYPES.SYSTEM && this.isFieldRequired("condition", false) && !project.asset_condition_id) {
                showErrorBorder = true;
                errorMessage = "* Condition is required";
            } else if (this.isFieldRequired("category", false) && !project.category_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Category is required";
            } else if (this.isFieldRequired("capital_type", false) && !project.recommendation_capital_type_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Capital Type is required";
            } else if (hasCapitalTypeWithoutId) {
                showErrorBorder = true;
                errorMessage = "* Capital Type selection is invalid";
            } else if (this.isFieldRequired("funding", false) && !project.funding_source_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Funding is required";
            } else if (this.isFieldRequired("responsibility", false) && !project.responsibility_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Responsibility is required";
            } else if (this.isFieldRequired("criticality", false) && !project.criticality_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Criticality is required";
            } else if (this.isFieldRequired("criticality_type", false) && !project.criticality_type?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Criticality Type is required";
            } else if (
                project.recommendation_type === RECOMMENDATION_TYPES.SYSTEM &&
                this.isFieldRequired("crv", false) &&
                (project.crv === "" || project.crv === null || project.crv === undefined || parseFloat(project.crv) <= 0)
            ) {
                showErrorBorder = true;
                errorMessage = "* CRV is required";
            } else if (this.isFieldRequired("note_html", false) && !project?.note_html?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Recommendation narrative is required";
            } else if (this.isFieldRequired("inspection_date", false) && !project.inspection_date) {
                showErrorBorder = true;
                errorMessage = "* Inspection date is required";
            } else if (project.inspection_date && !moment(project.inspection_date).isValid()) {
                showErrorBorder = true;
                errorMessage = "* Invalid inspection date";
            } else if (this.isFieldRequired("recommendation_status_id", false) && !project.status) {
                showErrorBorder = true;
                errorMessage = "* Status is required";
            } else if (this.isFieldRequired("status_notes", false) && !project.status_notes?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Status Notes is required";
            } else if (
                this.isFieldRequired("installed_year", false) &&
                ((isAsset && isEmptyValue(assetFormData.installed_year)) ||
                    (project.recommendation_type === RECOMMENDATION_TYPES.SYSTEM && isEmptyValue(project.installed_year)))
            ) {
                showErrorBorder = true;
                errorMessage = "* Installed Year is required";
            } else if (
                this.isFieldRequired("service_life", false) &&
                ((isAsset && isEmptyValue(assetFormData.service_life)) ||
                    (project.recommendation_type === RECOMMENDATION_TYPES.SYSTEM && isEmptyValue(project.service_life)))
            ) {
                showErrorBorder = true;
                errorMessage = "* Service Life is required";
            } else if (this.isFieldRequired("department", false) && !project.department_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Department is required";
            } else if (this.isFieldRequired("initiative", false) && !project.initiative_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Initiative is required";
            } else if (this.isFieldRequired("surveyor", false) && !project.surveyor_id?.toString()?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* Surveyor is required";
            } else if (project.fmp === "yes" && this.isFieldRequired("fmp_id", false) && !project.fmp_id?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* MFP ID is required";
            } else if (project.fmp === "yes" && this.isFieldRequired("fmp_project", false) && !project.fmp_project?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* MFP Project is required";
            } else if (project.fmp === "yes" && this.isFieldRequired("fmp_track", false) && !project.fmp_track?.trim()?.length) {
                showErrorBorder = true;
                errorMessage = "* MFP Track is required";
            } else if (
                selectedProject &&
                initialValues.status !== project.status &&
                (!project.status_notes?.trim() || initialValues.status_notes === project.status_notes) &&
                !!miscellaneous?.status_notes
            ) {
                showErrorBorder = true;
                errorMessage = "* Status notes must be updated to fit the current status";
            } else if (!project.code && role === "super_admin" && selectedProject) {
                showErrorBorder = true;
                errorMessage = "* Code is required";
            } else if (project.code && role === "super_admin" && !project.code?.split("-")[2]) {
                showErrorBorder = true;
                errorMessage = "* Invalid code format";
            } else if (!validatePriorityElementResult.isValidate) {
                showErrorBorder = true;
                errorMessage = validatePriorityElementResult.errorMessage;
            } else if (!validateBandFields.isValidate) {
                showErrorBorder = true;
                errorMessage = validateBandFields.errorMessage;
            } else if (!validateDynamicFields.isValidate) {
                showErrorBorder = true;
                errorMessage = validateDynamicFields.errorMessage;
            }

            if (!showErrorBorder && miscellaneous?.checklist_survey) {
                const { valid: checklistValid, errors: checklistErrors } = this.validateChecklists();
                if (!checklistValid) {
                    const first = checklistErrors[0];
                    showErrorBorder = true;
                    errorMessage = first.message || "Please fix checklist structure before saving.";
                }
            }
        }

        const isCRForm = qs.parse(this.props.location.search)?.is_cr === "true";
        const verbFieldLabel = isCRForm
            ? getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous)
            : "Recommendation";
        this.setState({
            showErrorBorder,
            errorMessage,
            liveVerbError: validateFirstWord(project.description, this.getAcceptableVerbs(), verbFieldLabel)
        });
        if (showErrorBorder) {
            return false;
        }
        return true;
    };

    validateChecklists = () => {
        const { checkListData } = this.state;
        const errors = [];

        if (!Array.isArray(checkListData) || checkListData.length === 0) {
            return { valid: true, errors: [] };
        }
        checkListData.forEach(p => {
            const partyHasItems = Array.isArray(p.checklists) && p.checklists.length > 0;
            const subs = Array.isArray(p.subBands) ? p.subBands : [];
            const anySubHasItems = subs.some(s => Array.isArray(s.checklists) && s.checklists.length > 0);

            if (!partyHasItems && !anySubHasItems) {
                errors.push({
                    type: "party",
                    partyId: p.id,
                    message: `Checklist Error: Party "${p.title}" does not contain any checklist items.`
                });
            } else {
                subs.forEach(s => {
                    if (!Array.isArray(s.checklists) || s.checklists.length === 0) {
                        errors.push({
                            type: "subband",
                            partyId: p.id,
                            subId: s.id,
                            message: `Checklist Error: Sub-band "${s.title}" under party "${p.title}" does not contain any checklist items.`
                        });
                    }
                });
            }
        });

        return { valid: errors.length === 0, errors };
    };

    validatePriorityElements = (isCR = false) => {
        const { priorityElementsData, project } = this.state;
        let isValidate = true;
        let errorMessage = "";
        priorityElementsData &&
            priorityElementsData.map((pElement, index) => {
                const required = isCR ? this.isFieldRequired(priorityElementFieldName(pElement, index), true) : pElement.recommendation_required;
                if (
                    required &&
                    (!project.priority_elements[index]?.element || !project.priority_elements[index]?.element.toString()?.trim()?.length) &&
                    project.priority_elements[index]?.element !== 0
                ) {
                    isValidate = false;
                    if (errorMessage === "") {
                        errorMessage = `* ${pElement.display_name} is required`;
                    }
                }
            });
        return { isValidate, errorMessage };
    };

    // Holds a SINGLE promise for the whole episode, however many times the surveyor hits "Validate
    // again" — one promise per save is what keeps a re-run from stranding the original.
    qaGate = async () => {
        // Flagged off for this user: no status is recorded, so a stale verdict from an earlier save in the
        // same session cannot be sent as if it described this one.
        if (!isOttoValidationEnabled()) {
            this.setState({ qaValidationStatus: null });
            return true;
        }
        if (await this.runQaQcValidation()) return true;
        return new Promise(resolve => {
            this.qaResolver = resolve;
        });
    };

    // Returns TRUE only when the save may go straight through. Never throws: a transport error, 403, 429
    // or timeout must NEVER be treated as `findings: []` — Otto's uptime must not become the
    // recommendation module's uptime — so those surface as "Validation incomplete" instead.
    runQaQcValidation = async () => {
        const { project, assetFormData } = this.state;
        const {
            assetReducer: { dropDownList },
            recommendationsReducer,
            location: { search }
        } = this.props;

        // The Asset band and the Additional Details band read from DIFFERENT condition lists — the same
        // split the id/name conversion elsewhere in this file already has to handle.
        const conditionOptions =
            project.recommendation_type === RECOMMENDATION_TYPES.ASSET
                ? dropDownList?.asset_conditions
                : recommendationsReducer?.getConditionBasedOnProject?.asset_conditions;

        const query = qs.parse(search);
        const payload = buildDraftPayload({
            project,
            assetFormData,
            conditionOptions: conditionOptions || [],
            projectId: query.p_id || "",
            // Set on the edit path, null while creating — the form carries the recommendation's own id as
            // `selectedProject`, taken from the route param.
            recommendationId: this.state.selectedProject
        });

        // A blank narrative, or nothing recorded to contradict it, has no possible finding. Returning early
        // still saves the round trip — but it no longer returns SILENTLY. A save that went through with no
        // modal at all was indistinguishable from one Otto had validated, which is the same confusion a
        // skipped rule caused on the server side: the surveyor is told what was not checked, and why.
        if (!isWorthChecking(payload)) {
            this.setState({
                qaState: ValidationModal.STATE.CLEAN,
                qaFindings: [],
                qaFailed: [],
                qaChecked: [],
                qaSkipped: localSkipReasons(payload),
                qaValidationStatus: QA_VALIDATION_STATUS.PASSED
            });
            // The shorter beat: these two reasons are facts the surveyor can see on the form in front of
            // them, unlike a rule Otto ran and could not read.
            await new Promise(resolve => setTimeout(resolve, QA_CLEAN_HOLD_MS));
            this.setState({ qaState: null });
            return true;
        }

        this.setState({ qaState: ValidationModal.STATE.CHECKING, qaFindings: [], qaFailed: [], qaChecked: [], qaSkipped: [] });

        let verdict = null;
        let refusal = null;
        try {
            verdict = await checkQaQcDraft(payload);
        } catch (err) {
            // A 403 USED TO PASS SILENTLY, on the reasoning that the check simply was not for this user.
            // It cannot any more: the endpoint admits anyone holding `forms.recommendations.create` — the
            // same permission that put this form on the screen — so if it refuses someone who is standing
            // here creating a recommendation, something is actually wrong (a misconfigured verify URL, a
            // permission blob that never arrived), and every recommendation saved meanwhile is going
            // unchecked with nobody able to tell.
            //
            // So it is surfaced like any other non-answer: the modal says what happened and the surveyor
            // decides. It deliberately does NOT block the save — Otto's uptime must not become the
            // recommendation module's uptime — but it is no longer invisible.
            if (err?.response?.status === 403) {
                refusal = {
                    message:
                        "Otto would not validate this recommendation for your account, so the check did not run. Please report this."
                };
            }
        }

        // The judgement lives in `validationOutcome.js` so it can be tested without standing up this
        // component. Every branch below decides whether a recommendation may be saved, and the failure
        // mode of getting one wrong is a save that goes through looking checked when nothing checked it.
        const { outcome, status, findings, failed, checked, skipped } = decideQaOutcome({ verdict, refusal });

        if (outcome === QA_OUTCOME.FINDINGS) {
            this.setState({
                qaState: ValidationModal.STATE.FINDINGS,
                qaFindings: findings,
                qaFailed: failed,
                qaChecked: checked,
                qaSkipped: skipped,
                qaValidationStatus: status
            });
            return false;
        }

        if (outcome === QA_OUTCOME.INCOMPLETE) {
            this.setState({
                qaState: ValidationModal.STATE.FAILED,
                qaFindings: [],
                qaFailed: failed,
                qaChecked: checked,
                qaSkipped: skipped,
                qaValidationStatus: status
            });
            return false;
        }

        // A clean result that compared NOTHING holds longer: the modal is explaining why Otto had nothing
        // to look at, and that is a sentence to read rather than a tick to acknowledge. It still closes
        // itself and still saves — see `nothingWasChecked`.
        this.setState({
            qaState: ValidationModal.STATE.CLEAN,
            qaChecked: checked,
            qaSkipped: skipped,
            qaValidationStatus: status
        });
        const hold = nothingWasChecked({ checked, skipped }) ? QA_NOTHING_CHECKED_HOLD_MS : QA_CLEAN_HOLD_MS;
        await new Promise(resolve => setTimeout(resolve, hold));
        this.setState({ qaState: null });
        return true;
    };

    renderQaValidationModal = () => {
        const { qaState, qaFindings, qaFailed, qaChecked, qaSkipped, project } = this.state;
        if (!qaState) return null;
        const subject = [project.code, project.description].filter(Boolean).join(" · ");
        return (
            <ValidationModal
                state={qaState}
                findings={qaFindings}
                failed={qaFailed}
                checked={qaChecked}
                skipped={qaSkipped}
                subject={subject}
                onClose={() => this.closeQaValidation(false)}
                onValidateAgain={this.revalidateQaValidation}
                onSaveAsIs={this.saveQaValidationAsIs}
            />
        );
    };

    // The setState callback is required: closeQaValidation resolves the promise qaGate awaits, and the save
    // paths read qaValidationStatus on the next line — resolving in the same tick sends the stale status.
    saveQaValidationAsIs = () => {
        if (this.state.qaState === ValidationModal.STATE.FINDINGS) {
            this.setState({ qaValidationStatus: QA_VALIDATION_STATUS.OVERRIDDEN }, () => this.closeQaValidation(true));
            return;
        }
        this.closeQaValidation(true);
    };

    // `proceed` false leaves the surveyor on the form with the modal closed; nothing is saved.
    closeQaValidation = (proceed = false) => {
        this.setState({ qaState: null });
        if (this.qaResolver) {
            const resolve = this.qaResolver;
            this.qaResolver = null;
            resolve(proceed);
        }
    };

    // The original save is still waiting on `qaResolver`, which this deliberately leaves in place: a pass
    // that finds something again re-renders the modal and the same promise keeps waiting.
    revalidateQaValidation = async () => {
        if (await this.runQaQcValidation()) this.closeQaValidation(true);
    };

    addProject = async () => {
        try {
            let {
                project: { asset, ...rest },
                selectedImage,
                initialValues,
                checkListData,
                selectedProject,
                parentRecommendationId
            } = this.state;
            const {
                location: { search }
            } = this.props;
            const query = qs.parse(search);
            const { handleAddRecommendations } = this.props;
            if (this.validate()) {
                if (!(await this.qaGate())) return;
                // Re-read after the gate: the validation panel is draggable, so the form stays editable
                // while it is open and anything destructured above is a pre-fix snapshot.
                ({ asset, ...rest } = this.state.project);
                checkListData = this.state.checkListData;
                this.setState({ loading: true });
                if (rest.recommendation_type === RECOMMENDATION_TYPES.ASSET) {
                    const managedRest = await this.manageAssetData(asset, rest);
                    if (!managedRest) {
                        this.setState({ loading: false });
                        return;
                    }
                    rest = managedRest;
                } else {
                    rest.asset_id = "";
                }
                rest.dynamic_fields = toArrayOfObjects(rest.dynamic_fields || {});
                // Nothing renders this yet; recorded so the planned Data Validation line and Ready-for-QA
                // gate can read it without re-opening the save path.
                rest.otto_validation_status = this.state.qaValidationStatus;
                if (rest.check_list?.length || checkListData?.length) {
                    rest.check_list = denormalizeToFlat(checkListData);
                }
                if (selectedProject || parentRecommendationId) {
                    const recomID = selectedProject || parentRecommendationId;
                    let redirectUrl = findInfoPathFromBreadCrump();
                    if (redirectUrl?.length === 3) {
                        addToBreadCrumpData({
                            key: "Name",
                            name: this.state.project.code,
                            path: `/recommendations/recommendationsinfo/${recomID}/${
                                this.state.activeDetail === "Main Details" ? "maindetails" : "additionaldetails"
                            }`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: `${this.state.activeDetail === "Main Details" ? "Main Details" : "Additional Details"}`,
                            path: `/recommendations/recommendationsinfo/${recomID}/${
                                this.state.activeDetail === "Main Details" ? "maindetails" : "additionaldetails"
                            }`
                        });
                    }
                    let newData = {};
                    // newData.code = rest.code;
                    newData.building_id = rest.building_id;
                    newData.recommendation_type = rest.recommendation_type;
                    Object.entries(rest).forEach(([key, value]) => {
                        if (!_.isEqual(value, initialValues[key])) {
                            if (key === "manufacturer_id") {
                                newData[key] = value;
                            } else {
                                newData[key] = value;
                            }
                        }
                    });
                    if (query?.is_cr === "true") {
                        newData.is_cr = true;
                    }
                    if (query?.is_mr === "true") {
                        newData.is_mr = true;
                        if (query?.s_id !== undefined && query?.s_id !== null && query?.s_id !== "") {
                            newData.survey_recommendation_id = query?.s_id;
                        }
                    }

                    this.props.setFormDirty(false);
                    this.setState({ isAddOrEdit: false });

                    await this.props.handleUpdateRecommendations(newData, selectedImage, recomID);
                    this.setState({ loading: false });
                } else {
                    if (qs.parse(search)?.is_assignedRecom !== "true" || qs.parse(search)?.type === "Regular") popBreadCrumpData();

                    this.props.setFormDirty(false);
                    this.setState({ isAddOrEdit: false });
                    await handleAddRecommendations({
                        ...rest,
                        ...(query?.is_cr === "true"
                            ? {
                                  is_cr: true,
                                  ...(query?.type === RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE ? {} : { cr_status: CAPITAL_REQUEST_STATUS[0]?.id })
                              }
                            : {}),
                        ...(query?.is_mr === "true" ? { is_mr: true } : {}),
                        ...(query?.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST ? { capital_request_id: query?.capital_request_id } : {}),
                        ...(RECOMMENDATION_CREATION_METHODS[query?.type] && query?.source_recommendation_id
                            ? {
                                  source_recommendation_id: query.source_recommendation_id,
                                  creation_method: RECOMMENDATION_CREATION_METHODS[query.type]
                              }
                            : {})
                    });
                    this.setState({ loading: false });
                }
                // get dashboard api call to update count in side panel
                const {
                    dashboardFilterParams = {},
                    individualFilters = {},
                    tempChartFilters = {},
                    tempQueryChartFilters = {}
                } = this.props.dashboardReducer;
                this.props.getDashboard(
                    getCleanParams(
                        {
                            ...dashboardFilterParams,
                            ...individualFilters,
                            ...tempChartFilters,
                            ...tempQueryChartFilters
                        },
                        "dashboard"
                    )
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    renderAssetRenameModal = () => {
        const { showAssetRenameModal, assetFormData, initialAssetFormData } = this.state;
        if (!showAssetRenameModal) return null;
        const assetCode = initialAssetFormData?.code || assetFormData?.code;
        return (
            <Portal
                body={
                    <ChoiceModal
                        heading="Asset name changed"
                        message={
                            <>
                                This asset {assetCode && <>(<strong>{assetCode}</strong>) </>}may{" "}
                                <strong>ALSO</strong> be linked to other recommendations.
                            </>
                        }
                        comparison={{
                            from: initialAssetFormData?.asset_name,
                            to: assetFormData?.asset_name
                        }}
                        prompt="Please pick one of the following two options:"
                        choices={[
                            {
                                value: "update",
                                label: "Update existing asset",
                                note: "Renames the asset everywhere it is being used."
                            },
                            {
                                value: "create",
                                label: "Create a new asset",
                                note: (
                                    <>
                                        Leaves the original asset unchanged and creates a <strong>NEW</strong> asset,
                                        duplicating the current asset.
                                    </>
                                )
                            }
                        ]}
                        onSelection={this.onAssetRenameSelection}
                        onCancel={() => this.resolveAssetRename("cancel")}
                    />
                }
                onCancel={() => this.resolveAssetRename("cancel")}
            />
        );
    };

    renderAssetTagReuseModal = () => {
        const { showAssetTagReuseModal, assetTagReuseFields = [], assetTagReuseEdits = {}, isEditingAssetTagReuse } = this.state;
        if (!showAssetTagReuseModal) return null;
        const fieldText = assetTagReuseFields.map(({ label, value }) => `${label} ("${value}")`).join(" and ");
        const isUnchanged = ({ key, value }) => (assetTagReuseEdits[key] || "") === value;
        const fieldNames = assetTagReuseFields.map(({ label }) => label).join(" and ");
        const choices = isEditingAssetTagReuse
            ? [
                  {
                      value: "save",
                      label: "Create new asset",
                      note: "Creates the new asset with the values entered above",
                      tone: "primary",
                      disabled: assetTagReuseFields.some(isUnchanged)
                  }
              ]
            : [
                  { value: "edit", label: "Let me edit them", note: "Change them here before the asset is created" },
                  {
                      value: "create",
                      label: "Keep them anyway",
                      note: "Create the new asset with the same values"
                  }
              ];
        return (
            <Portal
                body={
                    <ChoiceModal
                        heading={
                            isEditingAssetTagReuse
                                ? `Edit ${fieldNames}`
                                : `${assetTagReuseFields.length > 1 ? "Asset Tag and Serial Number are" : `${assetTagReuseFields[0]?.label} is`} still the same`
                        }
                        message={
                            isEditingAssetTagReuse
                                ? `Enter a different ${fieldNames} for the new asset.`
                                : `The new asset would reuse the same ${fieldText} as the original. These are normally unique to one asset.`
                        }
                        fields={
                            isEditingAssetTagReuse
                                ? assetTagReuseFields.map(field => ({
                                      key: field.key,
                                      label: field.label,
                                      value: assetTagReuseEdits[field.key] || "",
                                      invalid: isUnchanged(field)
                                  }))
                                : []
                        }
                        onFieldChange={(key, value) =>
                            this.setState(prevState => ({
                                assetTagReuseEdits: { ...prevState.assetTagReuseEdits, [key]: value }
                            }))
                        }
                        choices={choices}
                        onSelection={this.onAssetTagReuseSelection}
                        onBack={
                            isEditingAssetTagReuse
                                ? () =>
                                      this.setState({
                                          isEditingAssetTagReuse: false,
                                          assetTagReuseEdits: assetTagReuseFields.reduce(
                                              (acc, { key, value }) => ({ ...acc, [key]: value }),
                                              {}
                                          )
                                      })
                                : undefined
                        }
                        onCancel={() => this.resolveAssetRename("cancel")}
                    />
                }
                onCancel={() => this.resolveAssetRename("cancel")}
            />
        );
    };

    renderAssetRenameConfirmModal = () => {
        const { assetRenameConfirmChoice, assetFormData, initialAssetFormData, assetTagReuseFields = [] } = this.state;
        if (!assetRenameConfirmChoice) return null;
        const isUpdate = assetRenameConfirmChoice === "update";
        const cameFromTagReuse = !isUpdate && !!assetTagReuseFields.length;
        return (
            <Portal
                body={
                    <ChoiceModal
                        heading={
                            isUpdate
                                ? "Are you sure you want to rename this asset?"
                                : "Are you sure you want to create a new asset?"
                        }
                        message={
                            isUpdate ? (
                                "This will rename the asset everywhere it is being used. This action cannot be reverted."
                            ) : (
                                <>
                                    A new asset <strong>{assetFormData?.asset_name}</strong> will be created, duplicating
                                    the current asset. <strong>{initialAssetFormData?.asset_name}</strong> stays unchanged.
                                </>
                            )
                        }
                        comparison={
                            isUpdate
                                ? {
                                      from: initialAssetFormData?.asset_name,
                                      to: assetFormData?.asset_name,
                                      changeLabel: "will be renamed to"
                                  }
                                : undefined
                        }
                        choices={[
                            { value: "confirm", label: "Yes", tone: "primary" },
                            { value: "no", label: "No" }
                        ]}
                        onSelection={choice =>
                            choice === "confirm"
                                ? this.commitAssetRename(assetRenameConfirmChoice)
                                : this.setState({
                                      assetRenameConfirmChoice: null,
                                      showAssetTagReuseModal: cameFromTagReuse,
                                      showAssetRenameModal: !cameFromTagReuse
                                  })
                        }
                        hideCancel
                        onCancel={() => this.commitAssetRename("cancel")}
                    />
                }
                onCancel={() => this.commitAssetRename("cancel")}
            />
        );
    };

    createAssetForRecommendation = async (assetData, rest) => {
        const { selectedProject, project } = this.state;
        let payload = { ...assetData };
        if (payload.auxiliary && Object.values(payload.auxiliary).filter(e => e).length) {
            payload = {
                ...payload,
                asset_auxiliary: {
                    auxiliary: [
                        {
                            ...payload.auxiliary
                        }
                    ]
                }
            };
            delete payload.auxiliary;
        }
        if (selectedProject) {
            payload.client_id = project.client_id;
        }
        await this.props.addData(payload);
        const { asset_id, success, error, message } = this.props.assetReducer.addDataResponse || {};
        if (!asset_id || success === false || error) {
            this.setState({ alertMessage: message || error || "Failed to create the new asset" }, () => this.showAlert());
            return null;
        }
        rest.asset_id = asset_id;
        return rest;
    };

    isAssetRenamed = () => {
        const { assetFormData, initialAssetFormData } = this.state;
        return (assetFormData?.asset_name || "") !== (initialAssetFormData?.asset_name || "");
    };

    confirmAssetRename = () =>
        new Promise(resolve => {
            this.setState({ showAssetRenameModal: true, pendingAssetRename: { resolve } });
        });

    resolveAssetRename = choice => {
        if (choice === "update" || choice === "create") {
            this.setState({
                showAssetRenameModal: false,
                showAssetTagReuseModal: false,
                assetRenameConfirmChoice: choice
            });
            return;
        }
        this.commitAssetRename(choice);
    };

    commitAssetRename = choice => {
        const { pendingAssetRename } = this.state;
        this.setState({
            showAssetRenameModal: false,
            showAssetTagReuseModal: false,
            isEditingAssetTagReuse: false,
            assetRenameConfirmChoice: null,
            pendingAssetRename: null
        });
        if (pendingAssetRename?.resolve) pendingAssetRename.resolve(choice);
    };

    onAssetRenameSelection = choice => {
        if (choice !== "create") {
            this.resolveAssetRename(choice);
            return;
        }
        const { assetFormData, initialAssetFormData } = this.state;
        const reusedFields = [
            { key: "asset_tag", label: "Asset Tag" },
            { key: "serial_number", label: "Serial Number" }
        ]
            .map(({ key, label }) => ({ key, label, value: assetFormData?.[key], unchanged: assetFormData?.[key] === initialAssetFormData?.[key] }))
            .filter(({ value, unchanged }) => value && unchanged);
        if (!reusedFields.length) {
            this.resolveAssetRename("create");
            return;
        }
        this.setState({
            showAssetRenameModal: false,
            showAssetTagReuseModal: true,
            assetTagReuseFields: reusedFields,
            assetTagReuseEdits: reusedFields.reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {}),
            isEditingAssetTagReuse: false
        });
    };

    onAssetTagReuseSelection = choice => {
        if (choice === "edit") {
            this.setState({ isEditingAssetTagReuse: true });
            return;
        }
        if (choice !== "save") {
            this.resolveAssetRename(choice);
            return;
        }
        const { assetTagReuseEdits = {} } = this.state;
        this.setState(
            prevState => ({ assetFormData: { ...prevState.assetFormData, ...assetTagReuseEdits } }),
            () => this.resolveAssetRename("create")
        );
    };

    manageAssetData = async (asset, rest) => {
        let assetFormData = this.state.assetFormData;
        const { initialAssetFormData, selectedProject, project } = this.state;
        assetFormData.dynamic_fields = toArrayOfObjects(assetFormData.dynamic_fields || {});
        if (asset?.id && this.isAssetRenamed()) {
            const choice = await this.confirmAssetRename();
            if (choice !== "update" && choice !== "create") return null;
            if (choice === "create") {
                // assetFormData was read before the await; the tag-reuse step may have edited it since
                const newAssetData = { ...assetFormData, ...this.state.assetFormData };
                delete newAssetData.id;
                newAssetData.code = "";
                return this.createAssetForRecommendation(newAssetData, rest);
            }
        }
        if (!asset.id) {
            if (assetFormData.auxiliary && Object.values(assetFormData.auxiliary).filter(e => e).length) {
                assetFormData = {
                    ...assetFormData,
                    asset_auxiliary: {
                        auxiliary: [
                            {
                                ...assetFormData.auxiliary
                            }
                        ]
                    }
                };
                delete assetFormData.auxiliary;
            }
            if (selectedProject) {
                assetFormData.client_id = project.client_id;
            }
            await this.props.addData(assetFormData);
            const { asset_id } = this.props.assetReducer.addDataResponse;
            rest.asset_id = asset_id;
        } else if (!_.isEqual(this.state.assetFormData, this.state.initialAssetFormData)) {
            let newData = {};
            newData.asset_name = assetFormData.asset_name;
            newData.latest_source = ASSET_SOURCES.RECOMMENDATION;
            Object.entries(assetFormData).map(([key, value]) => {
                if (value !== initialAssetFormData[key]) {
                    newData[key] = value;
                }
            });
            if (newData.auxiliary && Object.values(newData.auxiliary).filter(e => e).length) {
                newData = {
                    ...newData,
                    asset_auxiliary: {
                        auxiliary: [
                            {
                                ...newData.auxiliary
                            }
                        ]
                    }
                };
                delete newData.auxiliary;
            }
            await this.props.updateData(asset?.id, newData);
            rest.asset_id = asset?.id;
        } else {
            rest.asset_id = asset?.id;
        }
        return rest;
    };

    updateProject = async () => {
        const { handleUpdateRecommendations } = this.props;
        if (this.validate()) {
            if (!(await this.qaGate())) return;
            await handleUpdateRecommendations({ ...this.state.project, otto_validation_status: this.state.qaValidationStatus });
        }
    };

    cancelForm = () => {
        this.props.setFormDirty(false);
        // this.setState({ isAddOrEdit: false });
        const { history } = this.props;

        setTimeout(() => {
            popBreadCrumpData();
            let redirectUrl = findInfoPathFromBreadCrump() || [];

            if (!this.props.isChartView) {
                history.push(redirectUrl[redirectUrl.length - 1]?.path || "/recommendations");
            } else {
                history.push(redirectUrl[6]?.path || "/recommendations");
            }
        }, 500);
    };

    getSubSystem = systemId => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        this.props.getSubSystemBasedOnProject(query.p_id, systemId);
    };

    clearForm = async () => {
        await this.setState({
            project: {
                consultancy_user_ids: [],
                client_id: "",
                name: "",
                comments: "",
                region_id: ""
            },
            selectedClient: {},
            selectedConsultancyUsers: []
        });
    };

    isIterable = obj => {
        if (obj == null) {
            return false;
        }
        return typeof obj[Symbol.iterator] === "function";
    };

    handleAddAttachment = e => {
        this.setState({
            imageUploadModal: true
        });
    };

    setActiveTab = activeTab => {
        this.setState({ activeDetail: activeTab }, () => ReactTooltip.rebuild());
    };

    handleIdentifier = value => {
        this.setState({ project: { recommendationIdentifier: value } });
    };

    handleRecomentation = value => {
        this.setState({ project: { recommendation: value } });
    };

    getRebuiltSiteCspYears = (costPerYear, previousYears = []) => {
        const start = parseInt(costPerYear.start);
        const end = parseInt(costPerYear.end);
        const previousYearMap = previousYears.reduce((acc, item) => {
            acc[parseInt(item.year)] = item;
            return acc;
        }, {});
        const maintenanceYears = [];
        const outOfScopeValuedYears = [];

        for (let year = start; year <= end; year++) {
            maintenanceYears.push({ year, amount: previousYearMap[year]?.amount ?? "" });
        }

        const outOfScopeYears = previousYears
            .map(item => ({ ...item, year: parseInt(item.year) }))
            .filter(item => item.year < start || item.year > end)
            .sort((a, b) => a.year - b.year);

        let yearRun = [];
        const addRunIfValued = () => {
            if (yearRun.some(item => Number(item.amount) > 0)) {
                outOfScopeValuedYears.push(...yearRun);
            }
        };

        outOfScopeYears.forEach(item => {
            const previousYear = yearRun[yearRun.length - 1]?.year;
            if (yearRun.length && item.year !== previousYear + 1) {
                addRunIfValued();
                yearRun = [];
            }
            yearRun.push(item);
        });
        addRunIfValued();

        return { maintenanceYears, outOfScopeValuedYears };
    };

    applySiteCspYearChange = ({ maintenanceYears, siteCspYears, outOfScopeValuedYears = [] }, keepOutOfScopeYears = false) => {
        const finalMaintenanceYears = keepOutOfScopeYears
            ? [...maintenanceYears, ...outOfScopeValuedYears].sort((a, b) => parseInt(a.year) - parseInt(b.year))
            : maintenanceYears;
        const costTotal = finalMaintenanceYears.reduce((total, item) => total + Number(item.amount), 0);

        this.setState({
            project: {
                ...this.state.project,
                maintenance_years: finalMaintenanceYears
            },
            siteCspYears,
            costTotal,
            pendingSiteCspYearChange: null
        });
    };

    getCostYear = async (site_id = "", resetMaintenanceYears = false, options = {}) => {
        if (!site_id) {
            this.setState({
                siteCspYears: { start: "", end: "" },
                pendingSiteCspYearChange: null
            });
            return;
        }
        const {
            location: { search }
        } = this.props;

        let costPerYear = {};
        const query = qs.parse(search);
        await this.props.getCostYearByProject(query.p_id, site_id || this.state.project.site_id);
        costPerYear = this.props.recommendationsReducer?.getCostYearByProject?.year_limits;
        if (costPerYear?.start && costPerYear?.end) {
            if (options.rebuildMaintenanceYears) {
                const previousYears = resetMaintenanceYears ? [] : [...(this.state.project.maintenance_years || [])];
                const siteCspYears = { start: costPerYear?.start, end: costPerYear?.end };
                const { maintenanceYears, outOfScopeValuedYears } = this.getRebuiltSiteCspYears(costPerYear, previousYears);
                const pendingSiteCspYearChange = { maintenanceYears, siteCspYears, outOfScopeValuedYears };

                if (options.confirmOutOfScopeYears && outOfScopeValuedYears.length) {
                    this.setState({ pendingSiteCspYearChange });
                    return;
                }

                this.applySiteCspYearChange(pendingSiteCspYearChange);
                return;
            }

            let currentState = resetMaintenanceYears ? [] : [...(this.state.project.maintenance_years || [])];
            for (let i = costPerYear.start; i <= costPerYear.end; i++) {
                const index = currentState.findIndex(item => item.year === i);
                if (index === -1) {
                    let insertIndex = 0;
                    while (insertIndex < currentState.length && currentState[insertIndex].year < i) {
                        insertIndex++;
                    }
                    currentState.splice(insertIndex, 0, { year: i, amount: "" });
                }
            }
            await this.setState({
                project: {
                    ...this.state.project,
                    maintenance_years: currentState
                },
                siteCspYears: { start: costPerYear?.start, end: costPerYear?.end }
            });
        } else {
            await this.setState({
                alertMessage: "No maintenance years defined for this site.",
                siteCspYears: { start: "", end: "" },
                pendingSiteCspYearChange: null
            });
            this.showLongAlert();
        }
    };

    showLongAlert = () => showAlertUtil(this.state.alertMessage, true);

    handleImage = e => {};

    deleteImage = () => {
        this.setState({
            attachmentChanged: true,
            project: {
                ...this.state.project,
                image: null,
                img_desc: null,
                image_id: null,
                image_name: ""
            },
            selectedImage: null
        });
    };

    handleAddImage = imageData => {
        this.setState({
            uploadError: "",
            imageUploadModal: false
        });
        if (!imageData.id) {
            this.setState({
                attachmentChanged: true,
                project: {
                    ...this.state.project,
                    image: imageData.file,
                    img_desc: imageData.comments
                },
                previewImage: URL.createObjectURL(imageData.file)
            });
        } else if (imageData.comments) {
            this.setState({
                project: {
                    ...this.state.project,
                    img_desc: imageData.comments
                }
            });
        }
    };

    handleTrade = async (tradeId, systemId = "", subSystemId = "") => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        this.setState({
            systemLoading: true,
            subSystemLoading: true
        });
        await Promise.all([
            this.props.getSystemBasedOnProject(query.p_id, tradeId),
            this.props.getSubSystemBasedOnProject(query.p_id, null, tradeId)
        ]);
        const systemData = this.props.recommendationsReducer?.getSystemByProject?.systems || [];
        const subSystemData = this.props.recommendationsReducer?.getSubSystemByProject?.sub_systems || [];

        this.setState({
            project: {
                ...this.state.project,
                system_id: systemId ?? "",
                sub_system_id: subSystemId ?? ""
            },
            systemArray: [],
            subSystemArray: []
        });
        setTimeout(() => {
            this.setState({
                systemArray: systemData,
                subSystemArray: subSystemData,
                systemLoading: false,
                subSystemLoading: false
            });
        }, 100);
    };

    handleSystem = async systemId => {
        this.setState({
            subSystemLoading: true
        });
        let data = [];
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        await this.props.getSubSystemBasedOnProject(query.p_id, systemId, this.state.project.trade_id);
        data = this.props.recommendationsReducer?.getSubSystemByProject?.sub_systems || [];
        this.setState({
            project: {
                ...this.state.project,
                sub_system_id: ""
            },
            subSystemArray: []
        });
        setTimeout(() => {
            this.setState({
                subSystemArray: data,
                subSystemLoading: false
            });
        }, 100);
    };

    toggleShowReportNoteTemplateModal = () => {
        const { showReportNoteTemplateModal } = this.state;
        this.setState({
            showReportNoteTemplateModal: !showReportNoteTemplateModal
        });
    };

    toggleShowRecommendationTemplateModal = () => {
        const { showRecommendationTemplateModal } = this.state;
        this.setState({
            showRecommendationTemplateModal: !showRecommendationTemplateModal
        });
    };

    renderRecommendationTemplateModal = () => {
        const { showRecommendationTemplateModal, project } = this.state;
        if (!showRecommendationTemplateModal || !project.sub_system_id) return null;
        return (
            <Portal
                body={
                    <RecommendationTemplateModal
                        heading={"Recommendation Templates"}
                        sub_system_id={project.sub_system_id || null}
                        onOk={this.onSuggestionSelected}
                        onCancel={() => {
                            this.setState({ showRecommendationTemplateModal: false });
                        }}
                    />
                }
                onCancel={() => this.setState({ showRecommendationTemplateModal: false })}
            />
        );
    };

    updateTextBandContent = async newBandContent => {
        const { project } = this.state;
        this.setState({
            project: {
                ...project,
                note_html: project.note_html + newBandContent
            }
        });
    };

    onSuggestionSelected = newBandContent => {
        const { project, captionLength, assetFormData } = this.state;
        if (typeof newBandContent === "string") {
            this.setState({
                project: {
                    ...project,
                    description: applyVerbToText(project.description, newBandContent)?.substr(0, captionLength)
                }
            });
            return;
        }
        const {
            text_format = "",
            cost_per_unit = "",
            unit = "",
            description = "",
            avg_useful_life: service_life,
            recommendation_type,
            trade,
            system,
            sub_system
        } = newBandContent;
        let newContent = text_format?.substr(0, captionLength) || "";
        const suggestedCategoryId = newBandContent?.category?.id || project.category_id;
        const suggestedServiceLife = service_life || project.service_life;
        const suggestedRecommendationType = recommendation_type || project.recommendation_type;
        const silentCapital = newBandContent?.capital_type?.id
            ? { projectPatch: {}, nextAutoFilled: undefined }
            : this.getSilentCapitalTypeMerge({
                  categoryId: suggestedCategoryId,
                  installedYear:
                      suggestedRecommendationType === RECOMMENDATION_TYPES.ASSET ? assetFormData.installed_year : project.installed_year,
                  serviceLife: suggestedServiceLife,
                  capitalTypeId: project.recommendation_capital_type_id,
                  autoFilledCapitalTypeId: this.state.autoFilledCapitalTypeId
              });
        this.setState({
            project: {
                ...project,
                description: newContent,
                cost_per_unit: cost_per_unit || project.cost_per_unit,
                unit: unit || project.unit,
                options_cost: project.quantity ? cost_per_unit * project.quantity : project.options_cost,
                notes: project.notes ? `${project.notes} ${description}` : description,
                note_html: project.note_html
                    ? `${project.note_html} ${description?.replace(/\n/g, "<br />") || ""}`
                    : description?.replace(/\n/g, "<br />"),
                service_life: suggestedServiceLife,
                usefull_life_remaining: getUsefullLifeRemaining(project.installed_year, suggestedServiceLife),
                recommendation_type: suggestedRecommendationType,
                criticality_id: newBandContent?.criticality?.id || project.criticality_id,
                capital_type: newBandContent?.capital_type?.name || project.capital_type,
                recommendation_capital_type_id: newBandContent?.capital_type?.id || project.recommendation_capital_type_id,
                funding_source_id: newBandContent?.funding_source?.id || project.funding_source_id,
                recommendation_space_type_id: newBandContent?.recommendation_space_type?.id || project.recommendation_space_type_id,
                responsibility_id: newBandContent?.responsibility?.id || project.responsibility_id,
                category_id: suggestedCategoryId,
                ...silentCapital.projectPatch,
                asset_condition_id:
                    recommendation_type === RECOMMENDATION_TYPES.SYSTEM && newBandContent?.condition?.id
                        ? newBandContent?.condition?.id
                        : project.asset_condition_id,
                trade_id: trade?.id,
                system_id: system?.id,
                sub_system_id: sub_system?.id
            },
            assetFormData: {
                ...assetFormData,
                client_asset_condition_id:
                    recommendation_type === RECOMMENDATION_TYPES.ASSET && newBandContent?.condition?.id
                        ? newBandContent?.condition?.id
                        : assetFormData?.client_asset_condition_id
            },
            ...(silentCapital.nextAutoFilled !== undefined ? { autoFilledCapitalTypeId: silentCapital.nextAutoFilled } : {})
        });
    };

    getCategoryCapitalTypeId = (category, remaining) => {
        if (remaining === "" || remaining === null || remaining === undefined || Number.isNaN(Number(remaining))) {
            return "";
        }
        const capitalType =
            Number(remaining) >= 0 ? category?.capital_type_within_service_life : category?.capital_type_past_service_life;
        return capitalType?.id || capitalType || "";
    };

    getCapitalTypeDisplayLabel = capitalTypeId => {
        if (capitalTypeId == null || String(capitalTypeId).trim() === "") return "";
        const capitalTypes = this.props.recommendationsReducer?.getCapitalTypeBasedOnProject?.capital_types || [];
        const item = capitalTypes.find(ct => String(ct.id) === String(capitalTypeId));
        return item?.display_name || item?.name || "";
    };

    getCapitalTypeName = capitalTypeId => {
        if (capitalTypeId == null || String(capitalTypeId).trim() === "") return "";
        const capitalTypes = this.props.recommendationsReducer?.getCapitalTypeBasedOnProject?.capital_types || [];
        const item = capitalTypes.find(ct => String(ct.id) === String(capitalTypeId));
        return item?.name || "";
    };

    computeSuggestedCapitalFields = (categoryId, installedYear, serviceLife) => {
        const categories = this.props.recommendationsReducer?.getCategoryByProject?.categories || [];
        const category = categories.find(item => item.id === categoryId);
        const remaining = getUsefullLifeRemaining(installedYear, serviceLife);
        const rawId = this.getCategoryCapitalTypeId(category, remaining);
        if (!rawId) {
            return { recommendation_capital_type_id: "", capital_type: "" };
        }
        return {
            recommendation_capital_type_id: rawId,
            capital_type: this.getCapitalTypeName(rawId)
        };
    };

    resolveLifecycleCapitalForFormUpdate = ({
        categoryId,
        installedYear,
        serviceLife,
        recommendation_capital_type_id: currentId,
        autoFilledCapitalTypeId,
        capitalTypeLabel
    }) => {
        const suggested = this.computeSuggestedCapitalFields(categoryId, installedYear, serviceLife);
        const hasCurrent = currentId != null && String(currentId).trim() !== "";
        const isManual = hasCurrent && String(currentId) !== String(autoFilledCapitalTypeId ?? "");

        if (isManual) {
            if (!suggested?.recommendation_capital_type_id) {
                return { projectPatch: {}, nextAutoFilled: undefined, needsConfirm: false };
            }
            if (String(suggested.recommendation_capital_type_id) === String(currentId)) {
                return {
                    projectPatch: {
                        ...(suggested.capital_type !== undefined ? { capital_type: suggested.capital_type } : {})
                    },
                    nextAutoFilled: undefined,
                    needsConfirm: false
                };
            }
            return {
                needsConfirm: true,
                pendingCapitalTypeChange: {
                    proposed: {
                        recommendation_capital_type_id: suggested.recommendation_capital_type_id,
                        capital_type: suggested.capital_type
                    },
                    nextAutoFilledId: suggested.recommendation_capital_type_id,
                    previousCapitalLabel: this.getCapitalTypeDisplayLabel(currentId) || capitalTypeLabel || ""
                },
                projectPatch: {},
                nextAutoFilled: undefined
            };
        }

        if (!suggested?.recommendation_capital_type_id) {
            if (hasCurrent && String(currentId) === String(autoFilledCapitalTypeId ?? "")) {
                return {
                    projectPatch: { recommendation_capital_type_id: "", capital_type: "" },
                    nextAutoFilled: "",
                    needsConfirm: false
                };
            }
            return { projectPatch: {}, nextAutoFilled: undefined, needsConfirm: false };
        }

        return {
            projectPatch: {
                recommendation_capital_type_id: suggested.recommendation_capital_type_id,
                capital_type: suggested.capital_type
            },
            nextAutoFilled: suggested.recommendation_capital_type_id,
            needsConfirm: false
        };
    };

    getSilentCapitalTypeMerge = ({
        categoryId,
        installedYear,
        serviceLife,
        capitalTypeId,
        autoFilledCapitalTypeId = this.state.autoFilledCapitalTypeId
    }) => {
        const r = this.resolveLifecycleCapitalForFormUpdate({
            categoryId,
            installedYear,
            serviceLife,
            recommendation_capital_type_id: capitalTypeId,
            autoFilledCapitalTypeId,
            capitalTypeLabel: ""
        });
        if (r.needsConfirm) {
            return { projectPatch: {}, nextAutoFilled: undefined };
        }
        return { projectPatch: r.projectPatch, nextAutoFilled: r.nextAutoFilled };
    };

    applyLifecycleCapitalResolutionToProject = (
        mergedProject,
        mergedAsset,
        extraState = {},
        touchAssetFormData = false
    ) => {
        const lifeData = mergedProject.recommendation_type === RECOMMENDATION_TYPES.ASSET ? mergedAsset : mergedProject;

        const resolved = this.resolveLifecycleCapitalForFormUpdate({
            categoryId: mergedProject.category_id,
            installedYear: lifeData.installed_year,
            serviceLife: lifeData.service_life,
            recommendation_capital_type_id: mergedProject.recommendation_capital_type_id,
            autoFilledCapitalTypeId: this.state.autoFilledCapitalTypeId,
            capitalTypeLabel: mergedProject.capital_type
        });

        const assetSlice = touchAssetFormData ? { assetFormData: mergedAsset } : {};

        if (resolved.needsConfirm && resolved.pendingCapitalTypeChange) {
            this.setState({
                ...extraState,
                project: mergedProject,
                ...assetSlice,
                showCapitalTypeUpdateConfirm: true,
                pendingCapitalTypeChange: resolved.pendingCapitalTypeChange
            });
            return;
        }

        this.setState({
            ...extraState,
            project: { ...mergedProject, ...resolved.projectPatch },
            ...assetSlice,
            ...(resolved.nextAutoFilled !== undefined ? { autoFilledCapitalTypeId: resolved.nextAutoFilled } : {})
        });
    };

    flushDeferredCapitalResolution = debounce(() => {
        const { project, assetFormData } = this.state;
        this.applyLifecycleCapitalResolutionToProject(project, assetFormData, {}, false);
    }, 450);

    applyRecommendationLifecyclePatch = ({
        project: projectPatch = {},
        assetFormData: assetPatch,
        extraState = {},
        deferCapitalTypeResolution = false
    } = {}) => {
        const mergedProject = { ...this.state.project, ...projectPatch };
        const mergedAsset = assetPatch !== undefined ? { ...this.state.assetFormData, ...assetPatch } : this.state.assetFormData;
        const touchAssetFormData = assetPatch !== undefined;

        if (deferCapitalTypeResolution) {
            this.setState(
                {
                    ...extraState,
                    project: mergedProject,
                    ...(touchAssetFormData ? { assetFormData: mergedAsset } : {})
                },
                () => this.flushDeferredCapitalResolution()
            );
            return;
        }

        this.applyLifecycleCapitalResolutionToProject(mergedProject, mergedAsset, extraState, touchAssetFormData);
    };

    handleCapitalTypeUpdateConfirmYes = () => {
        const { pendingCapitalTypeChange, project } = this.state;
        if (!pendingCapitalTypeChange?.proposed) {
            this.setState({ showCapitalTypeUpdateConfirm: false, pendingCapitalTypeChange: null });
            return;
        }
        this.setState({
            showCapitalTypeUpdateConfirm: false,
            pendingCapitalTypeChange: null,
            project: {
                ...project,
                ...pendingCapitalTypeChange.proposed
            },
            autoFilledCapitalTypeId: pendingCapitalTypeChange.nextAutoFilledId ?? ""
        });
    };

    handleCapitalTypeUpdateConfirmNo = () => {
        this.setState({ showCapitalTypeUpdateConfirm: false, pendingCapitalTypeChange: null });
    };

    renderCapitalTypeUpdateConfirmationModal = () => {
        const { showCapitalTypeUpdateConfirm, pendingCapitalTypeChange, project } = this.state;
        if (!showCapitalTypeUpdateConfirm || !pendingCapitalTypeChange?.proposed) return null;
        const proposedId = pendingCapitalTypeChange.proposed.recommendation_capital_type_id;
        const proposedLabel =
            this.getCapitalTypeDisplayLabel(proposedId) ||
            pendingCapitalTypeChange.proposed.capital_type ||
            proposedId ||
            "";
        const prevLabel =
            pendingCapitalTypeChange.previousCapitalLabel ||
            this.getCapitalTypeDisplayLabel(project.recommendation_capital_type_id) ||
            project.capital_type ||
            project.recommendation_capital_type_id ||
            "";
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading="Replace capital type?"
                        type="cancel"
                        message={
                            <>
                                For the selected category and remaining useful life, &quot;
                                <strong>{proposedLabel}</strong>
                                &quot; is the recommended capital type. Do you want to replace &quot;
                                <strong>{prevLabel}</strong>
                                &quot; with &quot;
                                <strong>{proposedLabel}</strong>
                                &quot;?
                            </>
                        }
                        onNo={this.handleCapitalTypeUpdateConfirmNo}
                        onYes={this.handleCapitalTypeUpdateConfirmYes}
                    />
                }
                onCancel={this.handleCapitalTypeUpdateConfirmNo}
            />
        );
    };

    renderReportNoteTemplateModal = () => {
        const { showReportNoteTemplateModal, project } = this.state;
        if (!showReportNoteTemplateModal || !project.sub_system_id) return null;
        return (
            <Portal
                body={
                    <RepotNoteTemplateModal
                        heading={"Narrative Templates"}
                        sub_system_id={project.sub_system_id || null}
                        onOk={this.updateTextBandContent}
                        onCancel={() => {
                            this.setState({ showReportNoteTemplateModal: false });
                        }}
                    />
                }
                onCancel={() => this.setState({ showReportNoteTemplateModal: false })}
            />
        );
    };

    renderAssetModal = () => {
        const { showAssetModal, project } = this.state;
        if (!showAssetModal) return null;
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        return (
            <Portal
                body={
                    <AssignAssetModal
                        handleAssignAsset={this.handleAssignAsset}
                        selectedData={project}
                        clientId={project.client_id || query.c_id}
                        onCancel={() => this.setState({ showAssetModal: false })}
                    />
                }
                onCancel={() => this.setState({ showAssetModal: false })}
            />
        );
    };

    handleAssignAsset = async assetData => {
        if (assetData?.client_asset_condition) {
            assetData.asset_condition = assetData.client_asset_condition;
        }
        const assetDynamicFieldValue = {};
        if (assetData?.dynamic_fields && Object.keys(assetData.dynamic_fields)?.length) {
            Object.keys(assetData.dynamic_fields).forEach(field => {
                assetDynamicFieldValue[field] = assetData.dynamic_fields[field]?.value;
            });
        }
        await this.setState({
            project: {
                ...this.state.project,
                asset: { id: assetData?.id }
            },
            assetFormData: {
                code: assetData.code,
                asset_name: assetData.asset_name,
                asset_tag: assetData.asset_tag,
                asset_note: assetData.asset_note,
                client_asset_condition_id: assetData.asset_condition?.id,
                installed_year: assetData.installed_year,
                service_life: assetData.service_life,
                usefull_life_remaining: assetData.usefull_life_remaining,
                crv: assetData.crv,
                manufacturer_id: assetData.manufacturer?.id,
                year_manufactured: assetData.year_manufactured,
                model_number: assetData.model_number,
                serial_number: assetData.serial_number,
                capacity: assetData.capacity,
                criticality: assetData.criticality,
                area_served: assetData.area_served,
                client_id: assetData.client?.id,
                region_id: assetData.region?.id,
                site_id: assetData.site?.id,
                building_id: assetData.building?.id,
                addition_id: assetData.addition?.id,
                floor_id: assetData.floor?.id,
                room_number: assetData.room_number,
                room_name: assetData.room_name,
                location: assetData.location,
                architectural_room_number: assetData.architectural_room_number,
                additional_room_description: assetData.additional_room_description,
                uniformat_level_1_id: assetData.uniformat_level_1?.id,
                uniformat_level_2_id: assetData.uniformat_level_2?.id,
                uniformat_level_3_id: assetData.uniformat_level_3?.id,
                uniformat_level_4_id: assetData.uniformat_level_4?.id,
                uniformat_level_5_id: assetData.uniformat_level_5?.id,
                uniformat_version: assetData?.uniformat_version ?? null ,
                asset_type_id: assetData.asset_type?.id,
                asset_description: assetData.asset_description,
                asset_barcode: assetData.asset_barcode,
                asset_client_id: assetData.asset_client_id,
                asset_cmms_id: assetData.asset_cmms_id,
                warranty_start: assetData.warranty_start,
                warranty_end: assetData.warranty_end,
                install_date: assetData.install_date,
                startup_date: assetData.startup_date,
                upstream_asset_barcode_number: assetData.upstream_asset_barcode_number,
                linked_asset_barcode_number: assetData.linked_asset_barcode_number,
                source_panel_barcode_number: assetData.source_panel_barcode_number,
                source_panel: assetData.source_panel,
                asset_status_id: assetData.asset_status?.id,
                notes: assetData.notes,
                building_type: assetData?.building_type?.name,
                main_category_id: assetData?.main_category?.id,
                sub_category_1_id: assetData?.sub_category_1?.id,
                sub_category_2_id: assetData?.sub_category_2?.id,
                sub_category_3_id: assetData?.sub_category_3?.id,
                guid: assetData?.guid,
                source_panel_name: assetData?.source_panel_name,
                skysite_hyperlink: assetData?.skysite_hyperlink,
                trade_id: assetData.trade?.id,
                system_id: assetData.system?.id,
                sub_system_id: assetData?.sub_system?.id,

                quantity: assetData?.quantity,
                rtls_tag: assetData?.rtls_tag,
                latitude: assetData?.latitude,
                longitude: assetData?.longitude,
                current_age: assetData?.current_age,
                age: assetData?.age,
                new_asset: assetData?.new_asset,
                source: assetData?.source,
                latest_source: assetData?.latest_source,
                parent_global_id: assetData?.parent_global_id,
                survey_global_id: assetData?.survey_global_id,
                survey_id: assetData?.survey_id,
                survey_property_note: assetData?.survey_property_note,
                capacity_status: assetData?.capacity_status,
                installed_year_status: assetData?.installed_year_status,
                name_plate_status: assetData?.name_plate_status,
                qa_notes: assetData?.qa_notes,
                additional_qa_notes: assetData?.additional_qa_notes,
                surveyor: assetData?.surveyor,
                editor: assetData?.editor,
                survey_date_created: assetData?.survey_date_created,
                survey_date_edited: assetData?.survey_date_edited,
                description: assetData?.asset_condition?.description,
                uniformat_level_6_id: assetData?.uniformat_level_6?.id,
                uniformat_level_6_description: assetData?.uniformat_level_6?.uniformat_level_6_description,
                subcategory2_description: assetData?.sub_category_2?.subcategory2_description,
                capacity_unit: assetData?.capacity_unit,
                refrigerant: assetData?.refrigerant,
                asset_additional: assetData?.asset_additional,
                auxiliary: assetData?.auxiliary[0],
                dynamic_fields: assetDynamicFieldValue
            }
        });
        this.getSelectedAssetDropdowns();
        this.setState({ initialAssetFormData: _.cloneDeep(this.state.assetFormData) });
    };

    handleRecommendationTypeSelect = async () => {
        const {
            recommendation_type,
            trade_id,
            system_id,
            sub_system_id,
            client_id,
            region_id,
            site_id,
            building_id,
            building_type,
            addition_id,
            floor_id,
            room,
            asset_condition_id,
            installed_year = "",
            service_life = "",
            usefull_life_remaining = ""
        } = this.state.project;
        const {
            assetReducer: { dropDownList },
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const isMR = query.is_mr === "true";
        if (recommendation_type === RECOMMENDATION_TYPES.ASSET) {
            let client_asset_condition_id = "";
            if (asset_condition_id) {
                let condition_name = this.props.recommendationsReducer?.getConditionBasedOnProject?.asset_conditions?.find(
                    item => item.id === asset_condition_id
                )?.name;
                client_asset_condition_id = dropDownList?.asset_conditions?.find(item => item.name === condition_name)?.id;
            }

            await this.setState({
                assetFormData: {
                    ...this.state.assetFormData,
                    client_id,
                    region_id,
                    site_id,
                    building_id,
                    building_type,
                    addition_id,
                    floor_id,
                    room_number: room,
                    trade_id,
                    system_id,
                    sub_system_id,
                    client_asset_condition_id,
                    ...(isMR && {
                        installed_year: installed_year ? parseInt(installed_year) : "",
                        service_life: isNaN(parseInt(service_life)) ? "" : parseInt(service_life),
                        current_age: installed_year ? getCurrentAge(installed_year) : "",
                        usefull_life_remaining: usefull_life_remaining ? parseInt(usefull_life_remaining) : ""
                    })
                }
            });
            this.setState({ initialAssetFormData: _.cloneDeep(this.state.assetFormData) });
        } else {
            const { client_asset_condition_id, installed_year = "", service_life = "", usefull_life_remaining = "" } = this.state.assetFormData;
            let asset_condition_id = "";
            if (client_asset_condition_id) {
                let condition_name = dropDownList?.asset_conditions?.find(item => item.id === client_asset_condition_id)?.name;
                asset_condition_id = this.props.recommendationsReducer?.getConditionBasedOnProject?.asset_conditions?.find(
                    item => item.name === condition_name
                )?.id;
            }
            this.setState({
                project: {
                    ...this.state.project,
                    asset_condition_id,
                    ...(isMR && {
                        installed_year: installed_year ? parseInt(installed_year) : "",
                        service_life: isNaN(parseInt(service_life)) ? "" : parseInt(service_life),
                        usefull_life_remaining: usefull_life_remaining ? parseInt(usefull_life_remaining) : ""
                    })
                }
            });
        }
        ReactTooltip.rebuild();
    };

    getRecommendationTemplates = async (sub_system_id, project_id) => {
        let params = {};
        let dynamicUrl = sub_system_id
            ? `/sub_systems/${sub_system_id}/recommendation_templates`
            : `/projects/${project_id}/recommendation_templates?limit=1000`;
        let recommendationTemplateList = [];

        await this.props.getRecommendationTemplates(params, dynamicUrl);
        recommendationTemplateList =
            this.props.recommendationsReducer.getRecommendationTemplatesResponse?.project_sub_system_recommendation_templates || [];

        await this.setState({
            recommendationTemplateList,
            recommendationSuggestions: recommendationTemplateList
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        if (this.state.forceShowVerbList) return;
        this.setState({
            recommendationSuggestions: this.getSuggestions(value)
        });
        ReactTooltip.rebuild();
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            recommendationSuggestions: [],
            forceShowVerbList: false
        });
    };

    getSuggestions = value => {
        const verbList = this.getAcceptableVerbs();
        if (verbList.length && !isFirstWordValid(value, verbList)) {
            const { word, prefix } = getVerbToken(value);
            return matchVerbs(word, verbList, !!prefix);
        }
        return matchTemplatesByPrefix(value, this.state.recommendationTemplateList);
    };

    getAcceptableVerbs = () =>
        this.props.recommendationsReducer?.getRecommendationAcceptableVerbsByProject?.recommendation_acceptable_verbs || [];

    handleDescriptionChange = newValue => {
        const { project } = this.state;
        const isCR = qs.parse(this.props.location.search)?.is_cr === "true";
        const label = isCR ? getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous) : "Recommendation";
        const liveVerbError = getLiveVerbError(newValue, this.getAcceptableVerbs(), label);
        const startedFailing = !!liveVerbError && !this.state.liveVerbError;

        this.setState({ project: { ...project, description: newValue }, liveVerbError, forceShowVerbList: false });

        if (startedFailing) {
            clearTimeout(this.shakeTimer);
            this.setState({ shakeVerbField: true });
            this.shakeTimer = setTimeout(() => this.setState({ shakeVerbField: false }), 500);
        }
    };

    scrollSuggestionsIntoView = () => {
        if (!this.suggestionInputRef?.current) return;
        this.suggestionInputRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    showApprovedVerbList = () => {
        const { project } = this.state;
        const { prefix, word, start } = getVerbToken(project.description || "");
        const input = this.suggestionInputRef?.current?.querySelector("input");
        if (input) {
            input.focus();
            input.setSelectionRange(start + word.length, start + word.length);
        }
        const matched = matchVerbs(word, this.getAcceptableVerbs(), !!prefix);
        const allVerbs = this.getAcceptableVerbs()
            .map(verb => verb?.name)
            .filter(name => name && !(prefix && name.toUpperCase().startsWith("ALLOWANCE:")))
            .sort((a, b) => a.localeCompare(b));
        this.setState(
            {
                forceShowVerbList: true,
                recommendationSuggestions: matched.length ? matched : allVerbs
            },
            this.scrollSuggestionsIntoView
        );
    };

    getSuggestionValue = suggestion =>
        typeof suggestion === "string" ? applyVerbToText(this.state.project.description, suggestion) : suggestion?.text_format || "";

    renderSuggestionsContainer = ({ containerProps, children }) => {
        if (!children) return <div {...containerProps} />;
        const isVerbMode = typeof this.state.recommendationSuggestions?.[0] === "string";
        return (
            <div {...containerProps}>
                <div className="verb-suggestion-header">{isVerbMode ? "Approved verbs" : "Suggestions"}</div>
                {children}
            </div>
        );
    };

    renderSuggestion = suggestion => {
        if (typeof suggestion === "string") return <div>{suggestion}</div>;
        return (
            <div>
                <ReactTooltip
                    id="suggestions"
                    effect="solid"
                    html={true}
                    multiline={true}
                    backgroundColor="#007bff"
                    place="bottom"
                    className="rich-text-tooltip"
                    getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                />
                <div data-for="suggestions" data-tip={suggestion.description || ""}>
                    {suggestion.text_format}
                </div>
            </div>
        );
    };

    handleChangeAssetForm = async e => {
        const { name, value } = e.target;
        const additional_asset = [
            "discharge",
            "unit_property_labeled",
            "factory_mounted_disconnect",
            "unit_voltage",
            "ahu_voltage",
            "wire_type",
            "wire_size",
            "estimated_wire_run_length",
            "breaker_size",
            "mocp",
            "mca",
            "liquid_line",
            "suction_line",
            "hot_gas_by_pass",
            "number_of_circuits",
            "length_of_line",
            "damper_type",
            "gas_heating",
            "gas_output_btu",
            "electric_heating",
            "electric_heating_kw",
            "pump_backup_heat_kw",
            "cooling_only",
            "controls",
            "control_type",
            "smoke_detector",
            "smoke_detector_mounting",
            "smoke_detector_supply",
            "smoke_detector_return",
            "curb",
            "curb_description",
            "vibration_isolation",
            "burglar_bars",
            "installed_on_adapter_curb",
            "curb_outside_dimension_length",
            "curb_outside_dimension_width",
            "allow_curb_adaptor",
            "ducted_or_concentric_system",
            "unit_weight",
            "codes_for_disconnects",
            "codes_for_convenience_outlets",
            "codes_for_roof_lighting",
            "duct_work_attached_to_bottom_of_unit",
            "aluminium_wire_used",
            "code_or_safety_concerns",
            "distance_from_salt_water_body",
            "recommend_coil_coating",
            "need_resealed",
            "split_system_line_sets_good_condition",
            "split_system_line_sets_damaged",
            "split_system_line_sets_crimped",
            "split_system_line_sets_insulated",
            "split_system_line_sets_re_used",
            "line_connection_type",
            "boiler_type",
            "boiler_burner_type",
            "boiler_btu_input",
            "boiler_btu_output",
            "boiler_hp",
            "boiler_fuel",
            "boiler_gas_pressure",
            "boiler_kw_input",
            "boiler_power_burner_type",
            "boiler_burner_model",
            "boiler_burner_serial",
            "boiler_pressure_type",
            "confirm_boiler_pressure",
            "return"
        ];

        const auxiliaryFields = [
            "id",
            "auxiliary_equipment_name",
            "auxiliary_model",
            "auxiliary_serial",
            "auxiliary_date_manufactured",
            "auxiliary_manufacturer",
            "auxiliary_condition",
            "auxiliary_eul",
            "auxiliary_crv"
        ];
        let assetValue = { uniformat_version: this.state?.assetFormData?.uniformat_version ?? null };
        if (name === "manufacturer") {
            assetValue = {
                ...this.state.assetFormData,
                manufacturer_id: e.target?.value
            };
        } else {
            assetValue = {
                ...this.state.assetFormData,
                [name]: value
            };
        }

        if (auxiliaryFields.includes(name))
            assetValue = { ...this.state.assetFormData, auxiliary: { ...this.state.assetFormData.auxiliary, [name]: value } };
        if (additional_asset.includes(name))
            assetValue = { ...this.state.assetFormData, asset_additional: { ...this.state.assetFormData.asset_additional, [name]: value } };
        await this.setState({
            assetFormData: assetValue
        });
    };

    setAssetFormData = async assetFormData => {
        await this.setState({ assetFormData });
    };

    getSelectedAssetDropdowns = () => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const { assetFormData } = this.state;
        this.props.getDropdownList("manufacturers", {
            current_manufacturer: this.state.assetFormData?.manufacturer_id && this.state.assetFormData?.manufacturer_id,
            client_id: assetFormData?.client_id ?? query?.c_id
        });
        if(assetFormData?.uniformat_version){
            this.props.getDropdownList("uniformat_level_1s", {
                client_id: assetFormData?.client_id ?? query?.c_id,
                uniformat_version: assetFormData?.uniformat_version ?? null
            });
        }
        this.props.getDropdownList("uniformat_level_2s", {
            client_id: assetFormData?.client_id ?? query?.c_id,
            uniformat_version: assetFormData?.uniformat_version ?? null,
            uniformat_level_1_id: assetFormData.uniformat_level_1_id
        });
        this.props.getDropdownList("uniformat_level_3s", {
            client_id: assetFormData?.client_id ?? query?.c_id,
            uniformat_version: assetFormData?.uniformat_version ?? null,
            uniformat_level_1_id: assetFormData.uniformat_level_1_id,
            uniformat_level_2_id: assetFormData.uniformat_level_2_id
        });
        this.props.getDropdownList("uniformat_level_4s", {
            client_id: assetFormData?.client_id ?? query?.c_id,
            uniformat_version: assetFormData?.uniformat_version ?? null,
            uniformat_level_1_id: assetFormData.uniformat_level_1_id,
            uniformat_level_2_id: assetFormData.uniformat_level_2_id,
            uniformat_level_3_id: assetFormData.uniformat_level_3_id
        });
        this.props.getDropdownList("uniformat_level_5s", {
            client_id: assetFormData?.client_id ?? query?.c_id,
            uniformat_version: assetFormData?.uniformat_version ?? null,
            uniformat_level_1_id: assetFormData.uniformat_level_1_id,
            uniformat_level_2_id: assetFormData.uniformat_level_2_id,
            uniformat_level_3_id: assetFormData.uniformat_level_3_id,
            uniformat_level_4_id: assetFormData.uniformat_level_4_id
        });
        this.props.getDropdownList("uniformat_level_6s", {
            client_id: assetFormData?.client_id ?? query?.c_id,
            uniformat_version: assetFormData?.uniformat_version ?? null,
            uniformat_level_1_id: assetFormData.uniformat_level_1_id,
            uniformat_level_2_id: assetFormData.uniformat_level_2_id,
            uniformat_level_3_id: assetFormData.uniformat_level_3_id,
            uniformat_level_4_id: assetFormData.uniformat_level_4_id,
            uniformat_level_5_id: assetFormData.uniformat_level_5_id
        });
        this.props.getDropdownList("main_categories", {
            client_id: assetFormData.client_id
        });
        this.props.getDropdownList("sub_category_1s", {
            client_id: assetFormData.client_id,
            main_category_id: assetFormData.main_category_id
        });
        this.props.getDropdownList("sub_category_2s", {
            client_id: assetFormData.client_id,
            main_category_id: assetFormData.main_category_id,
            sub_category_1_id: assetFormData.sub_category_1_id
        });
        this.props.getDropdownList("sub_category_3s", {
            client_id: assetFormData.client_id,
            main_category_id: assetFormData.main_category_id,
            sub_category_1_id: assetFormData.sub_category_1_id,
            sub_category_2_id: assetFormData.sub_category_2_id
        });
    };

    showErrorBand = item => {
        // const { project, assetFormData, costTotal } = this.state;
        // switch (item) {
        //     case "b1":
        //         return !(project.trade_id && project.system_id && project.sub_system_id && project.description?.trim()?.length);
        //     case "b2":
        //         return !(project.region_id && project.site_id && project.building_id);
        //     case "b3":
        //         return costTotal === 0;
        //     case "b4":
        //         return false;
        //     case "b5":
        //         return project.recommendation_type ===RECOMMENDATION_TYPES.ASSET && !(assetFormData.asset_name && assetFormData.client_asset_condition_id);
        //     case "b6":
        //         return (
        //             (project.recommendation_type ===RECOMMENDATION_TYPES.SYSTEM && !project.asset_condition_id) ||
        //             !(project.capital_type && project.category_id && project.status)
        //         );
        //     default:
        //         return false;
        // }
        return false;
    };
    // showBand = item => {
    //     const { showBand } = this.state;

    //     return false;
    // };

    handleClick = () => {
        this.setState(prevState => ({
            toggleInput: !prevState.toggleInput
        }));
    };

    getCodePrefix = (full = "") => {
        const digits = (full.match(/\d+$/) || [""])[0];
        return full.slice(0, full.length - digits.length);
    };

    getCodeDigits = (full = "") => (full.match(/\d+$/) || [""])[0];

    renderPriorityElementToolTip = (name, options = [], notes, index = "") => {
        let tootTipData = "";
        if (options.length) {
            tootTipData = `<h4>${name ? name : `Priority Element ${index + 1}`}</h4>`;
            if (notes) {
                tootTipData = tootTipData + `<p>${notes}</p>`;
            }
            options.map((option, i) => {
                tootTipData = tootTipData + `<p>${option.name}</p>`;
            });
        }
        return tootTipData || null;
    };

    openReportNote = () => {
        this.setState({
            showNoteModal: true
        });
    };

    handleChangeNote = data => {
        let note_xml = convertToXML([data], 1);
        let removedAllTags = removeAllTags(data);
        this.setState({
            project: {
                ...this.state.project,
                notes: removedAllTags,
                note_xml: note_xml,
                note_html: data
            }
        });
    };

    getRecommendationEditorHeight = () => {
        const minHeight = this.state.project?.recommendation_type === RECOMMENDATION_TYPES.ASSET ? 400 : 310;
        const calculatedHeight = (this.templateRef?.current?.clientHeight || 0) - 340;
        return Math.max(calculatedHeight, minHeight);
    };

    componentDidUpdate = (prevProps, prevState) => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);

        if (prevState.showBand !== this.state.showBand || prevState.project !== this.state.project) {
            setTimeout(() => {
                const height = this.getRecommendationEditorHeight();
                if (this.state.editorHeight !== height) {
                    this.setState({ editorHeight: height });
                }
            }, 500);
        }
        if (prevState.project.sub_system_id !== this.state.project.sub_system_id && !this.state.project.sub_system_id)
            this.getRecommendationTemplates(undefined, query.p_id);
        if (prevState.project !== this.state.project || !isEqual(prevState.checkListData, this.state.checkListData)) {
            this.checkFormDirty();
        }
    };

    checkFormDirty = () => {
        const { project, initialValues, isAddOrEdit } = this.state;

        if (!isAddOrEdit && Object.keys(initialValues)?.length) {
            const isDirty = !isEqual(project, initialValues) || !isEqual(this.state.initialCheckListData ?? [], this.state?.checkListData ?? []);

            if (isDirty) {
                this.props.setFormDirty(true);
            } else {
                this.props.setFormDirty(false);
            }
        }
    };

    scrollBandIntoView = bandId => {
        if (this._bandScrollRaf) {
            cancelAnimationFrame(this._bandScrollRaf);
        }

        const scrollContainer =
            this.templateRef.current?.closest(".height-new-cp") ||
            this.templateRef.current?.closest(".detail-recom");

        let attempt = 0;
        let lastPanelHeight = 0;

        const ensureExpandedBandVisible = () => {
            this._bandScrollRaf = null;

            const bandPanel = document.getElementById(bandId);
            if (!bandPanel) return;

            if (!scrollContainer) {
                bandPanel.scrollIntoView({ block: "start", behavior: "auto" });
                return;
            }

            const padding = 12;
            const containerRect = scrollContainer.getBoundingClientRect();
            const panelRect = bandPanel.getBoundingClientRect();
            const headerEl =
                document.getElementById(`heading-${bandId}`) ||
                document.getElementById(`heading${bandId}`);
            const headerRect = headerEl?.getBoundingClientRect();

            const bandTop = headerRect ? headerRect.top : panelRect.top;
            const bandBottom = panelRect.bottom;
            const topGap = bandTop - containerRect.top;
            const bottomGap = containerRect.bottom - bandBottom;
            const isFullyVisible = topGap >= padding && bottomGap >= padding;

            if (!isFullyVisible) {
                // Align band to the top of the scroll area so the full expanded panel is in view.
                scrollContainer.scrollTop += bandTop - containerRect.top - padding;
            }

            const panelHeight = panelRect.height;
            const heightStillGrowing = panelHeight > lastPanelHeight + 1;
            lastPanelHeight = panelHeight;

            if (attempt < 8 && (heightStillGrowing || panelHeight < 20)) {
                attempt += 1;
                this._bandScrollRaf = requestAnimationFrame(ensureExpandedBandVisible);
            }
        };

        this._bandScrollRaf = requestAnimationFrame(ensureExpandedBandVisible);
    };

    handleBandClick = (key, value) => {
        const wasExpanded = this.state.showBand?.[key];
        this.setState(
            {
                showBand: {
                    ...this.state.showBand,
                    [key]: value
                }
            },
            () => {
                if (value && !wasExpanded) {
                    this.scrollBandIntoView(key);
                }
            }
        );
    };
    handleChangeBandData = bandData => {
        this.setState({ project: { ...this.state.project, ...bandData } });
    };

    handleCheckBoxClick = (key, checked, field = "") => {
        const { project } = this.state;
        const valueFound = this.checkAnyActiveData(field);
        if (!checked && valueFound) {
            this.setState(
                {
                    alertMessage: "You can't uncheck when there is active data in the band"
                },
                () => this.showAlert()
            );
        } else {
            this.setState(
                {
                    project: { ...project, [key]: checked ? "yes" : "no" }
                },
                () => checked && ReactTooltip.rebuild()
            );
        }
    };

    checkAnyActiveData = field => {
        const { recommendation_custom_fields: bands = [] } = this.props.recommendationsReducer.dynamicFields;

        const { project } = this.state;
        let fields = [];
        let data =
            ["energy_band", "water_band"].includes(field) && this.state.staticLinking?.[field === "energy_band" ? "energy" : "water"]
                ? project?.dynamic_fields
                : project[field];
        let valueFound = false;
        switch (field) {
            case "energy_band":
                if (this.state.staticLinking.energy) {
                    const { dynamic_fields } = this.state.project;
                    let dynamicFieldValue = [];
                    if (dynamic_fields && Object.keys(dynamic_fields)?.length) {
                        Object.keys(dynamic_fields).forEach(eField => {
                            Object.values(bands).forEach(eachFields => {
                                eachFields.forEach(e => {
                                    if (e?.field_name === eField && e?.link_static_entity === "water") {
                                        dynamicFieldValue = [...dynamicFieldValue, { key: e?.field_name }];
                                    }
                                });
                            });
                        });
                    }
                    fields = dynamicFieldValue;
                } else fields = energy_fields;
                break;
            case "water_band":
                if (this.state.staticLinking.water) {
                    const { dynamic_fields } = this.state.project;
                    let dynamicFieldValue = [];
                    if (dynamic_fields && Object.keys(dynamic_fields)?.length) {
                        Object.keys(dynamic_fields).forEach(eField => {
                            Object.values(bands).forEach(eachFields => {
                                eachFields.forEach(e => {
                                    if (e?.field_name === eField && e?.link_static_entity === "water") {
                                        dynamicFieldValue = [...dynamicFieldValue, { key: e?.field_name }];
                                    }
                                });
                            });
                        });
                    }
                    fields = dynamicFieldValue;
                } else fields = water_fields;
                break;

            default:
                break;
        }
        valueFound = fields.some(f => data[f.key]);
        return valueFound;
    };
    showAlert = () => showAlertUtil(this.state.alertMessage);

    validateEnergyWaterFields = isCR => {
        const { project } = this.state;
        let isValidate = true;
        let errorMessage = "";

        const checkField = (key, label, container) => {
            if (!isValidate) return;
            if (!this.isFieldRequired(key, isCR)) return;
            const value = project?.[container]?.[key];
            const isEmpty = value === "" || value === null || value === undefined;
            if (isEmpty) {
                isValidate = false;
                errorMessage = `* ${label} is required`;
            }
        };

        if (project.energy_band_show === "yes") {
            checkField("annual_savings", "10-Year Energy Savings ($)", "energy_band");
            checkField("total_captial_spending_plan_kbtu_savings", "10-Year Energy Savings (kBTU)", "energy_band");
            checkField("implementation_cost", "Cost to Implement (ECM)", "energy_band");
            checkField("simple_payback", "Simple Payback (Yrs)", "energy_band");
            checkField("annual_nat_gas_savings", "Annual Natural Gas Savings (MMBTU)", "energy_band");
            checkField("annual_elec_savings", "Annual Electricity Savings (kWH)", "energy_band");
            checkField("annual_energy_savings", "Annual Energy Savings ($)", "energy_band");
            checkField("annual_cost_to_implement_ecm", "Annual Cost to Implement ECM ($)", "energy_band");
        }

        if (project.water_band_show === "yes") {
            checkField("annual_savings_water", "Annual Savings Opportunity ($)", "water_band");
            checkField("safety_concerns", "Identified Safety Concerns", "water_band");
            checkField("simple_payback_water", "Simple Payback (Yrs)", "water_band");
        }

        return { isValidate, errorMessage };
    };

    validateDynamicFields = () => {
        const {
            project: { dynamic_fields, energy_band_show, water_band_show },
            staticLinking
        } = this.state;
        const { recommendation_custom_fields: bands = [] } = this.props.recommendationsReducer.dynamicFields;
        const isCR = qs.parse(this.props.location?.search || "")?.is_cr === "true";
        let isValidate = true;
        let errorMessage = "";

        for (const [, fields] of Object.entries(bands)) {
            for (const field of fields) {
                const rules = field?.rules || {};
                const visibleType = rules.visible_type ?? "both";
                const visible = visibleType === "both" || (isCR ? visibleType === "cr_only" : visibleType === "recommendation_only");
                if (!visible) continue;
                if (field.link_static_entity === "energy" && !(staticLinking?.energy && energy_band_show === "yes")) continue;
                if (field.link_static_entity === "water" && !(staticLinking?.water && water_band_show === "yes")) continue;
                const fieldValue = dynamic_fields?.[field?.field_name];
                const mandatory = this.isFieldRequired(field?.field_name, isCR) || !!rules?.mandatory;
                const isRequired = mandatory && !fieldValue?.toString()?.trim()?.length;
                const regex = new RegExp(rules?.regex);
                const invalid =
                    (field?.field_type === DYNAMIC_FIELD_TYPES.TEXT || field?.field_type === DYNAMIC_FIELD_TYPES.MEMO) &&
                    fieldValue?.toString()?.trim()?.length &&
                    regex &&
                    !regex?.test(fieldValue);
                if (isRequired) {
                    isValidate = false;
                    errorMessage = `* ${field.label} is required`;
                    return { isValidate, errorMessage };
                } else if (invalid) {
                    isValidate = false;
                    errorMessage = `* Please enter a valid ${field.label}`;
                    return { isValidate, errorMessage };
                }
            }
        }

        return { isValidate, errorMessage };
    };

    isFieldLocked = field_name => {
        const fieldConfig = this.props.projectReducer?.getRecommendationFieldConfigsResponse?.recommendation_field_configs || [];
        const configName = FIELD_CONFIG_ALIASES[field_name] || field_name;
        return fieldConfig.find(field => field.field_name === configName)?.is_locked || false;
    };

    isFieldRequired = (field_name, isCR) => {
        const fieldConfig = this.props.projectReducer?.getRecommendationFieldConfigsResponse?.recommendation_field_configs || [];
        const configName = FIELD_CONFIG_ALIASES[field_name] || field_name;
        const row = fieldConfig.find(field => field.field_name === configName);
        if (!row) return false;
        return isCR ? !!row.is_required_capital_request : !!row.is_required_recommendation;
    };

    getVisibleStaticBandFields = staticBandName => {
        const { recommendation_custom_fields = {} } = this.props.recommendationsReducer?.dynamicFields || {};
        const {
            project: { energy_band_show, water_band_show },
            staticLinking
        } = this.state;
        const isCR = qs.parse(this.props.location?.search || "")?.is_cr === "true";
        const fields = Object.entries(recommendation_custom_fields).flatMap(([bandName, fields]) =>
            (fields || []).map(field => ({ ...field, group_field: field?.group_field || bandName }))
        );

        return fields.filter(field => {
            if (field?.is_static_band !== true || field?.group_field !== staticBandName) return false;
            const rules = field?.rules || {};
            const visibleType = rules.visible_type ?? "both";
            const visible = visibleType === "both" || (isCR ? visibleType === "cr_only" : visibleType === "recommendation_only");
            if (!visible) return false;
            if (field.link_static_entity === "energy" && !(staticLinking?.energy && energy_band_show === "yes")) return false;
            if (field.link_static_entity === "water" && !(staticLinking?.water && water_band_show === "yes")) return false;
            return true;
        });
    };

    renderGeoHierarchyDynamicFields = ({ project, showErrorBorder, isCR, isMR }) => {
        const fields = this.getVisibleStaticBandFields("Geo Hierarchy");
        const rows = [];
        let currentRow = [];
        let currentSpan = 0;
        
        fields.forEach(elem => {
            const span = Math.min(Number(elem.rules?.column_span) || 1, 4);
            if (currentSpan + span > 4) {
                rows.push(currentRow);
                currentRow = [];
                currentSpan = 0;
            }
            currentRow.push({ elem, span });
            currentSpan += span;
        });
        if (currentRow.length) rows.push(currentRow);

        return rows.map((row, rowIdx) => (
            <React.Fragment key={`geo-hierarchy-dynamic-${rowIdx}`}>
                {row.map(({ elem, span }) => (
                    <DynamicBandField
                        key={elem.field_name}
                        fieldType={elem.field_type}
                        onChange={(key, value) =>
                            this.handleChangeBandData({
                                dynamic_fields: { ...(project.dynamic_fields || {}), [key]: value }
                            })
                        }
                        value={project.dynamic_fields?.[elem?.field_name] || ""}
                        fieldKey={elem.field_name}
                        label={elem.label}
                        handleBandClick={() => this.handleBandClick("band2", true)}
                        fieldItem={elem}
                        showErrorBorder={showErrorBorder}
                        isFieldLocked={this.isFieldLocked}
                        isFieldRequired={this.isFieldRequired}
                        isCR={isCR}
                        isRecommendation
                        bandData={project.dynamic_fields || {}}
                        colSize={span * 3}
                        isMR={isMR}
                    />
                ))}
                {(() => {
                    const used = row.reduce((sum, r) => sum + r.span, 0);
                    const cols = (4 - used) * 3;
                    return cols > 0 ? <div className={`txt-rcm col-md-${cols} dynamic-cell`} /> : null;
                })()}
            </React.Fragment>
        ));
    };

    renderAdditionalDetailsDynamicFields = ({ project, showErrorBorder, isCR, isMR }) => {
        const fields = this.getVisibleStaticBandFields("Additional Details");
        const rows = [];
        let currentRow = [];
        let currentSpan = 0;

        fields.forEach(elem => {
            const span = Math.min(Number(elem.rules?.column_span) || 1, 4);
            if (currentSpan + span > 4) {
                rows.push(currentRow);
                currentRow = [];
                currentSpan = 0;
            }
            currentRow.push({ elem, span });
            currentSpan += span;
        });
        if (currentRow.length) rows.push(currentRow);

        return rows.map((row, rowIdx) => (
            <React.Fragment key={`additional-details-dynamic-${rowIdx}`}>
                {row.map(({ elem, span }) => (
                    <DynamicBandField
                        key={elem.field_name}
                        fieldType={elem.field_type}
                        onChange={(key, value) =>
                            this.handleChangeBandData({
                                dynamic_fields: { ...(project.dynamic_fields || {}), [key]: value }
                            })
                        }
                        value={project.dynamic_fields?.[elem?.field_name] || ""}
                        fieldKey={elem.field_name}
                        label={elem.label}
                        handleBandClick={() => this.handleBandClick("band6", true)}
                        fieldItem={elem}
                        showErrorBorder={showErrorBorder}
                        isFieldLocked={this.isFieldLocked}
                        isFieldRequired={this.isFieldRequired}
                        isCR={isCR}
                        isRecommendation
                        bandData={project.dynamic_fields || {}}
                        colSize={span * 3}
                        isMR={isMR}
                    />
                ))}
                {(() => {
                    const used = row.reduce((sum, r) => sum + r.span, 0);
                    const cols = (4 - used) * 3;
                    return cols > 0 ? <div className={`txt-rcm col-md-${cols} dynamic-cell`} /> : null;
                })()}
            </React.Fragment>
        ));
    };

    isYearRemovable = year => {
        if (!checkPermission("forms", permissions.RECOMMENDATION_CSP_YEAR, "delete")) return false;
        const { start, end } = this.state.siteCspYears;
        const { maintenance_years } = this.state.project;
        if (!maintenance_years?.length) {
            return false;
        }
        let isYearOutsideCsp = true;
        if (start && end) {
            if (year >= start && year <= end) {
                isYearOutsideCsp = false;
            } else {
                isYearOutsideCsp = true;
            }
        }
        const firstYear = maintenance_years[0].year;
        const lastYear = maintenance_years[maintenance_years.length - 1].year;
        const isFirstYear = year === firstYear;
        const isLastYear = year === lastYear;
        return isYearOutsideCsp && (isFirstYear || isLastYear);
    };

    renderYearRemoveConfirmationModal = () => {
        const { showYearRemoveConfirmation, selectedRemoveYear } = this.state;
        if (!showYearRemoveConfirmation) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Are you sure you want to remove the last year, including the associated amount?`}
                        type="cancel"
                        message={""}
                        onNo={() => this.setState({ showYearRemoveConfirmation: false })}
                        onYes={() => {
                            this.setState({ showYearRemoveConfirmation: false });
                            this.onRemoveMaintenanceYearConfirm(selectedRemoveYear);
                        }}
                    />
                }
                onCancel={() => this.setState({ showYearRemoveConfirmation: false })}
            />
        );
    };

    renderSiteCspYearChangeConfirmationModal = () => {
        const { pendingSiteCspYearChange } = this.state;
        if (!pendingSiteCspYearChange?.outOfScopeValuedYears?.length) return null;

        const years = pendingSiteCspYearChange.outOfScopeValuedYears.map(item => item.year).join(", ");
        const isMultipleYears = pendingSiteCspYearChange.outOfScopeValuedYears.length > 1;
        const message = `The previous CSP year${isMultipleYears ? "s" : ""} ${years} ${
            isMultipleYears ? "include" : "has"
        } a value but ${isMultipleYears ? "are" : "is"} outside the new site's CSP year definition. Do you want to keep ${
            isMultipleYears ? "them" : "it"
        }?`;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading="Keep CSP years outside the selected site's definition?"
                        type="cancel"
                        message={message}
                        clearBtnLabel="Remove"
                        ConfirmaBtnLabel="Keep"
                        onNo={() => this.applySiteCspYearChange(pendingSiteCspYearChange, false)}
                        onYes={() => this.applySiteCspYearChange(pendingSiteCspYearChange, true)}
                    />
                }
                onCancel={() => this.applySiteCspYearChange(pendingSiteCspYearChange, false)}
            />
        );
    };

    mergeSubsystemLinkedDynamicFields = (projectDynamicFields, subSystemId, subSystemArray) => {
        const subsystemItem = subSystemArray?.find(item => String(item.id) === String(subSystemId));
        return applySubsystemLinkedDynamicFields(projectDynamicFields, subsystemItem, this.props.recommendationsReducer?.dynamicFields);
    };

    handleSubsystemServiceLifeConfirmYes = async () => {
        const { pendingSubsystemChange, project, assetFormData } = this.state;
        const defaultSl = pendingSubsystemChange?.data ?? null;
        const { sub_system_id, trade_id, system_id } = pendingSubsystemChange;
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const isAsset = project.recommendation_type === RECOMMENDATION_TYPES.ASSET;
        const projectServiceLife = defaultSl === null ? project?.service_life : defaultSl;
        const assetServiceLife = defaultSl === null ? assetFormData?.service_life : defaultSl;
        const installedYear = isAsset ? assetFormData?.installed_year : project?.installed_year;
        const { projectPatch: silentCapitalPatch, nextAutoFilled } =
            defaultSl === null
                ? { projectPatch: {}, nextAutoFilled: undefined }
                : this.getSilentCapitalTypeMerge({
                      categoryId: project.category_id,
                      installedYear,
                      serviceLife: defaultSl,
                      capitalTypeId: project.recommendation_capital_type_id
                  });
        this.setState(
            {
                showSubsystemServiceLifeConfirm: false,
                pendingSubsystemChange: null,
                ...(nextAutoFilled !== undefined ? { autoFilledCapitalTypeId: nextAutoFilled } : {}),
                project: {
                    ...project,
                    sub_system_id: sub_system_id,
                    trade_id: trade_id ? trade_id : project.trade_id,
                    system_id: system_id ? system_id : project.system_id,
                    service_life: projectServiceLife,
                    usefull_life_remaining:
                        defaultSl === null ? project?.usefull_life_remaining : getUsefullLifeRemaining(project?.installed_year, defaultSl),
                    dynamic_fields: this.mergeSubsystemLinkedDynamicFields(
                        project.dynamic_fields,
                        sub_system_id,
                        this.state.subSystemArray
                    ),
                    ...silentCapitalPatch
                },
                assetFormData: {
                    ...assetFormData,
                    sub_system_id: sub_system_id,
                    trade_id: trade_id ? trade_id : assetFormData.trade_id,
                    system_id: system_id ? system_id : assetFormData.system_id,
                    service_life: assetServiceLife,
                    usefull_life_remaining:
                        defaultSl === null ? assetFormData?.usefull_life_remaining : getUsefullLifeRemaining(assetFormData?.installed_year, defaultSl)
                }
            },
            () =>
                sub_system_id
                    ? this.getRecommendationTemplates(this.state.project.sub_system_id)
                    : this.getRecommendationTemplates(undefined, query.p_id)
        );
        await this.props.getSubSystemBasedOnProject(query.p_id, system_id, this.state.project.trade_id);
        const datas = this.props.recommendationsReducer?.getSubSystemByProject?.sub_systems || [];
        this.setState({
            subSystemArray: datas
        });
    };

    handleSubsystemServiceLifeConfirmNo = async () => {
        const { project, pendingSubsystemChange } = this.state;
        const defaultSl = pendingSubsystemChange?.data;
        const { sub_system_id, trade_id, system_id } = pendingSubsystemChange;
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        this.setState({ showSubsystemServiceLifeConfirm: false });
        const isClear = defaultSl === null;
        this.setState(
            {
                project: {
                    ...this.state?.project,
                    sub_system_id: sub_system_id,
                    trade_id: trade_id ? trade_id : project.trade_id,
                    system_id: system_id ? system_id : project.system_id,
                    ...(isClear ? { service_life: "", usefull_life_remaining: "" } : {}),
                    dynamic_fields: this.mergeSubsystemLinkedDynamicFields(project.dynamic_fields, sub_system_id, this.state.subSystemArray)
                },
                assetFormData: {
                    ...this.state?.assetFormData,
                    sub_system_id: sub_system_id,
                    trade_id: trade_id ? trade_id : project.trade_id,
                    system_id: system_id ? system_id : project.system_id,
                    ...(isClear ? { service_life: "", usefull_life_remaining: "" } : {})
                }
            },
            () =>
                sub_system_id
                    ? this.getRecommendationTemplates(this.state.project.sub_system_id)
                    : this.getRecommendationTemplates(undefined, query.p_id)
        );
        await this.props.getSubSystemBasedOnProject(query.p_id, system_id, this.state.project.trade_id);
        const datas = this.props.recommendationsReducer?.getSubSystemByProject?.sub_systems || [];
        this.setState({
            subSystemArray: datas
        });
        this.setState({ pendingSubsystemChange: null });
    };

    handleSubsystemServiceLifeApply = selectedFields => {
        const { pendingSubsystemChange } = this.state;
        const applyServiceLife = !!selectedFields?.includes("service_life");
        // When the new Sub System has no Service Life definition, updating Service Life means clearing it,
        // which is what the "No" path does; otherwise the "Yes" path applies the new definition.
        const shouldUseClearPath = pendingSubsystemChange?.data === null ? applyServiceLife : !applyServiceLife;
        return shouldUseClearPath ? this.handleSubsystemServiceLifeConfirmNo() : this.handleSubsystemServiceLifeConfirmYes();
    };

    cancelPendingSubsystemChange = () => this.setState({ showSubsystemServiceLifeConfirm: false, pendingSubsystemChange: null });

    getSubSystemName = id => (id ? ((this.state.subSystemArray || []).find(item => item?.id === id)?.name ?? "") : "");

    renderSubsystemServiceLifeConfirmationModal = () => {
        const { showSubsystemServiceLifeConfirm, pendingSubsystemChange, assetFormData, project } = this.state;

        if (!showSubsystemServiceLifeConfirm) return null;

        const defaultSl = pendingSubsystemChange?.data;
        const isAsset = project?.recommendation_type === RECOMMENDATION_TYPES.ASSET;

        const installedYear = isAsset ? assetFormData?.installed_year : project?.installed_year;

        const oldULR = isAsset
            ? assetFormData?.usefull_life_remaining || assetFormData?.usefull_life_remaining === 0
                ? assetFormData?.usefull_life_remaining
                : "null"
            : project?.usefull_life_remaining || project?.usefull_life_remaining === 0
              ? project?.usefull_life_remaining
              : "null";

        const newULR = getUsefullLifeRemaining(installedYear, defaultSl);

        const oldEndOfServiceLife = isAsset
            ? assetFormData?.usefull_life_remaining || assetFormData?.usefull_life_remaining === 0
                ? new Date().getFullYear() + assetFormData?.usefull_life_remaining
                : "null"
            : project?.installed_year && project?.service_life
              ? parseInt(project?.installed_year) + parseInt(project?.service_life)
              : "null";

        const newEndOfServiceLife = isAsset
            ? newULR || newULR === 0
                ? new Date().getFullYear() + newULR
                : "null"
            : project?.installed_year && (defaultSl || defaultSl === 0)
              ? parseInt(project?.installed_year) + parseInt(defaultSl)
              : "null";
        const currentServiceLife = isAsset
            ? assetFormData?.service_life || assetFormData?.service_life === 0
                ? assetFormData?.service_life
                : "null"
            : project?.service_life || project?.service_life === 0
              ? project?.service_life
              : "null";

        const hasInstalledYear = installedYear !== null && installedYear !== undefined && installedYear;
        const rows = [
            { field: "service_life", label: "Service Life", from: currentServiceLife, to: defaultSl },
            ...(hasInstalledYear
                ? [
                      { field: "end_of_service_life", label: "End of Service Life", derived: true, from: oldEndOfServiceLife, to: newEndOfServiceLife },
                      { field: "usefull_life_remaining", label: "Useful Life Remaining", derived: true, from: oldULR, to: newULR }
                  ]
                : [])
        ];

        return (
            <Portal
                body={
                    <ServiceLifeChangeConfirmationModal
                        sourceLabel="Sub System"
                        entityLabel="Recommendation"
                        sourceFrom={this.getSubSystemName(isAsset ? assetFormData?.sub_system_id : project?.sub_system_id)}
                        sourceTo={this.getSubSystemName(pendingSubsystemChange?.sub_system_id)}
                        rows={rows}
                        onApply={this.handleSubsystemServiceLifeApply}
                        onCancel={this.cancelPendingSubsystemChange}
                    />
                }
                onCancel={this.cancelPendingSubsystemChange}
            />
        );
    };

    toggleConfirmModal = () => {
        this.setState({ showConfirmSave: !this.state.showConfirmSave });
    };

    handleSaveOrUpdate = () => {
        this.setState({ isAddOrEdit: true });

        const userRole = localStorage.getItem("role");
        const { getProjectByIdResponse } = this.props.projectReducer || {};

        const { miscellaneous } = getProjectByIdResponse || {};
        const { project, costTotal } = this.state;

        const show_opinions_cost_diff_indicator =
            (userRole === "super_admin" || userRole === "consultancy_user") &&
            miscellaneous?.display_unit &&
            Math.round(costTotal) !== Math.round(project.total_opinions_of_cost);

        if (show_opinions_cost_diff_indicator) {
            this.toggleConfirmModal();
        } else {
            this.addProject();
        }
    };

    renderSaveConfirmationModal = () => {
        const { showConfirmSave } = this.state;
        if (!showConfirmSave) return null;

        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={`The construction cost does not match the total opinions of cost. Are you sure you want to ${
                            this.state.selectedProject ? "update" : "save"
                        }? `}
                        onNo={this.toggleConfirmModal}
                        onYes={() => {
                            this.toggleConfirmModal();
                            this.addProject();
                        }}
                        cancel={this.toggleConfirmModal}
                    />
                }
                onCancel={this.toggleConfirmModal}
            />
        );
    };

    fetchOptions = async (inputValue, keyItem) => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        this.setState({ isLoadingDrop: true, inputValue });
        const { building_id, region_id, site_id } = this.state.project;
        if (keyItem === "building") {
            await this.props.getDropdownList("project_buildings", {
                search: inputValue,
                project_id: query?.p_id,
                current_building_id: building_id,
                region_id,
                site_id
            });
        } else if (keyItem === "site") {
            await this.props.getDropdownList("project_sites", {
                search: inputValue,
                project_id: query?.p_id,
                current_site_id: site_id,
                region_id
            });
        } else {
            await this.props.getDropdownList("manufacturers", {
                search: inputValue,
                current_manufacturer: this.state.assetFormData?.manufacturer_id && this.state.assetFormData?.manufacturer_id,
                client_id: query?.c_id || this.state.project.client_id
            });
        }
        this.setState({ isLoadingDrop: false });
    };

    handleInputChange = (newValue, { action }, keyItem) => {
        if (action === "input-change" || action === "input-click") {
            this.fetchOptions(newValue, keyItem);
            return newValue;
        }
    };

    toggleVoiceNoteModal = () => {
        this.setState({ showVoiceNoteModal: !this.state.showVoiceNoteModal });
    };

    toggleVideoNoteModal = () => {
        this.setState({ showVideoNotesModal: !this.state.showVideoNotesModal });
    };

    toggleImagesModal = () => {
        this.setState({ showImageModal: !this.state.showImageModal });
    };

    renderVoiceNoteModal = () => {
        if (!this.state.showVoiceNoteModal) return null;

        const {
            location: { search },
            match
        } = this.props;
        const query = qs.parse(search);
        const isMR = query.is_mr === "true";
        const isMobileRecomEdit = isMR && match?.params?.section === "edit";

        return (
            <Portal
                body={
                    <VoiceVideoPortal
                        tableComponent={
                            <VoiceNotesTable
                                isRecommendation
                                isModal
                                mobileRecommendationId={isMobileRecomEdit ? match?.params?.id : query?.s_id}
                                isMobileRegularRecom={isMR && match?.params?.section === "edit"}
                            />
                        }
                        onCancel={this.toggleVoiceNoteModal}
                        heading="Voice Notes"
                    />
                }
                onCancel={this.toggleVoiceNoteModal}
            />
        );
    };

    renderVideoNoteModal = () => {
        if (!this.state.showVideoNotesModal) return null;
        const {
            location: { search },
            match
        } = this.props;
        const query = qs.parse(search);
        const isMR = query.is_mr === "true";
        const isMobileRecomEdit = isMR && match?.params?.section === "edit";
        return (
            <Portal
                body={
                    <VoiceVideoPortal
                        tableComponent={
                            <VideoTable
                                isRecommendation
                                isModal
                                mobileRecommendationId={isMobileRecomEdit ? match?.params?.id : query?.s_id}
                                isMobileRegularRecom={isMR && match?.params?.section === "edit"}
                            />
                        }
                        onCancel={this.toggleVideoNoteModal}
                        heading="Videos"
                    />
                }
                onCancel={this.toggleVideoNoteModal}
            />
        );
    };

    renderImageModal = () => {
        if (!this.state.showImageModal) return null;
        const {
            location: { search },
            match
        } = this.props;
        const query = qs.parse(search);
        const isMR = query.is_mr === "true";
        const isMobileRecomEdit = isMR && match?.params?.section === "edit";
        return (
            <Portal
                body={
                    <VoiceVideoPortal
                        tableComponent={
                            <InfoImages
                                isRecommendation
                                // updateImageComment={updateImageComment}
                                // isMobileRecommendation
                                mobileRecommendationId={isMobileRecomEdit ? match?.params?.id : query?.s_id}
                                isMobRecom={true}
                                basicDetails={{
                                    region_id: { uuid: this.state?.project?.region_id },
                                    client_id: { uuid: this.state?.project?.client_id ?? query?.c_id },
                                    site_id: { uuid: this.state?.project?.site_id },
                                    building_id: { uuid: this.state?.project?.building_id }
                                }}
                                isMobileRegularRecom={isMR && match?.params?.section === "edit"}
                                hasCreate={false}
                            />
                        }
                        onCancel={this.toggleImagesModal}
                        heading="Images"
                        isImage
                    />
                }
                onCancel={this.toggleImagesModal}
            />
        );
    };

    onShowInfo = data => {
        this.setState({ showInfoModal: data });
    };
    renderSiteBuildingModal = () => {
        const { showInfoModal } = this.state;

        if (!showInfoModal?.name) return null;
        return (
            <Portal
                body={
                    <SiteBuildingInfoModal
                        onCancel={() => this.setState({ showInfoModal: false })}
                        basicDetails={showInfoModal?.data}
                        infoType={showInfoModal?.name}
                    />
                }
                onCancel={() => this.setState({ showInfoModal: false })}
            />
        );
    };

    renderImagePopup = () => {
        const {
            location: { search },
            match
        } = this.props;
        const query = qs.parse(search);
        const { imagePopup } = this.state;
        const isMR = query?.is_mr === "true";
        if (!imagePopup) return null;
        const { images = [] } = this.props.recommendationsReducer?.getAllImagesResponse || {};
        return (
            <Portal
                body={
                    <ImageViewV2
                        initialImages={
                            query?.s_id
                                ? [
                                      ...(this.props?.assetSurveyProjectReducer?.getSurveyRecommendationsImagesById?.data?.image ?? []),
                                      ...(this.props?.assetSurveyProjectReducer?.getSurveyRecommendationsImagesById?.data?.added_image ?? [])
                                  ]
                                : images
                        }
                        initialSelectedId={null}
                        onCancel={() => this.setState({ imagePopup: false })}
                        isSurveyAssetView={query?.s_id ? true : false}
                        noOverlay={true}
                    />
                }
                noOverlay={true}
                onCancel={() => this.setState({ imagePopup: false })}
            />
        );
    };

    setCheckListData = checkListData => {
        this.setState({ checkListData });
    };

    render() {
        const {
            project,
            initialValues,
            regionList,
            showBand,
            recommendationSuggestions,
            assetFormData,
            clients,
            isLoading,
            loading,
            showErrorBorder,
            priorityElementsData,
            criticalityData,
            costTotal,
            selectedProject,
            birth_year,
            selectedImage,
            criticalityTypeData,
            staticLinking
        } = this.state;
        const {
            assetReducer: { dropDownList }
        } = this.props;
        const {
            location: { search }
        } = this.props;

        const query = qs.parse(search);
        const isFMPUser = localStorage.getItem("fmp_user") === "yes" ? true : false;
        const isIRUser = localStorage.getItem("infrastructure_request_user") === "yes" ? true : false;
        const { getProjectByIdResponse } = this.props.projectReducer;
        const { miscellaneous } = getProjectByIdResponse || {};

        const userRole = localStorage.getItem("role");
        const show_opinions_cost_diff_indicator =
            (userRole === "super_admin" || userRole === "consultancy_user") &&
            miscellaneous?.display_unit &&
            Math.round(costTotal) !== Math.round(project.total_opinions_of_cost);
        const birthYear = selectedProject ? birth_year : project.maintenance_years?.find(year => parseInt(year.amount) > 0)?.year || "";
        const { is_edited, s3_eimage_key, s3_image_key } = selectedImage?.master_image || {};
        const imageUrl = is_edited ? `${s3_eimage_key}` : `${s3_image_key}`;
        const isCR = query.is_cr === "true";
        const crLabel = getCapitalRequestLabel(miscellaneous);
        const crNarrativeLabel = getCapitalRequestNarrativeLabel(miscellaneous);
        const crStatusLabel = getCapitalRequestStatusLabel(miscellaneous);
        const crStatusNotesLabel = getCapitalRequestStatusNotesLabel(miscellaneous);
        const isMR = query.is_mr === "true";
        let isCRApprover = userRole === "super_admin" || localStorage.getItem("crApprover") === "true";
        const groupedOptions = (this.props?.recommendationStatusReducer?.getStatusDropdwnResponse?.recommendation_status_data || [])
            .reduce((acc, item) => {
                if (item?.key === "deleted") return acc;
                const groupName = item?.group_name || "Others";

                let group = acc.find(g => g?.label === groupName);
                if (!group) {
                    group = { label: groupName, options: [] };
                    acc.push(group);
                }
                group.options.push({
                    label: item?.name,
                    value: item?.id,
                    description: item?.description,
                    key: item?.key
                });

                return acc;
            }, [])
            ?.sort((a, b) => {
                return (a.label === "Others") - (b.label === "Others") || a.label.localeCompare(b.label);
            });

        const Cr_status_options = [
            ...CAPITAL_REQUEST_STATUS.filter(item => !["not_approved", "deferred_to_next_year"].includes(item?.id)).map(e => ({
                id: e?.id,
                name: e?.name,
                disabled: e?.disabled ?? false
            })),
            ...CAPITAL_REQUEST_STATUS.filter(item => item?.id === "not_approved").map(e => ({
                id: e?.id,
                name: e?.name,
                disabled: e?.disabled ?? false,
                hasSeparator: true
            })),
            ...CAPITAL_REQUEST_STATUS.filter(item => item?.id === "deferred_to_next_year").map(e => ({
                id: e?.id,
                name: e?.name,
                disabled: e?.disabled ?? false,
                hasSeparator: true
            }))
        ];

        const prefix = this.getCodePrefix(project?.code || "");
        const digits = this.getCodeDigits(project?.code || "");

        const hasCspAddPermission = checkPermission("forms", permissions.RECOMMENDATION_CSP_YEAR, "create");
        const formContextClientName = resolveFormContextClientName({
            projectClientName: getProjectByIdResponse?.client?.name,
            recommendationClientName: this.props.recommendationsReducer?.getRecommendationByIdResponse?.client?.name,
            queryClientId: query.c_id,
            clientsList: this.props.projectReducer?.getAllClientsResponse?.clients
        });
        const formContextBanner = getFormContextBanner({
            section: this.props.match?.params?.section,
            selectedId: selectedProject,
            query,
            isCapitalRequest: isCR,
            crLabel,
            clientName: formContextClientName,
            sourceCode: query.capital_request_id ? getConvertSourceCode() : ""
        });
        return (
            <LoadingOverlay active={loading || isLoading} spinner={<Loader />} fadeSpeed={10}>
                {this.state.showNoteModal && (
                    <Portal
                        body={
                            <RecommendationNoteEdit
                                notes={this.state.project.note_html}
                                onCancel={() => this.setState({ showNoteModal: false })}
                                isRecommendationView={true}
                                handleChangeNote={this.handleChangeNote}
                                subSystemId={this.state.project.sub_system_id}
                                toggleShowReportNoteTemplateModal={this.toggleShowReportNoteTemplateModal}
                            />
                        }
                        onCancel={() => this.setState({ showNoteModal: false })}
                    />
                )}

                <div className="dtl-sec col-md-12">
                    <ReactTooltip
                        id="recommendation_details"
                        effect="solid"
                        place="top"
                        backgroundColor="#007bff"
                        className="rc-tooltip-custom-class rich-text-tooltip"
                        html={true}
                        getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                    />
                    <div className="tab-dtl region-mng additional-dtl addition-edit">
                        <div className="topper-rec-nav">
                            <ul>
                                <div className="recom-notify-img">
                                    <img
                                        src={recomIcon}
                                        alt=""
                                        data-tip={`${isCR ? crLabel : "Recommendation"} in Edit or New mode.\nChanges not saved yet!`}
                                        data-for="recommendation_details"
                                        data-place="top"
                                    />
                                </div>
                                <li
                                    className={this.state.activeDetail === "Main Details" ? "active cursor-hand pl-4" : "cursor-hand pl-4"}
                                    onClick={() => this.setActiveTab("Main Details")}
                                >
                                    {(this.state.selectedProject ?? this.state.parentRecommendationId)
                                        ? `Edit ${isCR ? crLabel : "Recommendation"}`
                                        : query.type === RECOMMENDATION_SOURCE_TYPES.REGULAR
                                          ? `Add New ${isCR ? crLabel : "Recommendation"}`
                                          : query.type === RECOMMENDATION_SOURCE_TYPES.SIMILAR
                                            ? `Add Similar ${isCR ? crLabel : "Recommendation"}`
                                            : query.type === RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE
                                              ? `Add Duplicate - Full ${isCR ? crLabel : "Recommendation"}`
                                              : query.type === RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP
                                                ? `Add Duplicate ${isCR ? crLabel : "Recommendation"}`
                                                : query.type === RECOMMENDATION_SOURCE_TYPES.GEO_HIERARCHY
                                                  ? `Add Same Geo Hierarchy ${isCR ? crLabel : "Recommendation"}`
                                                  : `Add New ${isCR ? crLabel : "Recommendation"}`}
                                </li>
                                {project.recommendation_type === RECOMMENDATION_TYPES.ASSET && (
                                    <li
                                        className={this.state.activeDetail === "Asset Details" ? "active cursor-hand" : "cursor-hand"}
                                        onClick={() => this.setActiveTab("Asset Details")}
                                    >
                                        Asset
                                    </li>
                                )}
                                {miscellaneous?.checklist_survey && (
                                    <li
                                        className={this.state.activeDetail === "Checklists" ? "active cursor-hand" : "cursor-hand"}
                                        onClick={() => this.setActiveTab("Checklists")}
                                    >
                                        Checklists
                                    </li>
                                )}
                                {query?.is_mr && (
                                    <>
                                        <li className="cursor-hand" onClick={this.toggleVoiceNoteModal}>
                                            Voice Notes
                                        </li>
                                        <li className="cursor-hand" onClick={this.toggleVideoNoteModal}>
                                            Videos
                                        </li>
                                        <li className="cursor-hand" onClick={this.toggleImagesModal}>
                                            Images
                                        </li>
                                    </>
                                )}
                                <FormContextBanner banner={formContextBanner} />
                            </ul>
                            <div className="mr-2 text-right btnOtr mt-2 mb-2">
                                {this.state.showErrorBorder && this.state.errorMessage ? (
                                    <span className="recom-save-error">
                                        <i className="fas fa-exclamation-circle" />
                                        <EllipsisTooltipText
                                            className="recom-save-error-text"
                                            text={this.state.errorMessage.replace(/^\*\s*/, "")}
                                            tooltipPlace="bottom"
                                            tooltipClassName="recom-save-error-tooltip"
                                        />
                                    </span>
                                ) : null}
                                <span id={ASSET_FIELD_VISIBILITY_SLOT_ID} />
                                <button type="button" className="btn btn-secondary btnClr" onClick={() => this.confirmCancel()}>
                                    Cancel
                                </button>
                                {!this.state.loading ? (
                                    <button
                                        type="button"
                                        title={this.state.locked === true ? "You cannot update this item as this recommendation is locked!!!" : ""}
                                        className={`btn btn-primary btnRgion ml-2
                                                 ${this.state.locked === true ? "cursor-notallowed" : ""}`}
                                        disabled={this.state.locked === true || !!this.state.qaState}
                                        onClick={this.handleSaveOrUpdate}
                                    >
                                        {this.state.qaState ? "Validating…" : this.state.selectedProject ? "Update" : "Save"}
                                    </button>
                                ) : (
                                    <button type="button" className="btn btn-primary btnRgion ml-2">
                                        <div className="button-loader d-flex justify-content-center align-items-center">
                                            <div className="spinner-border text-white" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    </button>
                                )}
                            </div>
                        </div>
                        {this.state.activeDetail === "Main Details" ? (
                            <div
                                className={`tab-active location-sec recom-sec main-dtl-add recommendation-form add-recommendation ${
                                    project?.recommendation_type === RECOMMENDATION_TYPES.ASSET
                                        ? ""
                                        : query.type === "Regular"
                                          ? "building-type edit-ck-recom"
                                          : "building-type"
                                }`}
                            >
                                <div class="wrapper-id-check">
                                    {this.state.selectedProject && (
                                        <label htmlFor="" className="label-box-top txt-editable">
                                            {this.state.toggleInput ? (
                                                <>
                                                    {checkPermission("forms", "recommendation_code", "edit") && this.state.selectedProject && (
                                                        <div className="label-detl">
                                                            <NumberFormat
                                                                autoComplete="off"
                                                                className="custom-input form-control"
                                                                placeholder="ID"
                                                                value={digits}
                                                                prefix={prefix}
                                                                allowEmptyFormatting
                                                                allowLeadingZeros
                                                                isNumericString
                                                                decimalScale={0}
                                                                allowNegative={false}
                                                                inputMode="numeric"
                                                                onValueChange={({ value }) => {
                                                                    const next = value ?? "";
                                                                    this.setState(prev => ({
                                                                        project: {
                                                                            ...prev.project,
                                                                            code: `${prefix}${next}`
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="p-2">
                                                    <span className="label-txt"> ID: </span>{" "}
                                                    <EllipsisTooltipText className="label-detl" text={` ${project?.code}`} />{" "}
                                                </div>
                                            )}
                                            {checkPermission("forms", "recommendation_code", "edit") && this.state.selectedProject && (
                                                <button
                                                    data-tip={"Edit Code"}
                                                    data-for="recommendation_details"
                                                    data-place="top"
                                                    onClick={this.handleClick}
                                                >
                                                    <i className="fa fa-edit"></i>
                                                </button>
                                            )}
                                        </label>
                                    )}
                                    <div class="wrapper-check-box">
                                        {((this.props.recommendationsReducer?.getAllImagesResponse?.images?.length > 0 && selectedProject) ||
                                            ((this.props?.assetSurveyProjectReducer?.getSurveyRecommendationsImagesById?.data?.image?.length > 0 ||
                                                this.props?.assetSurveyProjectReducer?.getSurveyRecommendationsImagesById?.data?.added_image?.length >
                                                    0) &&
                                                query?.s_id)) && (
                                            <div class="wrapper-water-check">
                                                <label class="container-check">
                                                    <span
                                                        className="edit-icn-bx modal-view-icn  p-0"
                                                        onClick={() => this.setState({ imagePopup: !this.state.imagePopup })}
                                                        data-tip={"View Images"}
                                                        data-for="recommendation_details"
                                                        data-place="bottom"
                                                        data-effect="solid"
                                                    >
                                                        <img src="/img/img-icon.svg" alt="" />
                                                    </span>
                                                </label>
                                            </div>
                                        )}
                                        <div class="wrapper-water-check">
                                            <label class="container-check">
                                                <input
                                                    checked={project.red_line === "yes"}
                                                    type="checkbox"
                                                    name="red_line"
                                                    onChange={e => this.handleCheckBoxClick(e.target.name, e.target.checked)}
                                                />
                                                <span class="checkmark"></span>Redlining
                                            </label>
                                        </div>
                                        <div class="wrapper-water-check">
                                            <label class="container-check">
                                                <input
                                                    checked={project.continuous_fca === "yes"}
                                                    type="checkbox"
                                                    name="continuous_fca"
                                                    onChange={e => this.handleCheckBoxClick(e.target.name, e.target.checked)}
                                                />
                                                <span class="checkmark"></span>Continuous FCA
                                            </label>
                                        </div>
                                        {isCR && (
                                            <div class="wrapper-water-check">
                                                <label class={`container-check ${query.is_cr === "true" || isIRUser ? "cursor-diabled" : ""}`}>
                                                    <input
                                                        checked={project.infrastructure_request === "yes"}
                                                        type="checkbox"
                                                        disabled={query.is_cr === "true" || isIRUser}
                                                        name="infrastructure_request"
                                                        onChange={e => this.handleCheckBoxClick(e.target.name, e.target.checked)}
                                                    />
                                                    <span class="checkmark"></span>
                                                    {crLabel}
                                                </label>
                                            </div>
                                        )}
                                        <div class="wrapper-water-check">
                                            <label class="container-check">
                                                <input
                                                    checked={project.budget_priority === "yes"}
                                                    type="checkbox"
                                                    name="budget_priority"
                                                    onChange={e => this.handleCheckBoxClick(e.target.name, e.target.checked)}
                                                />
                                                <span class="checkmark"></span>Budget Priority
                                            </label>
                                        </div>
                                        <div class="wrapper-water-check">
                                            <label class={`container-check ${isFMPUser ? "cursor-diabled" : ""}`}>
                                                <input
                                                    checked={project.fmp === "yes"}
                                                    type="checkbox"
                                                    disabled={isFMPUser}
                                                    name="fmp"
                                                    onChange={e => this.handleCheckBoxClick(e.target.name, e.target.checked)}
                                                />
                                                <span class="checkmark"></span>Master Facility Plan
                                            </label>
                                        </div>
                                        {miscellaneous?.show_energy_band && (
                                            <div class="wrapper-water-check">
                                                <label class="container-check">
                                                    <input
                                                        checked={project.energy_band_show === "yes"}
                                                        type="checkbox"
                                                        name="energy_band_show"
                                                        onChange={e => this.handleCheckBoxClick(e.target.name, e.target.checked, "energy_band")}
                                                    />
                                                    <span class="checkmark"></span>Energy
                                                </label>
                                            </div>
                                        )}
                                        {miscellaneous?.show_water_band && (
                                            <div class="wrapper-energy-check">
                                                <label class="container-check">
                                                    <input
                                                        checked={project.water_band_show === "yes"}
                                                        type="checkbox"
                                                        name="water_band_show"
                                                        onChange={e => this.handleCheckBoxClick(e.target.name, e.target.checked, "water_band")}
                                                    />
                                                    <span class="checkmark"></span>Water
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className={`col-md-12 detail-recom ${this.state.selectedProject ? "add-details-outer height-over-newrc" : ""}`}>
                                    <div className="outer-rcm recommendations">
                                        <div className="cnt-sec">
                                            <div className="row">
                                                <div className={`col-md-8 ${this.state.selectedProject ? "" : "height-new-cp"}`}>
                                                    <div id="accordion" ref={this.templateRef}>
                                                        <RecommendationBand
                                                            label="Geo Hierarchy"
                                                            bandId="band2"
                                                            handleBandClick={this.handleBandClick}
                                                            isDefaultOpen
                                                            showBand={showBand}
                                                            MainFields={
                                                                <>
                                                                    <FormField
                                                                        label="Region"
                                                                        fieldKey="region"
                                                                        fieldParam="region_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options: regionList,
                                                                            rules: { mandatory: this.isFieldRequired("region", isCR) }
                                                                        }}
                                                                        bandId="band2"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={async value => {
                                                                            await this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    region_id: value
                                                                                },
                                                                                assetFormData: {
                                                                                    ...assetFormData,
                                                                                    region_id: value,
                                                                                    site_id: "",
                                                                                    building_id: "",
                                                                                    building_type: "",
                                                                                    addition_id: "",
                                                                                    floor_id: ""
                                                                                }
                                                                            });
                                                                            this.handleRegionSelect();
                                                                        }}
                                                                    />
                                                                    <FormField
                                                                        label="Site"
                                                                        fieldKey="site"
                                                                        fieldParam="site_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options: dropDownList?.project_sites || [],
                                                                            rules: { mandatory: this.isFieldRequired("site", isCR) }
                                                                        }}
                                                                        bandId="band2"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={value => this.handleSiteSelect(value)}
                                                                        isLoadingDrop={this.state?.isLoadingDrop}
                                                                        handleInputChange={this.handleInputChange}
                                                                        hasSearchFunction
                                                                    />
                                                                    <FormField
                                                                        label="Building"
                                                                        fieldKey="building"
                                                                        fieldParam="building_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options: dropDownList?.project_buildings || [],
                                                                            rules: { mandatory: this.isFieldRequired("building", isCR) }
                                                                        }}
                                                                        bandId="band1"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={this.handleBuildingSelect}
                                                                        isLoadingDrop={this.state?.isLoadingDrop}
                                                                        handleInputChange={this.handleInputChange}
                                                                        hasSearchFunction
                                                                    />
                                                                </>
                                                            }
                                                            RestFields={
                                                                <>
                                                                    {/* <FormField
                                                                        label="Building Type"
                                                                        fieldKey="building_type"
                                                                        fieldParam="building_type"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            rules: { mandatory: !isCR, read_only: true }
                                                                        }}
                                                                        bandId="band2"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={async e => {
                                                                            await this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    recommendation_type: e.target.value
                                                                                }
                                                                            });
                                                                            this.handleRecommendationTypeSelect();
                                                                        }}
                                                                    /> */}
                                                                    <FormField
                                                                        label="Addition"
                                                                        fieldKey="addition"
                                                                        fieldParam="addition_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options:
                                                                                project.building_id &&
                                                                                this.props.recommendationsReducer.getAdditionByBuilding?.additions,
                                                                            rules: { mandatory: this.isFieldRequired("addition", isCR) }
                                                                        }}
                                                                        bandId="band2"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={async value => {
                                                                            await this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    addition_id: value
                                                                                },
                                                                                assetFormData: {
                                                                                    ...assetFormData,
                                                                                    addition_id: value
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                    <FormField
                                                                        label="Floor"
                                                                        fieldKey="floor"
                                                                        fieldParam="floor_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options:
                                                                                project.building_id &&
                                                                                this.props.recommendationsReducer?.getFloorByBuilding?.floors,
                                                                            rules: { mandatory: this.isFieldRequired("floor", isCR) }
                                                                        }}
                                                                        bandId="band2"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={async value => {
                                                                            await this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    floor_id: value
                                                                                },
                                                                                assetFormData: {
                                                                                    ...assetFormData,
                                                                                    floor_id: value
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                    <FormField
                                                                        label="Room"
                                                                        fieldKey="room"
                                                                        fieldParam="room"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            rules: { mandatory: this.isFieldRequired("room", isCR) }
                                                                        }}
                                                                        bandId="band2"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={e =>
                                                                            this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    room: e.target.value
                                                                                },
                                                                                assetFormData: {
                                                                                    ...assetFormData,
                                                                                    room_number: e.target.value
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                    <FormField
                                                                        label="Space Type"
                                                                        fieldKey="recommendation_space_type_id"
                                                                        fieldParam="recommendation_space_type_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        isLoading={!!this.props.recommendationsReducer?.getSpaceTypeResponse?.loading}
                                                                        fieldItem={{
                                                                            field_options:
                                                                                this.props.recommendationsReducer?.getSpaceTypeResponse
                                                                                    ?.space_types_list,
                                                                            rules: {
                                                                                mandatory: this.isFieldRequired("space_type", isCR)
                                                                            }
                                                                        }}
                                                                        bandId="band2"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={value =>
                                                                            this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    recommendation_space_type_id: value
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                    {this.renderGeoHierarchyDynamicFields({
                                                                        project,
                                                                        showErrorBorder,
                                                                        isCR,
                                                                        isMR
                                                                    })}
                                                                </>
                                                            }
                                                        />
                                                        <RecommendationBand
                                                            label={isCR ? crLabel : "Recommendation"}
                                                            bandId="band1"
                                                            handleBandClick={this.handleBandClick}
                                                            isDefaultOpen
                                                            showBand={showBand}
                                                            MainFields={
                                                                <>
                                                                    <FormField
                                                                        label="Trade"
                                                                        fieldKey="trade"
                                                                        fieldParam="trade_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options:
                                                                                this.props.recommendationsReducer?.getTradeByProject?.trades,
                                                                            rules: { mandatory: this.isFieldRequired("trade", isCR) }
                                                                        }}
                                                                        bandId="band1"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={value => {
                                                                            this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    trade_id: value
                                                                                },
                                                                                assetFormData: {
                                                                                    ...assetFormData,
                                                                                    trade_id: value,
                                                                                    system_id: "",
                                                                                    sub_system_id: ""
                                                                                }
                                                                            });
                                                                            this.handleTrade(value);
                                                                        }}
                                                                    />
                                                                    <FormField
                                                                        label="System"
                                                                        fieldKey="system"
                                                                        fieldParam="system_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        isLoading={this.state.systemLoading}
                                                                        fieldItem={{
                                                                            field_options: this.state?.systemArray,
                                                                            rules: { mandatory: this.isFieldRequired("system", isCR) }
                                                                        }}
                                                                        bandId="band1"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={async value => {
                                                                            const tradeId = this.state.systemArray.find(
                                                                                r => r.id === value
                                                                            )?.trade_id;
                                                                            this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    system_id: value,
                                                                                    trade_id: tradeId ? tradeId : project.trade_id
                                                                                },
                                                                                assetFormData: {
                                                                                    ...assetFormData,
                                                                                    system_id: value,
                                                                                    trade_id: tradeId ? tradeId : assetFormData.trade_id,
                                                                                    sub_system_id: ""
                                                                                }
                                                                            });
                                                                            await this.handleSystem(value);
                                                                        }}
                                                                    />
                                                                    <FormField
                                                                        label="Sub-System"
                                                                        fieldKey="sub_system"
                                                                        fieldParam="sub_system_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        isLoading={this.state.subSystemLoading}
                                                                        fieldItem={{
                                                                            field_options: this.state.subSystemArray,
                                                                            rules: { mandatory: this.isFieldRequired("sub_system", isCR) }
                                                                        }}
                                                                        bandId="band1"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={async value => {
                                                                            const data = this.state?.subSystemArray.find(
                                                                                item => item.id === value
                                                                            )?.service_life;
                                                                            const tradeId = this.state.subSystemArray.find(
                                                                                r => r.id === value
                                                                            )?.trade_id;
                                                                            const systemId = this.state.subSystemArray.find(
                                                                                r => r.id === value
                                                                            )?.system_id;
                                                                            const query = qs.parse(search);
                                                                            const normalizedData = data ?? "";
                                                                            const normalizedCurrent =
                                                                                (this.state.project.recommendation_type === RECOMMENDATION_TYPES.ASSET
                                                                                    ? this.state.assetFormData?.service_life
                                                                                    : this.state.project.service_life) ?? "";
                                                                            if (String(normalizedData) !== String(normalizedCurrent) && value) {
                                                                                this.setState({
                                                                                    showSubsystemServiceLifeConfirm: true,
                                                                                    pendingSubsystemChange: {
                                                                                        data,
                                                                                        sub_system_id: value,
                                                                                        trade_id: tradeId ? tradeId : project.trade_id,
                                                                                        system_id: systemId ? systemId : project.system_id
                                                                                    }
                                                                                });
                                                                            } else {
                                                                              
                                                                                const mergedDynamicFields = this.mergeSubsystemLinkedDynamicFields(
                                                                                    project.dynamic_fields,
                                                                                    value,
                                                                                    this.state.subSystemArray
                                                                                );
                                                                                this.setState(
                                                                                    {
                                                                                        project: {
                                                                                            ...project,
                                                                                            sub_system_id: value,
                                                                                            trade_id: tradeId ? tradeId : project.trade_id,
                                                                                            system_id: systemId ? systemId : project.system_id,
                                                                                            service_life: data ||"",
                                                                                            usefull_life_remaining: getUsefullLifeRemaining(
                                                                                                project?.installed_year,
                                                                                                data || 0
                                                                                            ),
                                                                                            dynamic_fields: mergedDynamicFields
                                                                                        },
                                                                                        assetFormData: {
                                                                                            ...assetFormData,
                                                                                            sub_system_id: value,
                                                                                            trade_id: tradeId ? tradeId : assetFormData.trade_id,
                                                                                            system_id: systemId ? systemId : assetFormData.system_id,
                                                                                            service_life: data || "",
                                                                                            usefull_life_remaining: getUsefullLifeRemaining(
                                                                                                assetFormData?.installed_year,
                                                                                                data || 0
                                                                                            )
                                                                                        }
                                                                                    },
                                                                                    () =>
                                                                                        value
                                                                                            ? this.getRecommendationTemplates(
                                                                                                  this.state.project.sub_system_id
                                                                                              )
                                                                                            : this.getRecommendationTemplates(undefined, query.p_id)
                                                                                );
                                                                                await this.props.getSubSystemBasedOnProject(
                                                                                    query.p_id,
                                                                                    systemId,
                                                                                    this.state.project.trade_id
                                                                                );
                                                                                const datas =
                                                                                    this.props.recommendationsReducer?.getSubSystemByProject
                                                                                        ?.sub_systems || [];
                                                                                this.setState({
                                                                                    subSystemArray: datas
                                                                                });
                                                                            }
                                                                        }}
                                                                    />
                                                                </>
                                                            }
                                                            RestFields={
                                                                <>
                                                                    <FormField
                                                                        label="Type"
                                                                        fieldKey="type"
                                                                        fieldParam="recommendation_type"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        hasEmptyOption={false}
                                                                        fieldItem={{
                                                                            field_options: [
                                                                                { id: RECOMMENDATION_TYPES.ASSET, name: "Asset" },
                                                                                { id: RECOMMENDATION_TYPES.SYSTEM, name: "System" }
                                                                            ],
                                                                            rules: {
                                                                                mandatory: this.isFieldRequired("type", isCR),
                                                                                read_only: query.is_cr === "true"
                                                                            }
                                                                        }}
                                                                        bandId="band1"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={async value => {
                                                                            await this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    recommendation_type: value
                                                                                }
                                                                            });
                                                                            this.handleRecommendationTypeSelect();
                                                                        }}
                                                                    />
                                                                    <div className="txt-rcm pt-0 txt-rcm-full-w" ref={this.suggestionInputRef}>
                                                                        <div className="heading">
                                                                            <h3>{isCR ? crLabel : "Recommendation"} *</h3>
                                                                            <div>
                                                                                {this.state.project.sub_system_id && (
                                                                                    <button
                                                                                        className="btn btn-clear"
                                                                                        onClick={() => this.toggleShowRecommendationTemplateModal()}
                                                                                    >
                                                                                        <i className="fas fa-plus" /> Add Template
                                                                                    </button>
                                                                                )}
                                                                                <span className="ml-2">
                                                                                    {project.description?.length}/{this.state.captionLength}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className="content-inp-card"
                                                                            data-tip={
                                                                                this.isFieldLocked("description")
                                                                                    ? "This field is locked and cannot be edited"
                                                                                    : ""
                                                                            }
                                                                            data-for="recommendation_details"
                                                                        >
                                                                            <div className="form-group">
                                                                                <Autosuggest
                                                                                    suggestions={
                                                                                        typeof recommendationSuggestions[0] === "string"
                                                                                            ? recommendationSuggestions
                                                                                            : recommendationSuggestions.filter((e, i) => i <= 39)
                                                                                    }
                                                                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                                    getSuggestionValue={this.getSuggestionValue}
                                                                                    renderSuggestion={this.renderSuggestion}
                                                                                    renderSuggestionsContainer={this.renderSuggestionsContainer}
                                                                                    theme={{
                                                                                        ...autosuggestDefaultTheme,
                                                                                        suggestion:
                                                                                            typeof recommendationSuggestions[0] === "string"
                                                                                                ? "react-autosuggest__suggestion verb-suggestion-row"
                                                                                                : "react-autosuggest__suggestion"
                                                                                    }}
                                                                                    shouldRenderSuggestions={() => true}
                                                                                    onSuggestionSelected={(e, { suggestion }) =>
                                                                                        this.onSuggestionSelected(suggestion)
                                                                                    }
                                                                                    inputProps={{
                                                                                        type: "text",
                                                                                        maxLength: this.state.captionLength,
                                                                                        placeholder: `Enter ${
                                                                                            isCR ? crLabel : "Recommendation"
                                                                                        }`,
                                                                                        value: this.state.project.description,

                                                                                        onChange: (e, { newValue }) => this.handleDescriptionChange(newValue),
                                                                                        onFocus: () => {
                                                                                            if (
                                                                                                this.state.recommendationTemplateList?.length > 4 ||
                                                                                                this.getAcceptableVerbs().length > 4
                                                                                            ) {
                                                                                                this.scrollSuggestionsIntoView();
                                                                                            }
                                                                                        },

                                                                                        className: `${
                                                                                            this.state.liveVerbError ||
                                                                                            (this.state.showErrorBorder &&
                                                                                                !this.state.project.description?.trim().length)
                                                                                                ? "error-border "
                                                                                                : ""
                                                                                        }${this.state.shakeVerbField ? "verb-field-shake " : ""}custom-input form-control pr-5 ${
                                                                                            this.isFieldLocked("description") ? "grayed-out" : ""
                                                                                        }`,
                                                                                        disabled: this.isFieldLocked("description")
                                                                                    }}
                                                                                />
                                                                                <i
                                                                                    className="fas fa-times cursor-pointer recom-close-icon"
                                                                                    onClick={() =>
                                                                                        this.setState({
                                                                                            project: { ...project, description: "" },
                                                                                            liveVerbError: null,
                                                                                            forceShowVerbList: false
                                                                                        })
                                                                                    }
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                        {this.state.liveVerbError ? (
                                                                            <div className="verb-inline-error">
                                                                                <i className="fas fa-exclamation-circle" />
                                                                                <span>{this.state.liveVerbError.replace(/^\*\s*/, "")}</span>
                                                                                <button
                                                                                    type="button"
                                                                                    className="verb-inline-error-link"
                                                                                    onClick={this.showApprovedVerbList}
                                                                                >
                                                                                    Show approved verbs
                                                                                </button>
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </>
                                                            }
                                                        />
                                                        <RecommendationBand
                                                            label="Capital Spending Plan"
                                                            bandId="band3"
                                                            handleBandClick={this.handleBandClick}
                                                            showBand={showBand}
                                                            MainFields={
                                                                <>
                                                                    <div className="txt-rcm">
                                                                        <div
                                                                            class={`content-inp-card blue-sec ${
                                                                                show_opinions_cost_diff_indicator ? "triangle-highlight" : ""
                                                                            }`}
                                                                            data-tip={
                                                                                show_opinions_cost_diff_indicator
                                                                                    ? "The construction cost doesn't match the opinions of cost."
                                                                                    : ""
                                                                            }
                                                                            data-for="recommendation_details"
                                                                            data-place="top"
                                                                            data-target="#collapseTre"
                                                                            aria-expanded="false"
                                                                            aria-controls="collapseOne"
                                                                            onClick={() => this.handleBandClick("band3", true)}
                                                                        >
                                                                            <h3 className="p-name">Construction Cost</h3>
                                                                            <h3>
                                                                                <NumberFormat
                                                                                    autoComplete={"nope"}
                                                                                    className="color-white"
                                                                                    value={parseInt(this.state.costTotal || 0)}
                                                                                    thousandSeparator={true}
                                                                                    displayType={"text"}
                                                                                    prefix={"$ "}
                                                                                />
                                                                            </h3>
                                                                        </div>
                                                                    </div>

                                                                    {miscellaneous?.display_unit ? (
                                                                        <>
                                                                            <FormField
                                                                                label="Unit"
                                                                                fieldKey="unit"
                                                                                fieldParam="unit"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: { mandatory: this.isFieldRequired("unit", isCR) },
                                                                                    className: "txt-categ year-item main_year"
                                                                                }}
                                                                                bandId="band3"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={e => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            unit: e.target.value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Cost per Unit"
                                                                                fieldKey="cost_per_unit"
                                                                                fieldParam="cost_per_unit"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("cost_per_unit", isCR),
                                                                                        prefix: "$ ",
                                                                                        thousand_separator: true,
                                                                                        allow_negative: false,
                                                                                        decimal_scale: 4
                                                                                    },
                                                                                    className: "txt-categ year-item main_year"
                                                                                }}
                                                                                bandId="band3"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={values => {
                                                                                    const { value } = values;
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            cost_per_unit: value,
                                                                                            options_cost: project.quantity
                                                                                                ? value * project.quantity
                                                                                                : project.options_cost
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {this.state.project.maintenance_years &&
                                                                                this.state.project.maintenance_years.map((item, i) => {
                                                                                    return (
                                                                                        <>
                                                                                            {(i === 0 || i === 1) && (
                                                                                                <FormField
                                                                                                    label={item.year}
                                                                                                    fieldKey={"maintenance_years"}
                                                                                                    fieldParam=""
                                                                                                    fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                                    value={(item && parseInt(item.amount)) || ""}
                                                                                                    isMaintenanceYear
                                                                                                    fieldItem={{
                                                                                                        rules: {
                                                                                                            mandatory: false,
                                                                                                            prefix: "$ ",
                                                                                                            thousand_separator: true,
                                                                                                            allow_negative: false
                                                                                                        },
                                                                                                        className: "txt-categ year-item main_year"
                                                                                                    }}
                                                                                                    placeholder="$ 0"
                                                                                                    bandId="band3"
                                                                                                    bandShown={showBand}
                                                                                                    handleBandClick={this.handleBandClick}
                                                                                                    showErrorBorder={showErrorBorder}
                                                                                                    isFieldLocked={this.isFieldLocked}
                                                                                                    onChange={values =>
                                                                                                        this.setMaintenanceYear(values, item.year)
                                                                                                    }
                                                                                                    hasRemove={this.isYearRemovable(item.year)}
                                                                                                    onRemove={() => this.removeMaintenanceYear(item)}
                                                                                                />
                                                                                            )}
                                                                                        </>
                                                                                    );
                                                                                })}
                                                                            {this.state.project.maintenance_years?.length < 2 &&
                                                                                hasCspAddPermission && (
                                                                                    <div className={`txt-rcm `}>
                                                                                        <div className="content-inp-card icn">
                                                                                            <AddRemoveButton onAdd={this.addMaintenanceYear} />
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            }
                                                            RestFields={
                                                                <>
                                                                    {miscellaneous?.display_unit ? (
                                                                        <>
                                                                            <FormField
                                                                                label="Quantity"
                                                                                fieldKey="quantity"
                                                                                fieldParam="quantity"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("quantity", isCR),
                                                                                        thousand_separator: true,
                                                                                        allow_negative: false,
                                                                                        decimal_scale: 2
                                                                                    },
                                                                                    className: "txt-categ year-item main_year"
                                                                                }}
                                                                                bandId="band3"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={values => {
                                                                                    const { value } = values;
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            quantity: value,
                                                                                            options_cost: project.cost_per_unit
                                                                                                ? value * project.cost_per_unit
                                                                                                : project.options_cost
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Opinions of Cost"
                                                                                fieldKey="options_cost"
                                                                                fieldParam="options_cost"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        read_only: true,
                                                                                        mandatory: this.isFieldRequired("options_cost", isCR),
                                                                                        prefix: "$ ",
                                                                                        thousand_separator: true,
                                                                                        allow_negative: false
                                                                                    },
                                                                                    className: "txt-categ year-item main_year"
                                                                                }}
                                                                                bandId="band3"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={values => {
                                                                                    const { value } = values;
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            options_cost: value,
                                                                                            total_opinions_of_cost: project.occurrence
                                                                                                ? value * project.occurrence
                                                                                                : 0
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />

                                                                            <FormField
                                                                                label="Number of Occurrences"
                                                                                fieldKey="occurrence"
                                                                                fieldParam="occurrence"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("occurrence", isCR),
                                                                                        thousand_separator: true,
                                                                                        allow_negative: false,
                                                                                        decimal_scale: 2
                                                                                    },
                                                                                    className: "txt-categ year-item main_year"
                                                                                }}
                                                                                bandId="band3"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={values => {
                                                                                    const { value } = values;
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            occurrence: value,
                                                                                            total_opinions_of_cost: project.options_cost
                                                                                                ? value * project.options_cost
                                                                                                : 0
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />

                                                                            {/* total cost  */}

                                                                            <FormField
                                                                                label="Total Opinions of Cost"
                                                                                fieldKey="total_opinions_of_cost"
                                                                                fieldParam="total_opinions_of_cost"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        read_only: true,
                                                                                        mandatory: this.isFieldRequired("total_opinions_of_cost", isCR),
                                                                                        prefix: "$ ",
                                                                                        thousand_separator: true,
                                                                                        allow_negative: false
                                                                                    },
                                                                                    className: "txt-categ year-item main_year"
                                                                                }}
                                                                                bandId="band3"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={values => {
                                                                                    const { value } = values;
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            total_opinions_of_cost: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />

                                                                            {this.state.project.maintenance_years &&
                                                                                this.state.project.maintenance_years.map((item, i) => {
                                                                                    return (
                                                                                        <>
                                                                                            <FormField
                                                                                                label={item.year}
                                                                                                fieldKey="maintenance_years"
                                                                                                fieldParam=""
                                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                                value={(item && parseInt(item.amount)) || ""}
                                                                                                isMaintenanceYear
                                                                                                fieldItem={{
                                                                                                    rules: {
                                                                                                        mandatory: false,
                                                                                                        prefix: "$ ",
                                                                                                        thousand_separator: true,
                                                                                                        allow_negative: false
                                                                                                    },
                                                                                                    className: "txt-categ year-item main_year"
                                                                                                }}
                                                                                                placeholder="$ 0"
                                                                                                bandId="band3"
                                                                                                bandShown={showBand}
                                                                                                handleBandClick={this.handleBandClick}
                                                                                                showErrorBorder={showErrorBorder}
                                                                                                isFieldLocked={this.isFieldLocked}
                                                                                                onChange={values => {
                                                                                                    this.setMaintenanceYear(values, item.year);
                                                                                                }}
                                                                                                hasRemove={this.isYearRemovable(item.year)}
                                                                                                onRemove={() => this.removeMaintenanceYear(item)}
                                                                                            />
                                                                                        </>
                                                                                    );
                                                                                })}
                                                                            {hasCspAddPermission && (
                                                                                <div className={`txt-rcm`}>
                                                                                    <div className="content-inp-card icn">
                                                                                        <AddRemoveButton onAdd={this.addMaintenanceYear} />
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {this.state.project.maintenance_years &&
                                                                                this.state.project.maintenance_years.map((item, i) => {
                                                                                    return (
                                                                                        <>
                                                                                            {i !== 0 && i !== 1 && (
                                                                                                <FormField
                                                                                                    label={item.year}
                                                                                                    fieldKey="maintenance_years"
                                                                                                    fieldParam=""
                                                                                                    fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                                    value={(item && parseInt(item.amount)) || ""}
                                                                                                    isMaintenanceYear
                                                                                                    fieldItem={{
                                                                                                        rules: {
                                                                                                            mandatory: false,
                                                                                                            prefix: "$ ",
                                                                                                            thousand_separator: true,
                                                                                                            allow_negative: false
                                                                                                        },
                                                                                                        className: "txt-categ year-item main_year"
                                                                                                    }}
                                                                                                    placeholder="$ 0"
                                                                                                    bandId="band3"
                                                                                                    bandShown={showBand}
                                                                                                    handleBandClick={this.handleBandClick}
                                                                                                    showErrorBorder={showErrorBorder}
                                                                                                    isFieldLocked={this.isFieldLocked}
                                                                                                    onChange={values => {
                                                                                                        this.setMaintenanceYear(values, item.year);
                                                                                                    }}
                                                                                                    hasRemove={this.isYearRemovable(item.year)}
                                                                                                    onRemove={() => this.removeMaintenanceYear(item)}
                                                                                                />
                                                                                            )}
                                                                                        </>
                                                                                    );
                                                                                })}
                                                                            {this.state.project.maintenance_years?.length >= 2 &&
                                                                                hasCspAddPermission && (
                                                                                    <div className={` txt-rcm `}>
                                                                                        <div className="content-inp-card icn">
                                                                                            <AddRemoveButton onAdd={this.addMaintenanceYear} />
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            }
                                                        />

                                                        <RecommendationBand
                                                            label="Priority"
                                                            bandId="band4"
                                                            handleBandClick={this.handleBandClick}
                                                            showBand={showBand}
                                                            MainFields={
                                                                <>
                                                                    <div className="txt-rcm">
                                                                        <div className="content-inp-card blue-sec">
                                                                            <h3 className="p-name">Priority Total</h3>
                                                                            <h3 className="color-white">{this.state.priorityTotal || 0}</h3>
                                                                        </div>
                                                                    </div>
                                                                    {priorityElementsData.map((item, i) => (
                                                                        <>
                                                                            {(i === 0 || i === 1) && (
                                                                                <>
                                                                                    {item.options?.length ? (
                                                                                        <FormField
                                                                                            label={item.display_name || `Priority Element ${i + 1}`}
                                                                                            fieldKey={priorityElementFieldName(item, i)}
                                                                                            fieldParam=""
                                                                                            fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                            value={project?.priority_elements?.[i]?.option_id || ""}
                                                                                            name={i + 1}
                                                                                            fieldItem={{
                                                                                                field_options: item.options,
                                                                                                rules: {
                                                                                                    mandatory: isCR
                                                                                                        ? this.isFieldRequired(
                                                                                                              priorityElementFieldName(item, i),
                                                                                                              true
                                                                                                          )
                                                                                                        : item.recommendation_required
                                                                                                }
                                                                                            }}
                                                                                            bandId="band4"
                                                                                            bandShown={showBand}
                                                                                            handleBandClick={this.handleBandClick}
                                                                                            showErrorBorder={showErrorBorder}
                                                                                            isFieldLocked={this.isFieldLocked}
                                                                                            onChange={value =>
                                                                                                this.setPriorityElement(
                                                                                                    { target: { name: i + 1, value } },
                                                                                                    item.id
                                                                                                )
                                                                                            }
                                                                                            isPriority
                                                                                        />
                                                                                    ) : (
                                                                                        <FormField
                                                                                            label={item.display_name || `Priority Element ${i + 1}`}
                                                                                            fieldKey={priorityElementFieldName(item, i)}
                                                                                            fieldParam=""
                                                                                            fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                            value={
                                                                                                parseInt(project?.priority_elements?.[i]?.element) ||
                                                                                                ""
                                                                                            }
                                                                                            name={i + 1}
                                                                                            fieldItem={{
                                                                                                rules: {
                                                                                                    mandatory: isCR
                                                                                                        ? this.isFieldRequired(
                                                                                                              priorityElementFieldName(item, i),
                                                                                                              true
                                                                                                          )
                                                                                                        : item.recommendation_required
                                                                                                }
                                                                                            }}
                                                                                            bandId="band4"
                                                                                            bandShown={showBand}
                                                                                            handleBandClick={this.handleBandClick}
                                                                                            showErrorBorder={showErrorBorder}
                                                                                            isFieldLocked={this.isFieldLocked}
                                                                                            onChange={val =>
                                                                                                this.setPriorityElement(
                                                                                                    { target: { name: i + 1, value: val?.value } },
                                                                                                    item.id
                                                                                                )
                                                                                            }
                                                                                            isPriority
                                                                                        />
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ))}
                                                                    {!priorityElementsData.length ? (
                                                                        <>
                                                                            <FormField
                                                                                label="Criticality"
                                                                                fieldKey="criticality"
                                                                                fieldParam="criticality_id"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    field_options: criticalityData,
                                                                                    rules: { mandatory: this.isFieldRequired("criticality", isCR) },
                                                                                    className: "border-right-last"
                                                                                }}
                                                                                bandId="band4"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={value => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            criticality_id: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Criticality Type"
                                                                                fieldKey="criticality_type"
                                                                                fieldParam="criticality_type"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    field_options: criticalityTypeData,
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("criticality_type", isCR)
                                                                                    },
                                                                                    className: "border-right-last"
                                                                                }}
                                                                                bandId="band4"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={value => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            criticality_type: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </>
                                                                    ) : null}
                                                                </>
                                                            }
                                                            RestFields={
                                                                <>
                                                                    {priorityElementsData.map((item, i) => (
                                                                        <>
                                                                            {i !== 0 && i !== 1 && (
                                                                                <>
                                                                                    {item.options?.length ? (
                                                                                        <FormField
                                                                                            label={item.display_name || `Priority Element ${i + 1}`}
                                                                                            fieldKey={priorityElementFieldName(item, i)}
                                                                                            fieldParam=""
                                                                                            fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                            value={project?.priority_elements?.[i]?.option_id || ""}
                                                                                            name={i + 1}
                                                                                            fieldItem={{
                                                                                                field_options: item.options,
                                                                                                rules: {
                                                                                                    mandatory: isCR
                                                                                                        ? this.isFieldRequired(
                                                                                                              priorityElementFieldName(item, i),
                                                                                                              true
                                                                                                          )
                                                                                                        : item.recommendation_required
                                                                                                }
                                                                                            }}
                                                                                            bandId="band4"
                                                                                            bandShown={showBand}
                                                                                            handleBandClick={this.handleBandClick}
                                                                                            showErrorBorder={showErrorBorder}
                                                                                            isFieldLocked={this.isFieldLocked}
                                                                                            onChange={value =>
                                                                                                this.setPriorityElement(
                                                                                                    { target: { name: i + 1, value } },
                                                                                                    item.id
                                                                                                )
                                                                                            }
                                                                                            isPriority
                                                                                        />
                                                                                    ) : (
                                                                                        <FormField
                                                                                            label={item.display_name || `Priority Element ${i + 1}`}
                                                                                            fieldKey={priorityElementFieldName(item, i)}
                                                                                            fieldParam=""
                                                                                            fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                            value={
                                                                                                parseInt(project?.priority_elements?.[i]?.element) ||
                                                                                                ""
                                                                                            }
                                                                                            name={i + 1}
                                                                                            fieldItem={{
                                                                                                rules: {
                                                                                                    mandatory: isCR
                                                                                                        ? this.isFieldRequired(
                                                                                                              priorityElementFieldName(item, i),
                                                                                                              true
                                                                                                          )
                                                                                                        : item.recommendation_required
                                                                                                }
                                                                                            }}
                                                                                            bandId="band4"
                                                                                            bandShown={showBand}
                                                                                            handleBandClick={this.handleBandClick}
                                                                                            showErrorBorder={showErrorBorder}
                                                                                            isFieldLocked={this.isFieldLocked}
                                                                                            onChange={val =>
                                                                                                this.setPriorityElement(
                                                                                                    { target: { name: i + 1, value: val?.value } },
                                                                                                    item.id
                                                                                                )
                                                                                            }
                                                                                            isPriority
                                                                                        />
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ))}
                                                                    {priorityElementsData?.length ? (
                                                                        <>
                                                                            <FormField
                                                                                label="Criticality"
                                                                                fieldKey="criticality"
                                                                                fieldParam="criticality_id"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    field_options: criticalityData,
                                                                                    rules: { mandatory: this.isFieldRequired("criticality", isCR) }
                                                                                }}
                                                                                bandId="band4"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={value => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            criticality_id: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Criticality Type"
                                                                                fieldKey="criticality_type"
                                                                                fieldParam="criticality_type"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    field_options: criticalityTypeData,
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("criticality_type", isCR)
                                                                                    }
                                                                                }}
                                                                                bandId="band4"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={value => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            criticality_type: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </>
                                                                    ) : null}
                                                                </>
                                                            }
                                                        />

                                                        {project.recommendation_type === RECOMMENDATION_TYPES.ASSET && (
                                                            <RecommendationBand
                                                                label="Asset"
                                                                bandId="asset"
                                                                handleBandClick={this.handleBandClick}
                                                                isDefaultOpen
                                                                showBand={showBand}
                                                                MainFields={
                                                                    <>
                                                                        <FormField
                                                                            label="Asset Name"
                                                                            fieldKey="asset_name"
                                                                            fieldParam="asset_name"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: this.isFieldRequired("asset_name", isCR) }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={this.handleChangeAssetForm}
                                                                        />
                                                                        <FormField
                                                                            label="Asset Condition"
                                                                            fieldKey="asset_condition"
                                                                            fieldParam="client_asset_condition_id"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                field_options: dropDownList?.asset_conditions,
                                                                                rules: { mandatory: this.isFieldRequired("asset_condition", isCR) }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={value =>
                                                                                this.handleChangeAssetForm({
                                                                                    target: { value, name: "client_asset_condition_id" }
                                                                                })
                                                                            }
                                                                        />
                                                                        <FormField
                                                                            label="Asset Tag"
                                                                            fieldKey="asset_tag"
                                                                            fieldParam="asset_tag"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: this.isFieldRequired("asset_tag", isCR) }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={this.handleChangeAssetForm}
                                                                        />
                                                                    </>
                                                                }
                                                                RestFields={
                                                                    <>
                                                                        <FormField
                                                                            label="Manufacturer"
                                                                            fieldKey="manufacturer"
                                                                            fieldParam="manufacturer"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                            value={assetFormData?.manufacturer_id}
                                                                            onChange={(value, name) =>
                                                                                this.handleChangeAssetForm({
                                                                                    target: { value, name: "manufacturer", selectedName: name }
                                                                                })
                                                                            }
                                                                            showErrorBorder={showErrorBorder}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            fieldItem={{
                                                                                field_options: dropDownList?.manufacturers || [],
                                                                                rules: { mandatory: this.isFieldRequired("manufacturer", isCR) }
                                                                            }}
                                                                            handleInputChange={this.handleInputChange}
                                                                            isManufacturer={true}
                                                                            isLoadingDrop={this.state?.isLoadingDrop}
                                                                            manufacturerCount={this.props.assetReducer?.manufacturerCount?.count}
                                                                            isAsset={true}
                                                                        />
                                                                        <FormField
                                                                            label="Model Number"
                                                                            fieldKey="model_number"
                                                                            fieldParam="model_number"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: this.isFieldRequired("model_number", isCR) }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={this.handleChangeAssetForm}
                                                                        />
                                                                        <FormField
                                                                            label="Serial Number"
                                                                            fieldKey="serial_number"
                                                                            fieldParam="serial_number"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: this.isFieldRequired("serial_number", isCR) }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={this.handleChangeAssetForm}
                                                                        />
                                                                        <FormField
                                                                            label="Refrigerant"
                                                                            fieldKey="refrigerant"
                                                                            fieldParam="refrigerant"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: this.isFieldRequired("refrigerant", isCR) }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={this.handleChangeAssetForm}
                                                                        />
                                                                        <FormField
                                                                            label="Installed Year"
                                                                            fieldKey="installed_year"
                                                                            fieldParam="installed_year"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: {
                                                                                    mandatory: this.isFieldRequired("installed_year", isCR),
                                                                                    allow_negative: false,
                                                                                    format: "####",
                                                                                    isAllowed: ({ value }) => {
                                                                                        if (value === "" || null) {
                                                                                            return true;
                                                                                        }
                                                                                        const numericValue = parseInt(value, 10);
                                                                                        const maxYear = new Date().getFullYear() + 5;
                                                                                        return !isNaN(numericValue) && numericValue <= maxYear;
                                                                                    }
                                                                                }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={values => {
                                                                                const { value } = values;
                                                                                const usefulLifeRemaining = getUsefullLifeRemaining(
                                                                                    value,
                                                                                    assetFormData.service_life
                                                                                );
                                                                                this.applyRecommendationLifecyclePatch({
                                                                                    deferCapitalTypeResolution: true,
                                                                                    assetFormData: {
                                                                                        ...assetFormData,
                                                                                        installed_year: value,
                                                                                        usefull_life_remaining: usefulLifeRemaining,
                                                                                        current_age: getCurrentAge(value)
                                                                                    }
                                                                                });
                                                                            }}
                                                                            onBlur={() => {
                                                                                this.flushDeferredCapitalResolution.cancel();
                                                                                queueMicrotask(() => {
                                                                                    const { project, assetFormData: afd } = this.state;
                                                                                    this.applyLifecycleCapitalResolutionToProject(
                                                                                        project,
                                                                                        afd,
                                                                                        {},
                                                                                        false
                                                                                    );
                                                                                });
                                                                            }}
                                                                        />
                                                                        <FormField
                                                                            label="Current Age"
                                                                            fieldKey="current_age"
                                                                            fieldParam="current_age"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: false, read_only: true }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                        />
                                                                        <FormField
                                                                            label="Service Life"
                                                                            fieldKey="service_life"
                                                                            fieldParam="service_life"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: {
                                                                                    mandatory: this.isFieldRequired("service_life", isCR),
                                                                                    allow_negative: false,
                                                                                    isAllowed: serviceLifeIntegerIsAllowed
                                                                                }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={values => {
                                                                                const { value } = values;
                                                                                const usefulLifeRemaining = getUsefullLifeRemaining(
                                                                                    assetFormData.installed_year,
                                                                                    value
                                                                                );
                                                                                this.applyRecommendationLifecyclePatch({
                                                                                    deferCapitalTypeResolution: true,
                                                                                    assetFormData: {
                                                                                        ...assetFormData,
                                                                                        service_life: value,
                                                                                        usefull_life_remaining: usefulLifeRemaining
                                                                                    }
                                                                                });
                                                                            }}
                                                                            onBlur={() => {
                                                                                this.flushDeferredCapitalResolution.cancel();
                                                                                queueMicrotask(() => {
                                                                                    const { project, assetFormData: afd } = this.state;
                                                                                    this.applyLifecycleCapitalResolutionToProject(
                                                                                        project,
                                                                                        afd,
                                                                                        {},
                                                                                        false
                                                                                    );
                                                                                });
                                                                            }}
                                                                        />
                                                                        <FormField
                                                                            label="End of Service Life"
                                                                            fieldKey="end_of_service_life"
                                                                            fieldParam="end_of_service_life"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={
                                                                                assetFormData.usefull_life_remaining ||
                                                                                assetFormData.usefull_life_remaining === 0
                                                                                    ? `${
                                                                                          new Date().getFullYear() +
                                                                                          assetFormData.usefull_life_remaining
                                                                                      }`
                                                                                    : ""
                                                                            }
                                                                            fieldItem={{
                                                                                rules: { mandatory: false, read_only: true }
                                                                            }}
                                                                            bandId="asset"
                                                                            isAsset
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                        />
                                                                        <FormField
                                                                            label="Useful Life Remaining"
                                                                            fieldKey="useful_life_remaining"
                                                                            fieldParam="usefull_life_remaining"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: false, read_only: true }
                                                                            }}
                                                                            bandId="asset"
                                                                            tooltip={
                                                                                assetFormData.usefull_life_remaining
                                                                                    ? `Year= ${
                                                                                          new Date().getFullYear() +
                                                                                          assetFormData.usefull_life_remaining
                                                                                      }`
                                                                                    : ""
                                                                            }
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={values => {
                                                                                const { value } = values;
                                                                                this.setState({
                                                                                    assetFormData: {
                                                                                        ...assetFormData,
                                                                                        service_life: value,
                                                                                        usefull_life_remaining: getUsefullLifeRemaining(
                                                                                            assetFormData.installed_year,
                                                                                            value
                                                                                        )
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                        <FormField
                                                                            label="Capacity"
                                                                            fieldKey="capacity"
                                                                            fieldParam="capacity"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: this.isFieldRequired("capacity", isCR) }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={this.handleChangeAssetForm}
                                                                        />
                                                                        <FormField
                                                                            label="Capacity Unit"
                                                                            fieldKey="capacity_unit"
                                                                            fieldParam="capacity_unit"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            value={assetFormData}
                                                                            fieldItem={{
                                                                                rules: { mandatory: this.isFieldRequired("capacity_unit", isCR) }
                                                                            }}
                                                                            bandId="asset"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={this.handleChangeAssetForm}
                                                                        />
                                                                    </>
                                                                }
                                                            />
                                                        )}

                                                        {project?.fmp === "yes" && (
                                                            <RecommendationBand
                                                                label="Master Facility Plan"
                                                                bandId="fmp"
                                                                handleBandClick={this.handleBandClick}
                                                                showBand={showBand}
                                                                MainFields={
                                                                    <>
                                                                        <FormField
                                                                            label="MFP ID"
                                                                            fieldKey="fmp_id"
                                                                            fieldParam="fmp_id"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            fieldItem={{ rules: { mandatory: this.isFieldRequired("fmp_id", isCR) } }}
                                                                            value={project}
                                                                            bandId="fmp"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={e => {
                                                                                this.setState({
                                                                                    project: {
                                                                                        ...project,
                                                                                        fmp_id: e.target.value
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                        <FormField
                                                                            label="MFP Project"
                                                                            fieldKey="fmp_project"
                                                                            fieldParam="fmp_project"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            fieldItem={{ rules: { mandatory: this.isFieldRequired("fmp_project", isCR) } }}
                                                                            value={project}
                                                                            bandId="fmp"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={e => {
                                                                                this.setState({
                                                                                    project: {
                                                                                        ...project,
                                                                                        fmp_project: e.target.value
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                        <FormField
                                                                            label="MFP Track"
                                                                            fieldKey="fmp_track"
                                                                            fieldParam="fmp_track"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                            fieldItem={{ rules: { mandatory: this.isFieldRequired("fmp_track", isCR) } }}
                                                                            value={project}
                                                                            bandId="fmp"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={e => {
                                                                                this.setState({
                                                                                    project: {
                                                                                        ...project,
                                                                                        fmp_track: e.target.value
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                    </>
                                                                }
                                                                RestFields={<></>}
                                                            />
                                                        )}

                                                        <RecommendationBand
                                                            label="Additional Details"
                                                            bandId="band6"
                                                            handleBandClick={this.handleBandClick}
                                                            // isDefaultOpen
                                                            showBand={showBand}
                                                            MainFields={
                                                                <>
                                                                    {project.recommendation_type === RECOMMENDATION_TYPES.SYSTEM && (
                                                                        <FormField
                                                                            label="Condition"
                                                                            fieldKey="condition"
                                                                            fieldParam="asset_condition_id"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                            value={project}
                                                                            fieldItem={{
                                                                                field_options:
                                                                                    this.props.recommendationsReducer?.getConditionBasedOnProject
                                                                                        ?.asset_conditions,
                                                                                rules: { mandatory: this.isFieldRequired("condition", isCR) }
                                                                            }}
                                                                            bandId="band6"
                                                                            bandShown={showBand}
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={value =>
                                                                                this.setState({
                                                                                    project: {
                                                                                        ...project,
                                                                                        asset_condition_id: value
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    )}
                                                                    <FormField
                                                                        label="Category"
                                                                        fieldKey="category"
                                                                        fieldParam="category_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options:
                                                                                this.props.recommendationsReducer?.getCategoryByProject?.categories,
                                                                            rules: { mandatory: this.isFieldRequired("category", isCR) }
                                                                        }}
                                                                        bandId="band6"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={value => {
                                                                            const bands =
                                                                                this.props.recommendationsReducer?.getCategoryByProject?.categories.find(
                                                                                    elem => elem.id === value
                                                                                )?.assigned_bands || [];
                                                                            this.applyRecommendationLifecyclePatch({
                                                                                project: {
                                                                                    category_id: value,
                                                                                    energy_band_show: bands.includes("energy_band") ? "yes" : "no",
                                                                                    water_band_show: bands.includes("water_band") ? "yes" : "no"
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                    {[RECOMMENDATION_TYPES.SYSTEM, RECOMMENDATION_TYPES.ASSET].includes(
                                                                        project.recommendation_type
                                                                    ) && (
                                                                        <FormField
                                                                            label="Capital Type"
                                                                            fieldKey="recommendation_capital_type_id"
                                                                            fieldParam="recommendation_capital_type_id"
                                                                            fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                            value={project}
                                                                            fieldItem={{
                                                                                field_options:
                                                                                    this.props.recommendationsReducer?.getCapitalTypeBasedOnProject
                                                                                        ?.capital_types,
                                                                                rules: { mandatory: this.isFieldRequired("capital_type", isCR) }
                                                                            }}
                                                                            bandId="band6"
                                                                            bandShown={showBand}
                                                                            isCapitalType
                                                                            handleBandClick={this.handleBandClick}
                                                                            showErrorBorder={showErrorBorder}
                                                                            isFieldLocked={this.isFieldLocked}
                                                                            onChange={value => {
                                                                                const selected =
                                                                                    this.props.recommendationsReducer?.getCapitalTypeBasedOnProject?.capital_types?.find(
                                                                                        item => String(item.id) === String(value)
                                                                                    );
                                                                                this.setState({
                                                                                    autoFilledCapitalTypeId: "",
                                                                                    project: {
                                                                                        ...project,
                                                                                        recommendation_capital_type_id: value,
                                                                                        capital_type: selected?.name || ""
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                    )}
                                                                </>
                                                            }
                                                            RestFields={
                                                                <>
                                                                    {project.recommendation_type === RECOMMENDATION_TYPES.SYSTEM ? (
                                                                        <>
                                                                            {isCR ? (
                                                                                <>
                                                                                    <FormField
                                                                                        label={crStatusLabel}
                                                                                        fieldKey="cr_status"
                                                                                        fieldParam="cr_status"
                                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                        value={project}
                                                                                        hasEmptyOption={false}
                                                                                        fieldItem={{
                                                                                            field_options: Cr_status_options ?? [],
                                                                                            rules: {
                                                                                                mandatory: this.isFieldRequired("cr_status", isCR),
                                                                                                read_only: !isCRApprover||
                                                                                                    project?.cr_status === "converted"
                                                                                            }
                                                                                        }}
                                                                                        bandId="band6"
                                                                                        bandShown={showBand}
                                                                                        handleBandClick={this.handleBandClick}
                                                                                        showErrorBorder={showErrorBorder}
                                                                                        isFieldLocked={this.isFieldLocked}
                                                                                        onChange={value =>
                                                                                            this.setState({
                                                                                                project: {
                                                                                                    ...project,
                                                                                                    cr_status: value
                                                                                                }
                                                                                            })
                                                                                        }
                                                                                        hasDisabledOptions={true}
                                                                                        hasMaxHeight="400px"
                                                                                    />
                                                                                    <FormField
                                                                                        label={crStatusNotesLabel}
                                                                                        fieldKey="cr_status_notes"
                                                                                        fieldParam="cr_status_notes"
                                                                                        fieldType={DYNAMIC_FIELD_TYPES.MEMO}
                                                                                        value={project}
                                                                                        hasEmptyOption={false}
                                                                                        fieldItem={{
                                                                                            rules: { mandatory: this.isFieldRequired("cr_status_notes", isCR) }
                                                                                        }}
                                                                                        bandId="band6"
                                                                                        bandShown={showBand}
                                                                                        handleBandClick={this.handleBandClick}
                                                                                        showErrorBorder={showErrorBorder}
                                                                                        isFieldLocked={this.isFieldLocked}
                                                                                        onChange={(field, value) =>
                                                                                            this.setState({
                                                                                                project: {
                                                                                                    ...project,
                                                                                                    cr_status_notes: value
                                                                                                }
                                                                                            })
                                                                                        }
                                                                                    />
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <FormField
                                                                                        label="Status"
                                                                                        fieldKey="recommendation_status_id"
                                                                                        fieldParam="recommendation_status_id"
                                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                        value={project}
                                                                                        hasEmptyOption={false}
                                                                                        fieldItem={{
                                                                                            field_options: groupedOptions || [],
                                                                                            rules: { mandatory: this.isFieldRequired("recommendation_status_id", isCR) }
                                                                                        }}
                                                                                        bandId="band6"
                                                                                        bandShown={showBand}
                                                                                        handleBandClick={this.handleBandClick}
                                                                                        showErrorBorder={showErrorBorder}
                                                                                        isFieldLocked={this.isFieldLocked}
                                                                                        onChange={(value, key) =>
                                                                                            this.setState({
                                                                                                project: {
                                                                                                    ...project,
                                                                                                    recommendation_status_id: value,
                                                                                                    status: key
                                                                                                }
                                                                                            })
                                                                                        }
                                                                                        hasGroupedByOptions={true}
                                                                                        isDropdownDynamic={true}
                                                                                        showInfo={true}
                                                                                        onInfoClick={() =>
                                                                                            this.onShowInfo({ name: "Status", data: groupedOptions })
                                                                                        }
                                                                                    />
                                                                                    <FormField
                                                                                        label={`Status Notes${
                                                                                            selectedProject &&
                                                                                            initialValues.status !== project.status &&
                                                                                            (!project.status_notes?.trim() ||
                                                                                                initialValues.status_notes ===
                                                                                                    project.status_notes) &&
                                                                                            !!miscellaneous?.status_notes
                                                                                                ? "*"
                                                                                                : " "
                                                                                        }`}
                                                                                        fieldKey="status_notes"
                                                                                        fieldParam="status_notes"
                                                                                        fieldType={DYNAMIC_FIELD_TYPES.MEMO}
                                                                                        value={project}
                                                                                        hasEmptyOption={false}
                                                                                        fieldItem={{
                                                                                            rules: {
                                                                                                mandatory: this.isFieldRequired("status_notes", isCR),
                                                                                                isFieldError:
                                                                                                    selectedProject &&
                                                                                                    initialValues.status !== project.status &&
                                                                                                    (!project.status_notes?.trim() ||
                                                                                                        initialValues.status_notes ===
                                                                                                            project.status_notes) &&
                                                                                                    !!miscellaneous?.status_notes
                                                                                            }
                                                                                        }}
                                                                                        bandId="band6"
                                                                                        bandShown={showBand}
                                                                                        handleBandClick={this.handleBandClick}
                                                                                        showErrorBorder={showErrorBorder}
                                                                                        isFieldLocked={this.isFieldLocked}
                                                                                        onChange={(field, value) => {
                                                                                            this.setState({
                                                                                                project: {
                                                                                                    ...project,
                                                                                                    status_notes: value
                                                                                                }
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                            <FormField
                                                                                label="Funding"
                                                                                fieldKey="funding"
                                                                                fieldParam="funding_source_id"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    field_options:
                                                                                        this.props.recommendationsReducer?.getFundingSourceByProject
                                                                                            ?.funding_sources,
                                                                                    rules: { mandatory: this.isFieldRequired("funding", isCR) }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={value => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            funding_source_id: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Responsibility"
                                                                                fieldKey="responsibility"
                                                                                fieldParam="responsibility_id"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    field_options:
                                                                                        this.props.recommendationsReducer?.getResponsibilityByProject
                                                                                            ?.responsibilities,
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("responsibility", isCR)
                                                                                    }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={value => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            responsibility_id: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Installed Year"
                                                                                fieldKey="installed_year"
                                                                                fieldParam="installed_year"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("installed_year", isCR),
                                                                                        allow_negative: false,
                                                                                        format: "####",
                                                                                        isAllowed: ({ value }) => {
                                                                                            if (value === "" || null) {
                                                                                                return true;
                                                                                            }
                                                                                            const numericValue = parseInt(value, 10);
                                                                                            const maxYear = new Date().getFullYear() + 5;
                                                                                            return !isNaN(numericValue) && numericValue <= maxYear;
                                                                                        }
                                                                                    }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={values => {
                                                                                    const { value } = values;
                                                                                    const usefulLifeRemaining = getUsefullLifeRemaining(
                                                                                        value,
                                                                                        project.service_life
                                                                                    );
                                                                                    this.applyRecommendationLifecyclePatch({
                                                                                        deferCapitalTypeResolution: true,
                                                                                        project: {
                                                                                            installed_year: value,
                                                                                            usefull_life_remaining: usefulLifeRemaining,
                                                                                            current_age: getCurrentAge(value)
                                                                                        }
                                                                                    });
                                                                                }}
                                                                                onBlur={() => {
                                                                                    this.flushDeferredCapitalResolution.cancel();
                                                                                    queueMicrotask(() => {
                                                                                        const { project: p, assetFormData: afd } = this.state;
                                                                                        this.applyLifecycleCapitalResolutionToProject(
                                                                                            p,
                                                                                            afd,
                                                                                            {},
                                                                                            false
                                                                                        );
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Current Age"
                                                                                fieldKey="current_age"
                                                                                fieldParam="current_age"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                                value={
                                                                                    project.installed_year
                                                                                        ? String(getCurrentAge(project.installed_year))
                                                                                        : ""
                                                                                }
                                                                                fieldItem={{
                                                                                    rules: { mandatory: false, read_only: true }
                                                                                }}
                                                                                bandId="band6"
                                                                                isAsset
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                            />
                                                                            <FormField
                                                                                label="Service Life"
                                                                                fieldKey="service_life"
                                                                                fieldParam="service_life"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("service_life", isCR),
                                                                                        allow_negative: false,
                                                                                        isAllowed: serviceLifeIntegerIsAllowed
                                                                                    }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={values => {
                                                                                    const { value } = values;
                                                                                    const usefulLifeRemaining = getUsefullLifeRemaining(
                                                                                        project.installed_year,
                                                                                        value
                                                                                    );
                                                                                    this.applyRecommendationLifecyclePatch({
                                                                                        deferCapitalTypeResolution: true,
                                                                                        project: {
                                                                                            service_life: value,
                                                                                            usefull_life_remaining: usefulLifeRemaining
                                                                                        }
                                                                                    });
                                                                                }}
                                                                                onBlur={() => {
                                                                                    this.flushDeferredCapitalResolution.cancel();
                                                                                    queueMicrotask(() => {
                                                                                        const { project: p, assetFormData: afd } = this.state;
                                                                                        this.applyLifecycleCapitalResolutionToProject(
                                                                                            p,
                                                                                            afd,
                                                                                            {},
                                                                                            false
                                                                                        );
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="End of Service Life"
                                                                                fieldKey="end_of_service_life"
                                                                                fieldParam="end_of_service_life"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                                value={
                                                                                    project.installed_year && project.service_life
                                                                                        ? String(
                                                                                              parseInt(project.installed_year) +
                                                                                                  parseInt(project.service_life)
                                                                                          )
                                                                                        : ""
                                                                                }
                                                                                fieldItem={{
                                                                                    rules: { mandatory: false, read_only: true }
                                                                                }}
                                                                                bandId="band6"
                                                                                isAsset
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                            />
                                                                            <FormField
                                                                                label="Useful Life Remaining"
                                                                                fieldKey="usefull_life_remaining"
                                                                                fieldParam="usefull_life_remaining"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.TEXT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: { read_only: true }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                tooltip={
                                                                                    project.usefull_life_remaining
                                                                                        ? `Year= ${
                                                                                              new Date().getFullYear() +
                                                                                              project.usefull_life_remaining
                                                                                          }`
                                                                                        : ""
                                                                                }
                                                                            />
                                                                            <FormField
                                                                                label="CRV"
                                                                                fieldKey="crv"
                                                                                fieldParam="crv"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.NUMBER}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("crv", isCR),
                                                                                        prefix: "$ ",
                                                                                        thousand_separator: true,
                                                                                        allow_negative: false
                                                                                    }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={values => {
                                                                                    const { value } = values;
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            crv: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <FormField
                                                                                label="Status"
                                                                                fieldKey="recommendation_status_id"
                                                                                fieldParam="recommendation_status_id"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                hasEmptyOption={false}
                                                                                fieldItem={{
                                                                                    field_options: groupedOptions || [],
                                                                                    rules: { mandatory: this.isFieldRequired("recommendation_status_id", isCR) }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={(value, key) =>
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            status: key,
                                                                                            recommendation_status_id: value
                                                                                        }
                                                                                    })
                                                                                }
                                                                                hasGroupedByOptions={true}
                                                                                isDropdownDynamic={true}
                                                                                showInfo={true}
                                                                                onInfoClick={() =>
                                                                                    this.onShowInfo({ name: "Status", data: groupedOptions })
                                                                                }
                                                                            />
                                                                            <FormField
                                                                                label="Status Notes"
                                                                                fieldKey="status_notes"
                                                                                fieldParam="status_notes"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.MEMO}
                                                                                value={project}
                                                                                hasEmptyOption={false}
                                                                                fieldItem={{
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("status_notes", isCR),
                                                                                        isFieldError:
                                                                                            selectedProject &&
                                                                                            initialValues.status !== project.status &&
                                                                                            (!project.status_notes?.trim() ||
                                                                                                initialValues.status_notes === project.status_notes)
                                                                                    }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={(field, value) => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            status_notes: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Funding"
                                                                                fieldKey="funding"
                                                                                fieldParam="funding_source_id"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    field_options:
                                                                                        this.props.recommendationsReducer?.getFundingSourceByProject
                                                                                            ?.funding_sources,
                                                                                    rules: { mandatory: this.isFieldRequired("funding", isCR) }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={value => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            funding_source_id: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FormField
                                                                                label="Responsibility"
                                                                                fieldKey="responsibility"
                                                                                fieldParam="responsibility_id"
                                                                                fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                                value={project}
                                                                                fieldItem={{
                                                                                    field_options:
                                                                                        this.props.recommendationsReducer?.getResponsibilityByProject
                                                                                            ?.responsibilities,
                                                                                    rules: {
                                                                                        mandatory: this.isFieldRequired("responsibility", isCR)
                                                                                    }
                                                                                }}
                                                                                bandId="band6"
                                                                                bandShown={showBand}
                                                                                handleBandClick={this.handleBandClick}
                                                                                showErrorBorder={showErrorBorder}
                                                                                isFieldLocked={this.isFieldLocked}
                                                                                onChange={value => {
                                                                                    this.setState({
                                                                                        project: {
                                                                                            ...project,
                                                                                            responsibility_id: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </>
                                                                    )}

                                                                    <FormField
                                                                        label="Department"
                                                                        fieldKey="department"
                                                                        fieldParam="department_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options:
                                                                                this.props.recommendationsReducer?.getDepaartmentsByProject?.departments?.filter(
                                                                                    item => item.name !== null
                                                                                ),
                                                                            rules: { mandatory: this.isFieldRequired("department", isCR) }
                                                                        }}
                                                                        bandId="band6"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={value =>
                                                                            this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    department_id: value
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                    <FormField
                                                                        label="Initiative"
                                                                        fieldKey="initiative"
                                                                        fieldParam="initiative_id"
                                                                        fieldType={DYNAMIC_FIELD_TYPES.SELECT}
                                                                        value={project}
                                                                        fieldItem={{
                                                                            field_options:
                                                                                this.props.recommendationsReducer?.getInitiativeDropdown?.projects,
                                                                            rules: { mandatory: this.isFieldRequired("initiative", isCR) }
                                                                        }}
                                                                        bandId="band6"
                                                                        bandShown={showBand}
                                                                        handleBandClick={this.handleBandClick}
                                                                        showErrorBorder={showErrorBorder}
                                                                        isFieldLocked={this.isFieldLocked}
                                                                        onChange={value =>
                                                                            this.setState({
                                                                                project: {
                                                                                    ...project,
                                                                                    initiative_id: value
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                    <div className="txt-rcm">
                                                                        <div className="content-inp-card">
                                                                            <div className="form-group">
                                                                                <label>Origin</label>
                                                                                <input
                                                                                    type="text"
                                                                                    readOnly
                                                                                    autoComplete={"nope"}
                                                                                    className={`custom-input form-control cursor-diabled ${
                                                                                        this.isFieldLocked("source") ? "grayed-out" : ""
                                                                                    }`}
                                                                                    placeholder="Origin"
                                                                                    value={formatCapitalRequestSourceValue(
                                                                                        this.state.project.source,
                                                                                        miscellaneous
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="txt-rcm">
                                                                        <div className="content-inp-card">
                                                                            <div className="form-group">
                                                                                <label>Birth Year</label>
                                                                                <input
                                                                                    type="text"
                                                                                    readOnly
                                                                                    autoComplete={"nope"}
                                                                                    className={`custom-input form-control cursor-diabled ${
                                                                                        this.isFieldLocked("birth_year") ? "grayed-out" : ""
                                                                                    }`}
                                                                                    placeholder="Birth Year"
                                                                                    value={birthYear}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {this.renderAdditionalDetailsDynamicFields({
                                                                        project,
                                                                        showErrorBorder,
                                                                        isCR,
                                                                        isMR
                                                                    })}
                                                            </>
                                                            }
                                                            ExtraFields={
                                                                <>
                                                                    <div className="form-row m-0">
                                                                        {(isCR || project.source === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST) && (
                                                                            <>
                                                                                <div className="col-md-4 p-0">
                                                                                    <div className="outer-rcm">
                                                                                        <div className="txt-rcm w-100">
                                                                                            <div>
                                                                                                <img src="/img/icn1.png" alt="" />
                                                                                            </div>
                                                                                            <div className="txt-secn">
                                                                                                <h4>Requester</h4>
                                                                                                <div className="sel-recom-react">
                                                                                                    <SelectBox
                                                                                                        isClearable={false}
                                                                                                        value={this.state.project.requestor_id}
                                                                                                        className={`selectOtr not-draggable build-select-otr ${
                                                                                                            this.isFieldLocked("requestor")
                                                                                                                ? "grayed-out"
                                                                                                                : ""
                                                                                                        }`}
                                                                                                        isSurveyor
                                                                                                        disabled
                                                                                                        isRecommendation
                                                                                                        optionsList={
                                                                                                            this.props.projectReducer
                                                                                                                .getUserByProjectData?.users ?? []
                                                                                                        }
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 p-0">
                                                                                    <div className="outer-rcm">
                                                                                        <div className="txt-rcm w-100">
                                                                                            <div>
                                                                                                <img src="/img/icn-2.png" alt="" />
                                                                                            </div>
                                                                                            <div className="txt-secn">
                                                                                                <h4>
                                                                                                    Requested Date{" "}
                                                                                                    {this.isFieldRequired("requested_date", isCR) ? "*" : ""}
                                                                                                </h4>
                                                                                                <DatePicker
                                                                                                    autoComplete={"nope"}
                                                                                                    placeholderText={`Requested Date`}
                                                                                                    showMonthDropdown
                                                                                                    showYearDropdown
                                                                                                    dropdownMode="scroll"
                                                                                                    maxDate={moment().add(100, "years").toDate()}
                                                                                                    minDate={moment().subtract(100, "years").toDate()}
                                                                                                    className={`form-control custom-wid ${
                                                                                                        this.isFieldLocked("requested_date")
                                                                                                            ? "grayed-out"
                                                                                                            : ""
                                                                                                    }`}
                                                                                                    disabled
                                                                                                    selected={
                                                                                                        this.state.project.requested_date &&
                                                                                                        moment(
                                                                                                            this.state.project.requested_date
                                                                                                        ).isValid()
                                                                                                            ? new Date(
                                                                                                                  this.state.project.requested_date
                                                                                                              )
                                                                                                            : ""
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>{" "}
                                                                            </>
                                                                        )}

                                                                        {!isCR && (
                                                                            <>
                                                                                <div className="col-md-4 p-0">
                                                                                    <div className="outer-rcm">
                                                                                        <div className="txt-rcm w-100">
                                                                                            <div>
                                                                                                <img src="/img/icn1.png" alt="" />
                                                                                            </div>
                                                                                            <div className="txt-secn">
                                                                                                <h4>Surveyor {this.isFieldRequired("surveyor", isCR) ? "*" : ""}</h4>
                                                                                                <div className="sel-recom-react">
                                                                                                    <SelectBox
                                                                                                        isClearable={false}
                                                                                                        value={this.state.project.surveyor_id}
                                                                                                        className={`selectOtr not-draggable build-select-otr ${
                                                                                                            this.isFieldLocked("surveyor")
                                                                                                                ? "grayed-out"
                                                                                                                : ""
                                                                                                        }`}
                                                                                                        showErrorBorder={
                                                                                                            this.isFieldRequired(
                                                                                                                "surveyor",
                                                                                                                isCR
                                                                                                            ) &&
                                                                                                            !this.state.project.surveyor_id
                                                                                                                ?.toString()
                                                                                                                ?.trim()?.length
                                                                                                        }
                                                                                                        isSurveyor
                                                                                                        isRecommendation
                                                                                                        disabled={this.isFieldLocked("surveyor")}
                                                                                                        optionsList={this.getSurveyorOptions()}
                                                                                                        handleChange={value => {
                                                                                                            const surveyorUser = this.getSurveyorOptions().find(
                                                                                                                ({ id }) => id === value
                                                                                                            );
                                                                                                            this.setState({
                                                                                                                project: {
                                                                                                                    ...project,
                                                                                                                    surveyor_id: value,
                                                                                                                    surveyor:
                                                                                                                        surveyorUser?.printed_name ||
                                                                                                                        surveyorUser?.name ||
                                                                                                                        ""
                                                                                                                }
                                                                                                            });
                                                                                                        }}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 p-0">
                                                                                    <div className="outer-rcm">
                                                                                        <div className="txt-rcm w-100">
                                                                                            <div>
                                                                                                <img src="/img/icn-2.png" alt="" />
                                                                                            </div>
                                                                                            <div className="txt-secn">
                                                                                                <h4>
                                                                                                    Inspection Date{" "}
                                                                                                    {this.isFieldRequired("inspection_date", isCR) ? "*" : ""}
                                                                                                </h4>
                                                                                                <DatePicker
                                                                                                    autoComplete={"nope"}
                                                                                                    placeholderText={`Inspection Date`}
                                                                                                    // className="form-control custom-wid"
                                                                                                    className={`${
                                                                                                        showErrorBorder &&
                                                                                                        !this.state.project.inspection_date
                                                                                                            ? "error-border "
                                                                                                            : ""
                                                                                                    }form-control custom-wid ${
                                                                                                        this.isFieldLocked("inspection_date")
                                                                                                            ? "grayed-out"
                                                                                                            : ""
                                                                                                    }`}
                                                                                                    disabled={this.isFieldLocked("inspection_date")}
                                                                                                    selected={
                                                                                                        this.state.project.inspection_date &&
                                                                                                        moment(
                                                                                                            this.state.project.inspection_date
                                                                                                        ).isValid()
                                                                                                            ? new Date(
                                                                                                                  this.state.project.inspection_date
                                                                                                              )
                                                                                                            : ""
                                                                                                    }
                                                                                                    showMonthDropdown
                                                                                                    showYearDropdown
                                                                                                    dropdownMode="scroll"
                                                                                                    maxDate={moment().add(100, "years").toDate()}
                                                                                                    minDate={moment().subtract(100, "years").toDate()}
                                                                                                    onChange={date => {
                                                                                                        this.setState({
                                                                                                            project: {
                                                                                                                ...project,
                                                                                                                inspection_date: new Date(date)
                                                                                                            }
                                                                                                        });
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            }
                                                        />

                                                        {project.energy_band_show === "yes" && !staticLinking?.energy && (
                                                            <EnergyBand
                                                                energyData={project.energy_band}
                                                                bandShown={showBand.energyBand}
                                                                handleBandClick={this.handleBandClick}
                                                                handleChangeData={this.handleChangeBandData}
                                                                bandId="energyBand"
                                                                isFieldLocked={this.isFieldLocked}
                                                                isFieldRequired={this.isFieldRequired}
                                                                isCR={isCR}
                                                                showErrorBorder={showErrorBorder}
                                                            />
                                                        )}
                                                        {project.water_band_show === "yes" && !staticLinking?.water && (
                                                            <WaterBand
                                                                waterData={project.water_band}
                                                                bandShown={showBand.waterBand}
                                                                handleBandClick={this.handleBandClick}
                                                                handleChangeData={this.handleChangeBandData}
                                                                bandId="waterBand"
                                                                isFieldLocked={this.isFieldLocked}
                                                                isFieldRequired={this.isFieldRequired}
                                                                isCR={isCR}
                                                                showErrorBorder={showErrorBorder}
                                                            />
                                                        )}
                                                        <DynamicBand
                                                            bandData={project.dynamic_fields}
                                                            bandShown={showBand}
                                                            handleBandClick={this.handleBandClick}
                                                            handleChangeData={this.handleChangeBandData}
                                                            showErrorBorder={showErrorBorder}
                                                            isFieldLocked={this.isFieldLocked}
                                                            isFieldRequired={this.isFieldRequired}
                                                            isRecommendation
                                                            isCR={isCR}
                                                            staticEntityEnabled={{
                                                                energy: staticLinking?.energy && project?.energy_band_show === "yes",
                                                                water: staticLinking?.water && project?.water_band_show === "yes"
                                                            }}
                                                            isMR={isMR}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 back-set">
                                                    {selectedProject ? (
                                                        <div className="details-img-block details-img-new" style={{ height: "250px" }}>
                                                            {imageUrl ? <img src={imageUrl} alt="" /> : <img src="/img/no-image.png" alt="" />}
                                                        </div>
                                                    ) : query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST || isMR ? (
                                                        <div className="template  pb-0">
                                                            <div className={`heading`}>
                                                                <h3 className={`p-0`}>
                                                                    {isMR ? "Mobile Rec. Voice Note" : crNarrativeLabel}
                                                                </h3>
                                                                <div class="d-flex align-items-center">
                                                                    <button
                                                                        className="btn"
                                                                        onClick={() => this.handleChangeNote(this.state.cr_narrative)}
                                                                    >
                                                                        <i className="fas fa-copy" /> Copy to Rec. Narrative
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={`cnt-temp-area notes-outer-area mb-rec-hght`}
                                                                data-for="recommendation_details"
                                                            >
                                                                <CKEditor
                                                                    editor={Editor}
                                                                    config={{ ...CkeditorConfiguration, toolbar: [] }}
                                                                    id="text-form"
                                                                    data={this.state.cr_narrative || ""}
                                                                    onReady={editor => {
                                                                        editor?.enableReadOnlyMode("my-feature-id");
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    <div className={`template ${isCR || isMR ? "templ-hgt" : ""}`}>
                                                        {/* <h1>{dimensions}</h1> */}
                                                        <div className={`heading ${this.isFieldLocked("note_html") ? "grayed-out" : ""}`}>
                                                            <h3 className={`${project.sub_system_id ? "col-5" : ""} p-0`}>
                                                                {`${isCR ? crNarrativeLabel : "Recommendation Narrative"}${
                                                                    this.isFieldRequired("note_html", isCR) ? " *" : ""
                                                                }`}
                                                            </h3>
                                                            <div class="d-flex align-items-center">
                                                                {this.state.project.sub_system_id && (
                                                                    <button
                                                                        className="btn btn-clear"
                                                                        onClick={() => this.toggleShowReportNoteTemplateModal()}
                                                                    >
                                                                        <i className="fas fa-plus" /> Add Template
                                                                    </button>
                                                                )}
                                                                <div
                                                                    data-tip={
                                                                        this.isFieldLocked("note_html")
                                                                            ? "This field is locked and cannot be edited"
                                                                            : `Click to Expand ${
                                                                                  isCR ? crLabel : "Recommendation"
                                                                              } Narrative`
                                                                    }
                                                                    data-for="recommendation_details"
                                                                    data-effect="solid"
                                                                    data-place="left"
                                                                    class="ml-2 btn-expand-bl"
                                                                    disabled={this.isFieldLocked("note_html")}
                                                                >
                                                                    <img
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => this.openReportNote()}
                                                                        src="/img/expand1.svg"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={`cnt-temp-area notes-outer-area   ${
                                                                showErrorBorder &&
                                                                this.isFieldRequired("note_html", isCR) &&
                                                                !project?.note_html?.trim()?.length
                                                                    ? "error-border"
                                                                    : ""
                                                            } ${this.isFieldLocked("note_html") ? "grayed-out" : ""}`}
                                                            style={{ maxHeight: `${this.state.editorHeight}px` }}
                                                            data-tip={
                                                                this.isFieldLocked("note_html") ? "This field is locked and cannot be edited" : ""
                                                            }
                                                            data-for="recommendation_details"
                                                        >
                                                            <CKEditor
                                                                editor={Editor}
                                                                config={
                                                                    this.isFieldLocked("note_html")
                                                                        ? { ...CkeditorConfiguration, toolbar: [] }
                                                                        : { ...CkeditorConfiguration, extraPlugins: [MyUploadAdapterPlugin] }
                                                                }
                                                                id="text-form"
                                                                data={this.state.project.note_html || ""}
                                                                onReady={editor => {
                                                                    if (this.isFieldLocked("note_html")) {
                                                                        editor?.enableReadOnlyMode("my-feature-id");
                                                                    }
                                                                }}
                                                                // disabled={this.isFieldLocked("note_html")}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    this.handleChangeNote(data);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row bg-grey-bottom-layer"></div>
                            </div>
                        ) : this.state.activeDetail === "Asset Details" ? (
                            <div className="tab-active location-sec recom-sec recommendation-form  addition-add">
                                {project.code && (
                                    <label htmlFor="" className="label-box-top">
                                        <span className="label-txt"> ID: </span> <span className="label-detl">{` ${project?.code}`}</span>{" "}
                                    </label>
                                )}
                                <div className="col-md-12 detail-recom">
                                    <div className="btn-assign">
                                        {/* <button
                                            className={`btn add-btn mr-2 ${
                                                !(project.region_id && project.site_id && project.building_id) ? "cursor-diabled" : ""
                                            }`}
                                            disabled={!(project.region_id && project.site_id && project.building_id)}
                                            onClick={() => {
                                                sessionStorage.setItem("currentFormData", JSON.stringify(project));
                                                sessionStorage.setItem("activeDetail", "Asset Details");
                                                addToBreadCrumpData({
                                                    key: "addAsset",
                                                    name: `Add Asset`,
                                                    path: `/assets/add`
                                                });
                                                history.push({
                                                    pathname: "/assets/add",
                                                    search: "?isRecomAsset=true"
                                                });
                                            }}
                                        >
                                            <i className="fas fa-plus" /> Add New Asset & Assign
                                        </button> */}
                                        <button
                                            className={`btn add-btn ${
                                                !(project.region_id && project.site_id && project.building_id) ? "cursor-diabled" : ""
                                            }`}
                                            disabled={!(project.region_id && project.site_id && project.building_id)}
                                            onClick={() => this.setState({ showAssetModal: true })}
                                        >
                                            <i className="fas fa-plus" /> Assign Asset
                                        </button>
                                    </div>
                                    <AssetForm
                                        assetFormData={assetFormData}
                                        clientList={clients}
                                        regionList={regionList}
                                        additionList={this.props.recommendationsReducer.getAdditionByBuilding.additions}
                                        buildingList={this.props.userReducer.getAllBuildingsDropdownResponse.buildings}
                                        floorList={this.props.recommendationsReducer.getFloorByBuilding.floors}
                                        tradeList={this.props.recommendationsReducer.getTradeByProject.trades}
                                        systemList={this.state.systemArray}
                                        subSystemList={this.state.subSystemArray}
                                        handleChangeAssetForm={this.handleChangeAssetForm}
                                        setAssetFormData={this.setAssetFormData}
                                        showErrorBorder={this.state.showErrorBorder}
                                        isFieldLocked={this.isFieldLocked}
                                        isFieldRequired={field_name => this.isFieldRequired(field_name, isCR)}
                                    />
                                    {/* <div className="add-btn-wrapper">
                                        <span className="errorMessage">{this.state.showErrorBorder ? this.state.errorMessage : ""}</span>
                                        <button className="button btn-clear" onClick={() => this.confirmCancel()}>
                                            Cancel
                                        </button>

                                        {!this.state.loading ? (
                                            <button
                                                title={
                                                    this.state.locked === true
                                                        ? "You cannot update this item as this recommendation is locked!!!"
                                                        : ""
                                                }
                                                className={`button btn-save ml-2 ${this.state.locked === true ? "cursor-notallowed" : ""}`}
                                                disabled={this.state.lock === true ? true : false}
                                                onClick={() => this.addProject()}
                                            >
                                                {this.state.selectedProject ? "Update" : "Save"}
                                            </button>
                                        ) : (
                                            <button className="button btn-save ml-2">
                                                <div className="button-loader d-flex justify-content-center align-items-center">
                                                    <div className="spinner-border text-white" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                            </button>
                                        )}
                                    </div> */}
                                </div>
                            </div>
                        ) : this.state.activeDetail === "Checklists" && miscellaneous?.checklist_survey ? (
                            <div
                                className={`tab-active location-sec recom-sec main-dtl-add recommendation-form add-recommendation building-type edit-ck-recom`}
                            >
                                <RecommendationChecklist data={this.state.checkListData} setData={this.setCheckListData} />
                            </div>
                        ) : null}
                    </div>
                </div>

                {this.renderConfirmationModal()}
                {this.renderReportNoteTemplateModal()}
                {this.renderAssetModal()}
                {this.renderRecommendationTemplateModal()}
                {this.renderYearRemoveConfirmationModal()}
                {this.renderSiteCspYearChangeConfirmationModal()}
                {this.renderSubsystemServiceLifeConfirmationModal()}
                {this.renderCapitalTypeUpdateConfirmationModal()}
                {this.renderVoiceNoteModal()}
                {this.renderVideoNoteModal()}
                {this.renderImageModal()}
                {this?.renderSiteBuildingModal()}
                {this.renderSaveConfirmationModal()}
                {this.renderAssetRenameModal()}
                {this.renderAssetTagReuseModal()}
                {this.renderAssetRenameConfirmModal()}
                {this.renderImagePopup()}
                {this.renderQaValidationModal()}
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = state => {
    const {
        projectReducer,
        buildingReducer,
        recommendationsReducer,
        commonReducer,
        userReducer,
        assetReducer,
        dashboardReducer,
        mobileRecommendationsReducer,
        assetSurveyProjectReducer,
        recommendationStatusReducer
    } = state;
    return {
        projectReducer,
        buildingReducer,
        recommendationsReducer,
        commonReducer,
        userReducer,
        assetReducer,
        dashboardReducer,
        mobileRecommendationsReducer,
        assetSurveyProjectReducer,
        recommendationStatusReducer
    };
};
const { setFormDirty } = commonActions;

export default withRouter(
    connect(mapStateToProps, {
        ...recommendationsActions,
        ...buildingActions,
        ...userActions,
        ...projectActions,
        ...assetActions,
        ...dashboardActions,
        ...MobileAction,
        ...statusAction,
        setFormDirty,
        getAssetVoiceNotes: surveyAssetActions.getAssetVoiceNotes,
        getSurveyRecommendationImagesById: surveyAssetActions?.getSurveyRecommendationImagesById
    })(RecommendationForm)
);

const assetFormInitialState = {
    code: "",
    asset_name: "",
    asset_tag: "",
    asset_note: "",
    client_asset_condition_id: "",
    installed_year: "",
    service_life: "",
    usefull_life_remaining: "",
    crv: "",
    manufacturer_id: "",
    year_manufactured: "",
    model_number: "",
    serial_number: "",
    capacity: "",
    criticality: "",
    area_served: "",

    trade_id: "",
    system_id: "",
    sub_system_id: "",

    client_id: "",
    region_id: "",
    site_id: "",
    building_id: "",
    addition_id: "",
    floor_id: "",
    room_number: "",
    room_name: "",
    location: "",
    architectural_room_number: "",
    additional_room_description: "",

    uniformat_level_1_id: "",
    uniformat_level_2_id: "",
    uniformat_level_3_id: "",
    uniformat_level_4_id: "",
    uniformat_level_5_id: "",
    uniformat_version: null,

    asset_type_id: "",
    asset_description: "",
    asset_barcode: "",
    asset_client_id: "",
    asset_cmms_id: "",

    warranty_start: "",
    warranty_end: "",
    install_date: "",
    startup_date: "",
    upstream_asset_barcode_number: "",
    linked_asset_barcode_number: "",
    source_panel_barcode_number: "",
    source_panel: "",
    asset_status_id: "",
    notes: "",

    main_category_id: "",
    sub_category_1_id: "",
    sub_category_2_id: "",
    sub_category_3_id: "",
    guid: "",
    source_panel_name: "",
    skysite_hyperlink: "",

    quantity: "",
    rtls_tag: "",
    latitude: "",
    longitude: "",
    current_age: "",
    age: "",
    new_asset: "",
    source: ASSET_SOURCES.RECOMMENDATION,
    latest_source: ASSET_SOURCES.RECOMMENDATION,
    parent_global_id: "",
    survey_global_id: "",
    survey_id: "",
    survey_property_note: "",
    capacity_status: "",
    installed_year_status: "",
    name_plate_status: "",
    qa_notes: "",
    additional_qa_notes: "",
    surveyor: "",
    editor: "",
    survey_date_created: "",
    survey_date_edited: "",
    description: "",
    uniformat_level_6_id: "",
    uniformat_level_6_description: "",
    subcategory2_description: "",
    capacity_unit: "",
    refrigerant: "",
    asset_additional: {},
    auxiliary: {}
};
